/**
 * Geojson polygon object of our bounding area definitions
 */
const COUNTRY_AND_STATE_BOUNDS = {
  AUSTRALIA: {
    type: 'Feature',
    properties: {},
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [111, -45],
          [157, -45],
          [157, -8],
          [111, -8],
          [111, -45],
        ],
      ],
    },
  },
  SOUTHAUSTRALIA: {
    type: 'Feature',
    properties: {},
    geometry: {
      coordinates: [
        [
          [128.9584137123179, -25.955069402134214],
          [128.9584137123179, -39.70046005680013],
          [140.99112925998054, -39.70046005680013],
          [140.99112925998054, -25.955069402134214],
          [128.9584137123179, -25.955069402134214],
        ],
      ],
      type: 'Polygon',
    },
  },
  NEWSOUTHWALES: {
    type: 'Feature',
    properties: {},
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [140.93, -34.85],
          [150.35, -38.09],
          [154.885, -27.88],
          [140.98, -28.98],
          [140.93, -34.85],
        ],
      ],
    },
  },
  VICTORIA: {
    type: 'Feature',
    properties: {},
    geometry: {
      coordinates: [
        [
          [140.9343803502369, -33.34071186189187],
          [140.93433393600947, -39.68525421456566],
          [151.4058790021645, -39.57754166478358],
          [151.22278130794894, -37.16768644472243],
          [140.9343803502369, -33.34071186189187],
        ],
      ],
      type: 'Polygon',
    },
  },
  NORTHEASTNSW: {
    // used for Northern NSW Helicopter Service
    type: 'Feature',
    properties: {},
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [146.5, -28.97],
          [146.5, -33.57],
          [156.5, -33.57],
          [156.5, -28.15],
          [153.56, -28.15],
          [146.5, -28.97],
        ],
      ],
    },
  },
  TASMANIA: {
    type: 'Feature',
    properties: {},
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [143.1, -44.09],
          [149.82, -44.09],
          [149.82, -39.36],
          [143.1, -39.36],
          [143.1, -44.09],
        ],
      ],
    },
  },
  ACT: {
    type: 'Feature',
    properties: {},
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [148.755972, -35.929623],
          [149.403859, -35.929623],
          [149.403859, -35.119141],
          [148.755972, -35.119141],
          [148.755972, -35.929623],
        ],
      ],
    },
  },
  NOTHERNTERRITORY: {
    type: 'Feature',
    properties: {},
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [128.996658, -25.992767],
          [138.010254, -25.992767],
          [138.010254, -8.961045],
          [128.996658, -8.961045],
          [128.996658, -25.992767],
        ],
      ],
    },
  },
  LOLO_TRIAL: {
    type: 'Feature',
    properties: { layer: null, area: null, perimeter: null },
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [116.824797104543634, -34.990306379422925],
          [116.843245425436066, -35.038182983857553],
          [116.968898583003238, -34.97317978042247],
          [116.968931052126436, -34.97316332103037],
          [116.970903328326017, -34.972171885024409],
          [116.970936135594229, -34.972155895078458],
          [116.970969274712274, -34.972140380873839],
          [116.971002732190414, -34.972125346007886],
          [116.971036500833861, -34.972110795876461],
          [116.971070568052369, -34.972096734076956],
          [116.971104924852511, -34.972083165105914],
          [116.971139560442452, -34.972070092560671],
          [116.971174463130978, -34.972057522736463],
          [116.971209624824382, -34.972045457431875],
          [116.971245032032698, -34.972033899344922],
          [116.971280675762614, -34.972022853871579],
          [116.971316544323145, -34.972012323709748],
          [116.971352627821602, -34.972002311557389],
          [116.971388913667511, -34.971992822810478],
          [116.971425391968296, -34.971983856569693],
          [116.972767481733968, -34.971668553360985],
          [116.97280414079853, -34.971660115022246],
          [116.97284096983492, -34.971652206384192],
          [116.972877957152036, -34.971644831044046],
          [116.972915092857306, -34.97163798900192],
          [116.97295236436014, -34.971631684754414],
          [116.972989759969551, -34.97162591830147],
          [116.973027269792738, -34.971620692341048],
          [116.973064881239338, -34.971616007772525],
          [116.973102582618139, -34.971611867293802],
          [116.973140363137304, -34.971608270904937],
          [116.973178212004996, -34.97160522040457],
          [116.973216115731248, -34.971602716691962],
          [116.9732540644236, -34.971600759767227],
          [116.973292046390839, -34.971599351428893],
          [116.973330049042602, -34.971598490777694],
          [116.973368061586825, -34.971598179612272],
          [116.973371203818033, -34.971598178712952],
          [116.973425977926581, -34.971598190404109],
          [116.973460847340334, -34.971598428724462],
          [116.973498844596065, -34.971599213832633],
          [116.973536816670844, -34.971600548426522],
          [116.973574751873343, -34.971602430707549],
          [116.97361263941184, -34.971604859776392],
          [116.973650467595121, -34.971607837431691],
          [116.973688223832482, -34.971611358277528],
          [116.973725898231692, -34.971615425911125],
          [116.973763477302668, -34.97162003583594],
          [116.973800951153066, -34.971625188051917],
          [116.973838308990821, -34.971630881659792],
          [116.976001804439761, -34.97199202780979],
          [116.97603903367451, -34.971998258312908],
          [116.976076122615041, -34.972005026610645],
          [116.976113059570139, -34.972012330004986],
          [116.97614983644587, -34.972020164898652],
          [116.97735481107577, -34.972290920189778],
          [116.977391412583643, -34.972299285683448],
          [116.977427832428589, -34.972308178179844],
          [116.977464054422626, -34.972317596779646],
          [116.977500068673294, -34.972327536986199],
          [116.977535866187281, -34.972337996101601],
          [116.989914597080997, -34.9760819151482],
          [116.989950168865221, -34.976092887776531],
          [116.989985501429828, -34.976104372119039],
          [116.990020583982869, -34.976116366377141],
          [116.990055405732505, -34.976128865154976],
          [116.990089955886788, -34.976141865754471],
          [116.990124223654107, -34.976155364578347],
          [116.990945850570597, -34.976493585210733],
          [116.990979827856791, -34.976507576863128],
          [117.154048599263547, -35.04484456622373],
          [117.158645415553565, -35.032039872342182],
          [117.158863538921196, -35.031453457710882],
          [117.15889423098406, -35.031377077390175],
          [117.158928741568275, -35.031302344627477],
          [117.158966980741639, -35.031229450079024],
          [117.159431279130331, -35.030394732630782],
          [117.159462595322566, -35.030340798489021],
          [117.159495857647812, -35.030288043358496],
          [117.160206320265502, -35.029205020395352],
          [117.160260177065538, -35.029127545599692],
          [117.160724849572262, -35.028495715205054],
          [117.160782819871315, -35.028421273822687],
          [117.160844390156512, -35.028349783115971],
          [117.160909411140437, -35.028281414855371],
          [117.160977724542363, -35.028216337214133],
          [117.161049164887118, -35.028154707573663],
          [117.16126805897386, -35.027974068848152],
          [117.161359804211656, -35.027902705845179],
          [117.162314419275049, -35.027204867010937],
          [117.162406442403494, -35.02714052591449],
          [117.163376286586413, -35.026469337589788],
          [117.163405663840422, -35.026449271016986],
          [117.17028186041955, -35.021854791165651],
          [117.170378293823319, -35.02179217496888],
          [117.170477804706934, -35.021734574291145],
          [117.170580133166709, -35.021682141117878],
          [117.171237167960953, -35.021365604039374],
          [117.171336823635556, -35.021320467065834],
          [117.172729916652429, -35.020744776849938],
          [117.173277511148285, -35.0205185586845],
          [117.173373007458395, -35.020481458052814],
          [117.177242165193775, -35.019005341423338],
          [117.177276789092616, -35.018992220314658],
          [117.177311681888682, -35.018979601027695],
          [117.177345505390804, -35.018967932324188],
          [117.18030417779562, -35.017971203807974],
          [117.180315716996802, -35.017967355608903],
          [117.180726458958929, -35.017831480638279],
          [117.180819003694182, -35.017802861512791],
          [117.182255215605778, -35.017383808016291],
          [117.258941351764207, -34.996893155893211],
          [117.257852287834382, -34.893432082560217],
          [117.689832833192767, -34.894921670647662],
          [117.690422711189683, -35.111406895512694],
          [118.356827492095135, -35.543988594997643],
          [118.340983158945733, -35.553358887702473],
          [118.339428023384585, -35.554247499722294],
          [118.337997446624968, -35.555056678223082],
          [118.334170039016158, -35.557199596284306],
          [118.332730064341035, -35.557997604305967],
          [118.329840824094845, -35.559582410299925],
          [118.328391586402631, -35.560369193883162],
          [118.324514727772566, -35.562452219794068],
          [118.323056354767004, -35.563227689006624],
          [118.320130582260617, -35.564767275289455],
          [118.318663208840121, -35.565531377071352],
          [118.314738302130991, -35.567553756300754],
          [118.31326204160996, -35.568306412410948],
          [118.310300759372581, -35.569800235792229],
          [118.308815764635938, -35.570541388674087],
          [118.304844228078764, -35.572502382878611],
          [118.303418343981434, -35.573199209076222],
          [118.207754395748793, -35.619771257737284],
          [118.206489025348333, -35.620387106279907],
          [118.203952199734317, -35.621610483736788],
          [118.202538806320945, -35.622285143444572],
          [118.202252061083868, -35.622420619116212],
          [118.202112813655503, -35.622486337974067],
          [118.198331988230734, -35.624268839235526],
          [118.196910518006007, -35.624932083848535],
          [118.194060310135228, -35.626248183207053],
          [118.192631597670129, -35.626901023563335],
          [118.1888121103907, -35.628628006976896],
          [118.187376236624118, -35.629270388217776],
          [118.184497450996673, -35.630544654712025],
          [118.183054566115402, -35.631176529173445],
          [118.179197637361085, -35.632847438058775],
          [118.177747853780488, -35.633468733794984],
          [118.174841481449221, -35.634700728555742],
          [118.173384916980353, -35.635311416788397],
          [118.169491784218508, -35.636925715149573],
          [118.168028526994931, -35.637525738322097],
          [118.165095441201743, -35.638715089929406],
          [118.163625636913707, -35.639304406672977],
          [118.159697548403187, -35.640861572903248],
          [118.158221329250978, -35.641440113070701],
          [118.155262551625469, -35.642586405138445],
          [118.153780021031253, -35.643154146246786],
          [118.149818234923714, -35.644653681222394],
          [118.148329461235676, -35.645210577406203],
          [118.145345812859091, -35.646313489775707],
          [118.143850966049285, -35.646859496068828],
          [118.139856755784763, -35.648300914155811],
          [118.138355975248146, -35.64883596220983],
          [118.135348552393793, -35.649895089286872],
          [118.13384193795514, -35.650419159316698],
          [118.129816585067374, -35.651801998263579],
          [118.128304209571638, -35.652315048001014],
          [118.125273839616057, -35.653330096606624],
          [118.123755873035179, -35.653832085582223],
          [118.11970066985009, -35.655155899325223],
          [118.118228921227796, -35.655630324979484],
          [118.115280401269615, -35.656568789118296],
          [118.113803657812582, -35.657032816811011],
          [118.109553568842216, -35.658351076341035],
          [118.108452394862184, -35.658689314959872],
          [118.106247364224487, -35.659360020348629],
          [118.105033519581298, -35.659725253017996],
          [118.104646895637757, -35.659839923773404],
          [118.103653122293849, -35.660133640555046],
          [118.103155987858599, -35.66027990988988],
          [118.09887636695089, -35.661533309414665],
          [118.097268842283256, -35.661997219296211],
          [118.094048512129234, -35.662912810977389],
          [118.092435737219603, -35.6633644846832],
          [118.088128078148316, -35.664552588031484],
          [118.086510148324692, -35.664991980595403],
          [118.083269290245653, -35.66585846029966],
          [118.081646390768356, -35.6662855384468],
          [118.077312193602893, -35.667407930131844],
          [118.075684471960926, -35.667822638104212],
          [118.072424309934036, -35.668639674881035],
          [118.070791901025473, -35.669041995591556],
          [118.066432679324748, -35.670098284408255],
          [118.064795703658888, -35.670488170192868],
          [118.061517323165958, -35.671255494245599],
          [118.059875947117348, -35.671632924419896],
          [118.055493218037668, -35.672622738948178],
          [118.053847580101774, -35.672987663150082],
          [118.050552156556819, -35.673704996588299],
          [118.048902404222645, -35.674057400428637],
          [118.044497700208808, -35.67498039622825],
          [118.042843953086049, -35.67532023474098],
          [118.039532601648261, -35.675987335646994],
          [118.037875027010955, -35.676314592644303],
          [118.033449884104925, -35.677170447757931],
          [118.03178863573703, -35.67748507557576],
          [118.028462573189245, -35.678101700233242],
          [118.026797786888437, -35.678403690777657],
          [118.022353749226227, -35.679192105731033],
          [118.020685552696136, -35.679481419431909],
          [118.0173458843052, -35.680047360996866],
          [118.015674441222586, -35.680323985263669],
          [118.011213061034027, -35.681044684864275],
          [118.00958760838148, -35.681301030318252],
          [118.006333882802551, -35.681801723370768],
          [118.004705642251679, -35.682046067372085],
          [117.99938751572131, -35.682822998882273],
          [117.989012674895093, -35.684218197211976],
          [117.987327385850222, -35.6844317286413],
          [117.983954400275366, -35.684845983355387],
          [117.982266733423103, -35.685046700344913],
          [117.977763291043061, -35.685564817762099],
          [117.97607341815376, -35.685752684338865],
          [117.972691558968336, -35.686115571576352],
          [117.97099960414846, -35.686290588639736],
          [117.945871825824156, -35.688826639038098],
          [117.94274325080039, -35.689132916650749],
          [117.941178166938926, -35.68928056464631],
          [117.937002576907503, -35.689659622593467],
          [117.935435995674766, -35.68979626468581],
          [117.932301414978383, -35.690058552859909],
          [117.930733443393706, -35.690184195344273],
          [117.926550426760855, -35.690504547346961],
          [117.924981179038241, -35.690619165941712],
          [117.92184149828654, -35.690837388234854],
          [117.920271093136535, -35.69094098833591],
          [117.91608189816111, -35.691202540864538],
          [117.914510447099474, -35.691295101787489],
          [117.9113665916949, -35.691469193448484],
          [117.909794217029571, -35.691550720589248],
          [117.905600092870031, -35.691753395402827],
          [117.904026898922325, -35.691823870774954],
          [117.900879794267098, -35.691953778743823],
          [117.899305911438773, -35.692013211340566],
          [117.895108109052103, -35.692156946385921],
          [117.893533685731086, -35.69220531372423],
          [117.89038435705254, -35.692290999330112],
          [117.888809478674602, -35.692328314899783],
          [117.884609249017672, -35.692413068808037],
          [117.883034006414277, -35.692439317320577],
          [117.879883269397396, -35.692480756281839],
          [117.878307804661517, -35.692495946730503],
          [117.874106402288703, -35.692521693421384],
          [117.873419295963799, -35.692524843746526],
          [117.87204504374381, -35.692529042681144],
          [117.871357913137217, -35.692530091290621],
          [117.870615974247926, -35.692528869111982],
          [117.86913210636169, -35.692523974102073],
          [117.868390193552614, -35.692520301270861],
          [117.863883553183541, -35.692490480651145],
          [117.862193639824682, -35.692472930381371],
          [117.858814054125332, -35.69242510443496],
          [117.85712441326109, -35.692394829657644],
          [117.852619225297076, -35.692297119216619],
          [117.850930001718211, -35.69225411003913],
          [117.847552086959354, -35.692155376169637],
          [117.845863426356118, -35.692099650578371],
          [117.841361235832437, -35.691934081792397],
          [117.839673304579378, -35.691865631693531],
          [117.83629826495303, -35.691716024974539],
          [117.834611187156611, -35.691634871052429],
          [117.830113541806554, -35.691401500578763],
          [117.828427412794895, -35.691307630242875],
          [117.825056266333718, -35.691107194741221],
          [117.823371278561694, -35.691000633172621],
          [117.818879720722634, -35.690699541050947],
          [117.817196077437075, -35.690580287350315],
          [117.813830184815288, -35.690329104904208],
          [117.812147969653097, -35.690197180655332],
          [117.807664040762916, -35.689828472106285],
          [117.8059833589449, -35.689683869215173],
          [117.802623679739099, -35.689382012669682],
          [117.800944714726825, -35.689224761713319],
          [117.796469954424879, -35.688788561742683],
          [117.794792868995728, -35.688618663620389],
          [117.791440673048669, -35.688266245390878],
          [117.789765592208369, -35.68808372888094],
          [117.785301533838833, -35.687580185876811],
          [117.783628620364652, -35.687385051878607],
          [117.780285051613873, -35.686982194272787],
          [117.778614428713013, -35.686774473363187],
          [117.774162605619836, -35.686203762693424],
          [117.772494377613498, -35.685983452174526],
          [117.76916047027953, -35.685530276600957],
          [117.767494819730246, -35.685297416042886],
          [117.76301931658827, -35.684654344122634],
          [117.762823965853386, -35.684626208832412],
          [117.761169358978805, -35.684381419666749],
          [117.757996235138194, -35.683899687020869],
          [117.75641099567099, -35.683653118996176],
          [117.751988215283973, -35.682948680936818],
          [117.75041993343325, -35.68269307832287],
          [117.747286150435571, -35.682170700817153],
          [117.745720678066846, -35.681903933119997],
          [117.741304203726031, -35.681134867080402],
          [117.739695705092799, -35.6808485858935],
          [117.736481913009925, -35.680264230709611],
          [117.734876651036643, -35.679966163007975],
          [117.730502216404261, -35.679136989880135],
          [117.152595211200151, -35.569171955920979],
          [116.820682342716054, -35.569540874911411],
          [116.819466157137526, -35.569708661425523],
          [116.817032390232725, -35.570037530007937],
          [116.815814838583947, -35.5701986102776],
          [116.81143138015409, -35.57076610677035],
          [116.809786327676989, -35.570972806949442],
          [116.806493949236483, -35.571373966635235],
          [116.804846651152047, -35.57156842524256],
          [116.80045119486681, -35.572070596780577],
          [116.798801861616653, -35.572252773346747],
          [116.795501194124881, -35.572604856129146],
          [116.793849888661498, -35.572774759647416],
          [116.789443903113693, -35.573211441654678],
          [116.787790750442809, -35.573369046044604],
          [116.784482716604202, -35.57367195659549],
          [116.782827866912612, -35.57381726095781],
          [116.778412820695166, -35.57418830684486],
          [116.776756436760252, -35.574321283300549],
          [116.773442215585874, -35.574574913701269],
          [116.771784410722034, -35.574695567646302],
          [116.767361779622547, -35.575000854205996],
          [116.765702645560737, -35.575109163157322],
          [116.762383203821855, -35.575313440562809],
          [116.760722925822392, -35.57540940811765],
          [116.756294183829596, -35.575648831927992],
          [116.754632943555521, -35.575732432006077],
          [116.751309564584744, -35.575887276376648],
          [116.749647458263667, -35.575958519769813],
          [116.74521408476221, -35.576132002589816],
          [116.743551196930298, -35.57619087131161],
          [116.740224799834664, -35.576296240379122],
          [116.738561321148154, -35.57634273982552],
          [116.734124794623654, -35.576450223199174],
          [116.732460899550915, -35.576484335383725],
          [116.729132764065866, -35.576540186880095],
          [116.727468555129803, -35.576561925292594],
          [116.723030360362941, -35.576603374146373],
          [116.721985379621628, -35.576610682936632],
          [116.719895354287246, -35.576620422594374],
          [116.718850324083292, -35.576622854361176],
          [116.718230907030829, -35.576622000005273],
          [116.716992081019839, -35.57661857808489],
          [116.71637268555105, -35.576616009621091],
          [116.711934301027213, -35.576591409565879],
          [116.710269998561671, -35.576575988890738],
          [116.70694160676976, -35.576532771969823],
          [116.705277546221851, -35.576504976623312],
          [116.700840454923082, -35.576414335752929],
          [116.699176730721661, -35.576374152245307],
          [116.695849772449151, -35.576281412357275],
          [116.694186568055784, -35.576228857775504],
          [116.689752250266224, -35.576072205767616],
          [116.688089741948147, -35.576007272017932],
          [116.684765492433598, -35.575865044236366],
          [116.683103780914848, -35.575787751103803],
          [116.678673717817901, -35.575565141018387],
          [116.677170624225027, -35.57548452399152],
          [116.674165273408676, -35.575313175262806],
          [116.672663046762295, -35.575222445359543],
          [116.668374734806207, -35.574948905767371],
          [116.666767166071963, -35.574840526668936],
          [116.663553237292149, -35.574612186103479],
          [116.6619469069243, -35.574492226435041],
          [116.657665213079213, -35.574156888129835],
          [116.656060311734109, -35.57402534699213],
          [116.652851968643517, -35.573750703931807],
          [116.651248558374277, -35.573607603807829],
          [116.646974826227279, -35.573210572909545],
          [116.645372996066953, -35.573055904806097],
          [116.642171047156125, -35.572735030297395],
          [116.640570958083345, -35.572568824791404],
          [116.636306525825603, -35.572110223607865],
          [116.634834244804665, -35.571946911220948],
          [116.631891334817283, -35.571610512614996],
          [116.630420737327199, -35.571437431791992],
          [116.132246452012168, -35.512308437184572],
          [116.130577225758429, -35.51210964924087],
          [116.127241072817355, -35.511699477448872],
          [116.125574175807628, -35.511488098097232],
          [116.121132402638295, -35.510907636078514],
          [116.119627083223349, -35.510705634857118],
          [116.116618538914508, -35.51029136035794],
          [116.115173426412525, -35.510087487647411],
          [116.114956449680449, -35.510056036556819],
          [116.114638714704938, -35.510009818598235],
          [116.114479876445216, -35.509986654760269],
          [116.110052059854752, -35.509339204040998],
          [116.1083930561947, -35.509090143095591],
          [116.105077915913171, -35.508579506239187],
          [116.103421810768054, -35.508317934824788],
          [116.099009468812028, -35.507603719336146],
          [116.09735638988559, -35.507329641050035],
          [116.094053383257119, -35.50676901357906],
          [116.092403485232694, -35.506482469790114],
          [116.088008133268772, -35.505701735047012],
          [116.086361542950954, -35.505402732050413],
          [116.083071795926685, -35.504792304621105],
          [116.081428669797333, -35.504480885584371],
          [116.077051814189986, -35.503633897786131],
          [116.075412308731075, -35.503310077997639],
          [116.072137015610792, -35.502650070943957],
          [116.070501256727653, -35.502313889974005],
          [116.066144398445317, -35.501400939601638],
          [116.06451256330422, -35.50105241903384],
          [116.06125288781061, -35.500343068877498],
          [116.059625078034969, -35.499982245584135],
          [116.055289709952262, -35.499003649198983],
          [116.053666039755967, -35.498630533072628],
          [116.05042297384125, -35.497872055650816],
          [116.048803606900947, -35.497486702449294],
          [116.044491215597191, -35.496442791001982],
          [116.042876311992245, -35.496045218711856],
          [116.039651053553371, -35.495237893713806],
          [116.038040730195576, -35.49482814999908],
          [116.033752790558879, -35.493719285016937],
          [116.032147204829698, -35.493297390562077],
          [116.02894085733476, -35.492441496777587],
          [116.027340126145987, -35.492007502843933],
          [116.023078111265932, -35.490834064740227],
          [116.021482384804244, -35.490387993810828],
          [116.018296031936416, -35.489483819922327],
          [116.016705434308392, -35.489025724157784],
          [116.012470801086693, -35.487788114929515],
          [116.011858146935992, -35.487608043676232],
          [116.010633603058409, -35.487246108820841],
          [116.010130794800375, -35.487096814166591],
          [116.009153127414947, -35.486802624341578],
          [116.007417563569788, -35.486275776306002],
          [116.006550617117341, -35.486010559040039],
          [116.002289220970852, -35.484696772737834],
          [116.000694051189612, -35.484197994341912],
          [115.997509482576675, -35.483188255333687],
          [115.995920113422585, -35.482677303714524],
          [115.991689676437431, -35.481298564776921],
          [115.990106250003464, -35.480775469612183],
          [115.986945446874984, -35.479717190595807],
          [115.985368098059325, -35.479182015737365],
          [115.981170108613696, -35.477738807999572],
          [115.979598992999172, -35.477191585822993],
          [115.976463084903457, -35.476085147211734],
          [115.974898322099989, -35.475525938870931],
          [115.970734249685961, -35.474018768651206],
          [115.969175997074672, -35.47344761281704],
          [115.966066088379307, -35.472293404017364],
          [115.964514461073577, -35.471710361843691],
          [115.96038576708952, -35.470139760641416],
          [115.967117081390455, -35.461433197639714],
          [112.760354373493385, -35.499012448122883],
          [112.746888805252823, -31.971033569095813],
          [112.773413653037039, -31.971033569095813],
          [112.679560964050012, -28.860487305526146],
          [113.479427668941113, -28.860487305526146],
          [113.307395915283649, -28.29156704736242],
          [111.777367891932386, -28.29156704736242],
          [111.683108914248464, -21.020160197459305],
          [114.364840077803137, -21.045946074031946],
          [114.900153995210758, -20.054433168755679],
          [114.900822204081464, -20.053204713726529],
          [114.902619962341419, -20.049936518055802],
          [114.903300051256451, -20.048713860056523],
          [114.904672051574039, -20.046274460697759],
          [114.905363951285381, -20.045057741821267],
          [114.907224669283096, -20.041821211279853],
          [114.907928304247889, -20.040610543042078],
          [114.909347275256664, -20.038195327352412],
          [114.910062599609319, -20.036990800584931],
          [114.91198564512149, -20.033787024251694],
          [114.912351155681336, -20.033181340746239],
          [114.913085147261768, -20.031971555642713],
          [114.913387391415085, -20.031475568742451],
          [114.913817940045988, -20.03077646006551],
          [114.914549408128778, -20.029596019840426],
          [114.91491655005882, -20.029006595178203],
          [114.916901269278242, -20.025836642347144],
          [114.917651294871462, -20.02465111735512],
          [114.919162804320081, -20.022286588355314],
          [114.919924271987611, -20.021107606830526],
          [114.92196999222142, -20.017972541399615],
          [114.922602930580865, -20.017010649022211],
          [114.923876438047273, -20.01509136537419],
          [114.924516991865744, -20.014133994787983],
          [114.926609137801506, -20.011032864375125],
          [114.927399304634264, -20.009873333387588],
          [114.928990822268702, -20.007561128743077],
          [114.92979215778189, -20.006408476669833],
          [114.931943851427718, -20.003344028703907],
          [114.932756272883694, -20.002198360765703],
          [114.934392163967232, -19.999914075574111],
          [114.935215618306188, -19.998775479005133],
          [114.937426131211055, -19.995748735115967],
          [114.93826053119858, -19.994617315136963],
          [114.939940238151507, -19.992361714721312],
          [114.94078553072768, -19.991237555868452],
          [114.943054115555015, -19.988249525994775],
          [114.943910253055833, -19.98713267773087],
          [114.945633291143508, -19.98490640870375],
          [114.94650017824074, -19.983797010423643],
          [114.94882607326474, -19.980848692812856],
          [114.94970359124784, -19.979746876716945],
          [114.951469243710676, -19.97755085728619],
          [114.952357363801411, -19.976456672837116],
          [114.954739783014588, -19.973549053146257],
          [114.955638453951565, -19.972462549806778],
          [114.957446264833266, -19.97029733935068],
          [114.958355388590348, -19.969218651119832],
          [114.960793530696947, -19.966352697019317],
          [114.961713002053443, -19.965281932714959],
          [114.96356225999034, -19.963148378394919],
          [114.964492030382985, -19.962085607264896],
          [114.966985070704482, -19.959262278331437],
          [114.967186116845824, -19.95903504573073],
          [114.967588695661789, -19.958580935761518],
          [114.967715176314414, -19.958438443579269],
          [114.968530870403356, -19.957527981631017],
          [114.970018409322165, -19.95588086071308],
          [114.970765289986161, -19.955059835443024],
          [114.973312393951915, -19.952280068770108],
          [114.974272580315414, -19.951241788877383],
          [114.976202949006961, -19.949173555015534],
          [114.977173115147252, -19.948143619032749],
          [114.979773423904476, -19.945408347217381],
          [114.980753472694687, -19.944386845976112],
          [114.98272340436165, -19.942352342086849],
          [114.983713268352744, -19.941339357425363],
          [114.986365907760501, -19.938649489682177],
          [114.987365496120788, -19.93764510343874],
          [114.989374338754828, -19.935644993221842],
          [114.990383575941337, -19.934649289932736],
          [114.99308765567082, -19.932005723785096],
          [114.994106466140579, -19.931018768201568],
          [114.99615358302151, -19.92905368567898],
          [114.99718187234555, -19.928075577625748],
          [114.999936484980822, -19.925479198006542],
          [115.01382163875769, -19.912414415692695],
          [115.014845013286845, -19.91146012618384],
          [115.01690081042409, -19.909560286777776],
          [115.0179332150459, -19.908614754867017],
          [115.020698277803376, -19.906105049208634],
          [115.021739645068578, -19.905168326157309],
          [115.023831260404449, -19.903303772550998],
          [115.024881487790481, -19.902375960881841],
          [115.027693789236992, -19.899913770903765],
          [115.028752774221175, -19.898994950656402],
          [115.030879454123578, -19.897166353744183],
          [115.03194712925665, -19.896256594166459],
          [115.034805750285159, -19.893842715768699],
          [115.035882018440475, -19.892942087906988],
          [115.038043088417908, -19.891150022355589],
          [115.039127871354253, -19.890258599954393],
          [115.042031882965034, -19.887893817345741],
          [115.042870983709008, -19.887215279761278],
          [115.044554137763271, -19.885863698550793],
          [115.045323399855079, -19.885249913052974],
          [115.045653753218176, -19.884988730145722],
          [115.046165339758659, -19.884585368020282],
          [115.046447916638158, -19.884363090684019],
          [115.048886551573105, -19.882449295598462],
          [115.049285828977872, -19.882136979038307],
          [115.049797418216372, -19.881738133308147],
          [115.051109930179223, -19.880725897781929],
          [115.053346139412838, -19.879019890155746],
          [115.054043061837888, -19.87849123897945],
          [115.059159674579405, -19.874628756911534],
          [115.061337162580003, -19.873012072648976],
          [115.064371621753025, -19.870799098299699],
          [115.065513487357634, -19.869974074643778],
          [115.067805029178771, -19.868333776882253],
          [115.068954683811626, -19.867518517165763],
          [115.072030672777373, -19.865357600073139],
          [115.073187993231386, -19.864552181637805],
          [115.075510256792995, -19.862951225618531],
          [115.076675181014821, -19.862155703323026],
          [115.079791697029236, -19.860047542260247],
          [115.080761882954562, -19.85939640971651],
          [115.0827073710484, -19.858100992966399],
          [115.083683495197192, -19.857456170066143],
          [115.08693495898126, -19.855325292128498],
          [115.090199258788857, -19.853189401369718],
          [115.091388890984604, -19.852418498914574],
          [115.093773782434141, -19.850887974200589],
          [115.094969860970423, -19.850127814147243],
          [115.09816981518486, -19.848113863364063],
          [115.099373391368999, -19.847363757731216],
          [115.101787660971809, -19.845873856293395],
          [115.102998332806919, -19.845134071280313],
          [115.106236115204638, -19.843175143717872],
          [115.107453770275356, -19.842445739579148],
          [115.109895998901266, -19.840997356242951],
          [115.111120550872783, -19.840278391434595],
          [115.114395103851052, -19.838375125611492],
          [115.115626424120251, -19.837666665783956],
          [115.118095785292326, -19.836260289780512],
          [115.119333801913513, -19.835562385295816],
          [115.122644055279011, -19.833715400845051],
          [115.123339670989139, -19.833329508050326],
          [115.124732971749268, -19.832561040059886],
          [115.12536504136358, -19.832214257881674],
          [115.125981271218734, -19.831879681302212],
          [115.127083769000819, -19.831284171827008],
          [115.127635630779764, -19.830987462101632],
          [115.130980505346088, -19.829197359770319],
          [115.132238004880037, -19.828531442372139],
          [115.134759318987449, -19.827210370662044],
          [115.136023110178485, -19.826555230739245],
          [115.139401515067902, -19.82482259418731],
          [115.140671486400038, -19.82417827760537],
          [115.143217533662323, -19.822900519043685],
          [115.144493588008686, -19.822267086956458],
          [115.147904419753218, -19.820592479159529],
          [115.149186478872934, -19.819969961244681],
          [115.151756495765767, -19.818735898942521],
          [115.153044429257079, -19.818124367145799],
          [115.156486577193846, -19.816508333992374],
          [115.157780233071321, -19.815907851266275],
          [115.160373232139023, -19.814717959166444],
          [115.161672551946822, -19.81412855968523],
          [115.165144893721958, -19.812571626379395],
          [115.166449783930489, -19.811993345216649],
          [115.169065041218687, -19.810847951571645],
          [115.170375384016779, -19.8102808507806],
          [115.173876787383847, -19.80878352364067],
          [115.175192477550809, -19.808227637395532],
          [115.177829124314712, -19.807127126215846],
          [115.179150053931949, -19.806582511173929],
          [115.182679377651198, -19.805145276733072],
          [115.184005406424376, -19.804611982357073],
          [115.18666250916749, -19.803556738552572],
          [115.187993558855737, -19.803034801714659],
          [115.191549653593711, -19.801658129419081],
          [115.192885640559894, -19.80114757530032],
          [115.19556244475109, -19.800137901043229],
          [115.196903236795038, -19.799638789898211],
          [115.200484945124231, -19.798323125811578],
          [115.201830452313629, -19.797835483720576],
          [115.204526074818546, -19.796871712659367],
          [115.205876167651127, -19.796395593581735],
          [115.2094823240501, -19.795141369378655],
          [115.209761355802016, -19.795044597829872],
          [115.210319636042414, -19.794851536768988],
          [115.210550256389297, -19.794771976445531],
          [115.211334618997512, -19.794504227587993],
          [115.212807401840223, -19.794005593982945],
          [115.213544425035252, -19.793757989939252],
          [115.217169552632754, -19.792549558315443],
          [115.218531080345088, -19.792102222939207],
          [115.221258362583399, -19.791219207400445],
          [115.222624093726949, -19.790783535331855],
          [115.22627162613469, -19.78963728823021],
          [115.227641486965126, -19.789213293858381],
          [115.230385214206308, -19.788377032274184],
          [115.231759056335477, -19.787964772256373],
          [115.235427806448115, -19.786881085593564],
          [115.236805525554587, -19.786480582412878],
          [115.239564747215354, -19.785691367062896],
          [115.240946222790058, -19.785302662987476],
          [115.244634997207413, -19.784281890197008],
          [115.246020051184473, -19.783905028394315],
          [115.248793715058014, -19.78316315695406],
          [115.250182299773428, -19.782798156309809],
          [115.253889895202519, -19.781840625644293],
          [115.255281971086106, -19.781487489755818],
          [115.258069452143559, -19.780793132197232],
          [115.259464832136359, -19.780451916822472],
          [115.263190042586416, -19.779557944843248],
          [115.264588560313882, -19.779228683257088],
          [115.267388695731825, -19.778582129161862],
          [115.268790290039874, -19.77826484204877],
          [115.272531901426191, -19.777434717438211],
          [115.273936476087556, -19.777129419187304],
          [115.276748499643645, -19.77653084392324],
          [115.27815592335719, -19.776237572306059],
          [115.281912717997557, -19.775471564860766],
          [115.283322852267929, -19.775190338763082],
          [115.286145763915897, -19.774639956368844],
          [115.28755851701203, -19.774370802770306],
          [115.291329273627184, -19.77366916160247],
          [115.292744549321583, -19.773412092194235],
          [115.29557751539005, -19.772910061849814],
          [115.296995178784528, -19.772665108108185],
          [115.300778669799797, -19.772028061645699],
          [115.300922076592656, -19.772003977801262],
          [115.301267748108103, -19.771946101931007],
          [115.302629122935741, -19.771724328215157],
          [115.305184319001228, -19.77131887156861],
          [115.306462771839506, -19.771121057590676],
          [115.310257765183792, -19.770548815375491],
          [115.311681890207183, -19.770340309357721],
          [115.314532093581306, -19.76993548313601],
          [115.315958145851823, -19.769739165629971],
          [115.319763406755897, -19.769231912023088],
          [115.321191260368437, -19.769047793820562],
          [115.324048685298635, -19.768691773806268],
          [115.325478231435341, -19.768519875591721],
          [115.32929252063343, -19.76807777606848],
          [115.330723648677463, -19.767918103237832],
          [115.333587391345077, -19.767611002745525],
          [115.335019979888216, -19.767463577781825],
          [115.338842059013928, -19.767086775334349],
          [115.340276001036727, -19.766951600935613],
          [115.343145138737214, -19.766693519790067],
          [115.344580308334571, -19.766570615741273],
          [115.348408932726102, -19.766259232677385],
          [115.349845232771372, -19.766148599877909],
          [115.352718852692988, -19.765939621716143],
          [115.35415614738838, -19.765841279051756],
          [115.355975222278744, -19.76572462619049],
          [115.361327971808464, -19.765399835134247],
          [115.459480297868538, -19.889856324394842],
          [118.391693396299914, -19.753185374891682],
          [118.371619368439156, -19.712652303860693],
          [118.4156802464463, -19.636921718162739],
          [118.416386368036569, -19.635709082208336],
          [118.417810332980594, -19.633289985944032],
          [118.418528163743872, -19.63208354631854],
          [118.420457928990345, -19.628874725687979],
          [118.420745729132136, -19.628398179432395],
          [118.421323170328151, -19.627446059987619],
          [118.421548181603384, -19.627076257862939],
          [118.422057241048947, -19.626248445409374],
          [118.422950327195849, -19.624806682882081],
          [118.423398968387687, -19.624086985126212],
          [118.425390506266922, -19.620912285673398],
          [118.426143094927966, -19.619725015996664],
          [118.427659745800725, -19.617357054284582],
          [118.42842379362321, -19.616176382933702],
          [118.430476427844951, -19.613036873952524],
          [118.431251851192087, -19.611862916940026],
          [118.432814041934535, -19.609521779306647],
          [118.433600794041467, -19.608354619370118],
          [118.638497931334541, -19.307238971401375],
          [118.640072081261565, -19.30492862835348],
          [118.640864690652961, -19.303776875602296],
          [118.642992992932363, -19.300714755081856],
          [118.643796602831003, -19.299569927110383],
          [118.645414787162736, -19.297287257101175],
          [118.646229346307337, -19.296149436647113],
          [118.648416023580694, -19.293124684756378],
          [118.649045343967487, -19.292260618832472],
          [118.650310314169701, -19.290536649047056],
          [118.650945947797368, -19.289676765870013],
          [118.653113405659155, -19.286766200899422],
          [118.653931271610986, -19.285678175007718],
          [118.655577126283447, -19.283509030017683],
          [118.656405098816322, -19.282427929805067],
          [118.658626443155867, -19.27955429279632],
          [118.659464461116045, -19.278480188409901],
          [118.661150486705651, -19.276339053704305],
          [118.661998479945964, -19.275272044069538],
          [118.664273006594044, -19.272436237042655],
          [118.66513089597413, -19.271376410293044],
          [118.66685652860599, -19.269263997235612],
          [118.667724258367912, -19.268211430712938],
          [118.670051247866809, -19.265414344896044],
          [118.670928727179103, -19.264369136626328],
          [118.672693403877588, -19.262286127802497],
          [118.673580585076024, -19.261248346134209],
          [118.675959300881118, -19.258490854769093],
          [118.676624619330823, -19.257724741203788],
          [118.67796055683425, -19.256196669840392],
          [118.678559278687771, -19.25551591902439],
          [118.678864511288225, -19.2551719787038],
          [118.679331820607104, -19.254646995862117],
          [118.679565782834629, -19.254384767942668],
          [118.681995474911332, -19.251667737975708],
          [118.682911332791832, -19.250652704658535],
          [118.684752484239766, -19.248630365898634],
          [118.685677758921543, -19.247623080240942],
          [118.688157659248645, -19.244947362430764],
          [118.6890922868796, -19.243947882888449],
          [118.690970831238928, -19.241956811757404],
          [118.691914729980908, -19.240965239054503],
          [118.694444055249051, -19.23833167156937],
          [118.695397199021613, -19.237348020994318],
          [118.697312626376629, -19.235388760682724],
          [118.698274892872064, -19.234413169831896],
          [118.700852846281919, -19.231822583645283],
          [118.70123487558908, -19.231440015644182],
          [118.702000356031704, -19.230676133296868],
          [118.702383789180544, -19.230294835138466],
          [118.704927115094392, -19.227774455426754],
          [118.705885078333722, -19.226833331093303],
          [122.571150236794097, -15.430579616655962],
          [122.579462015759532, -15.440780597846242],
          [122.597707061231972, -15.463892276907018],
          [123.122380802332259, -16.128516075856169],
          [122.390486192683738, -18.098944416851339],
          [122.390447141422555, -18.099048994515442],
          [122.382044550715477, -18.12072434295402],
          [122.382001001944786, -18.120831803844624],
          [122.381950922297278, -18.120936382408104],
          [122.381894502429418, -18.121037680244683],
          [122.381831956379756, -18.121135314243304],
          [122.381763520670006, -18.121228914782535],
          [122.38168945520431, -18.121318126630172],
          [121.330728443562862, -19.347256001063556],
          [121.330707379641922, -19.347280364597111],
          [121.330009743155188, -19.348086346008017],
          [121.329793080286436, -19.348332805214739],
          [121.327406127590734, -19.350985183819148],
          [121.327261754926099, -19.351141959034123],
          [121.326834809878619, -19.351605550555689],
          [121.326812862823431, -19.351629201826142],
          [121.318634175426951, -19.360226878867309],
          [121.253658007411218, -19.428274594996537],
          [121.252117184560461, -19.429885843756665],
          [121.252094784246992, -19.429909116412546],
          [121.252090453112032, -19.42991352309059],
          [121.251296231236097, -19.430718915445539],
          [121.248917832891721, -19.43313064806091],
          [121.248905111082081, -19.433143508366186],
          [121.245274038965817, -19.436784554863266],
          [121.243696975235252, -19.438342894708796],
          [121.240424479905869, -19.44156334627138],
          [121.240401234229694, -19.441585860798796],
          [121.236422818758115, -19.445416968218467],
          [121.236407615718917, -19.445431601986797],
          [121.236391557424554, -19.445446704301901],
          [121.234371353655092, -19.447324129904644],
          [121.233024518166985, -19.448575730785308],
          [121.232735907736014, -19.448843930203168],
          [121.221954386285915, -19.458727825728545],
          [121.221930321327363, -19.458749551550511],
          [121.219718341628209, -19.460715243813411],
          [121.219693880967839, -19.460736569437074],
          [121.213348272704707, -19.466184647103717],
          [121.213323421738551, -19.46620556173724],
          [121.212610163128602, -19.466801837434787],
          [121.212369848090134, -19.467002725295515],
          [121.210206998354352, -19.468810691759984],
          [121.209486035252439, -19.469413337355604],
          [121.209478356840805, -19.469419720743474],
          [121.20945312456206, -19.469440219890203],
          [121.209427519964152, -19.469460297254841],
          [121.208998496583376, -19.469792270296978],
          [121.208854402708539, -19.469903767344931],
          [121.207544205600698, -19.470917455276322],
          [121.197226987035833, -19.47889237158563],
          [121.146725490988729, -19.517795518947992],
          [121.146317028807857, -19.518107500061035],
          [121.146222844608701, -19.518174911442941],
          [121.075780402943337, -19.567264366657128],
          [121.075753351336175, -19.567282675954687],
          [121.07572596787918, -19.567300534691867],
          [121.06405677959674, -19.57487652073479],
          [121.034598147786369, -19.593436546559303],
          [121.034570944193774, -19.593453624684969],
          [121.034426898882316, -19.593542382375006],
          [120.992576878220461, -19.618561169162604],
          [120.992475098347199, -19.618621707925456],
          [120.957237595738547, -19.638674291785094],
          [120.957145263243319, -19.638723186126072],
          [120.95683347458521, -19.638877709438702],
          [120.956727050612926, -19.638926396935631],
          [120.640289991090299, -19.76901516641675],
          [120.640259442019669, -19.769027651704732],
          [120.629185176854435, -19.773359769637636],
          [120.629075387619082, -19.773398747154431],
          [120.624896343291653, -19.774866979427486],
          [120.62486514401121, -19.774877929572767],
          [120.298758511795995, -19.887151301091649],
          [120.298651474486064, -19.887183474337803],
          [119.559992946817147, -20.10218883584605],
          [118.857137644786576, -20.296563940273586],
          [118.857025995753133, -20.296594289694667],
          [118.728127484395941, -20.328209208887813],
          [118.728016770657518, -20.328233557132933],
          [118.727897328998552, -20.328257319919317],
          [118.727793207290802, -20.328275197542268],
          [118.680834908804059, -20.336266524680298],
          [118.675973000253862, -20.327197001240563],
          [118.411267553973587, -19.792709118151492],
          [116.952971188703046, -19.861261511390705],
          [116.953985769427732, -19.861470942430003],
          [116.955443237715258, -19.861778559133143],
          [116.959325781859434, -19.862616066278406],
          [116.960780185257363, -19.862936572065109],
          [116.96368579406419, -19.86359045113835],
          [116.965136973392646, -19.863923819028969],
          [116.969002328794545, -19.864829903077521],
          [116.970450132067981, -19.865176089005274],
          [116.973342285218337, -19.865881269904662],
          [116.97478660991419, -19.866240258581001],
          [116.978633429389333, -19.867214602072181],
          [116.980074181978011, -19.867586361121596],
          [116.982951983747057, -19.868342626211188],
          [116.984389005947946, -19.868727124157431],
          [116.98821594500987, -19.869769387147471],
          [116.989649113615769, -19.870166581722344],
          [116.992511495609051, -19.870973651312909],
          [116.993940683815595, -19.871383517335403],
          [116.997746405172506, -19.872493335598904],
          [116.99917148887323, -19.872915829002238],
          [117.002017451943857, -19.873773419807435],
          [117.003438307032297, -19.874208510914002],
          [117.252817543195079, -19.950802415199234],
          [117.255583807446783, -19.951657671364387],
          [117.256964871131913, -19.952091254307902],
          [117.260642114442135, -19.953263322744078],
          [117.262018952212884, -19.953708782134527],
          [117.264768314606044, -19.954611554879307],
          [117.26614081404739, -19.955068861039081],
          [117.269794928593114, -19.956304094258485],
          [117.270176239342049, -19.956433504002973],
          [117.27093853798317, -19.956693247095643],
          [117.2713686063762, -19.956840445430146],
          [117.272305368098273, -19.957165649275225],
          [117.274274681931047, -19.957855919415124],
          [117.275258129259328, -19.958204110830991],
          [117.278887903653867, -19.959502102340082],
          [117.280248788350946, -19.959995465018665],
          [117.288523767058223, -19.963014952278172],
          [117.289840995065902, -19.963497856740673],
          [117.293353272135846, -19.964802398012239],
          [117.294668080967199, -19.965297112371786],
          [117.297293048235701, -19.966297546994156],
          [117.298603179693032, -19.966803259163044],
          [117.302090532052489, -19.968166438030664],
          [117.303395878217316, -19.968683096747498],
          [117.306001710610531, -19.969727340943962],
          [117.307302174355868, -19.970254917430452],
          [117.310763505731302, -19.97167630671612],
          [117.312059000722343, -19.972214756905487],
          [117.314644930219401, -19.973302502208639],
          [117.315935338644977, -19.973851785631382],
          [117.319369567151853, -19.975330942868652],
          [117.320654889011962, -19.975891053229475],
          [117.323220268100954, -19.977022033440051],
          [117.324500301048147, -19.977592893397286],
          [117.327906343902669, -19.979129356334681],
          [117.32854503882254, -19.979419110703361],
          [117.329821088672361, -19.980001306614952],
          [117.33045842111926, -19.980293738265345],
          [117.333688502622408, -19.981784163108614],
          [117.33489718605631, -19.982347850972474],
          [117.337309511324975, -19.983484861137413],
          [117.338513130676461, -19.984058172646485],
          [117.341716222625678, -19.985599920000254],
          [117.342914796780519, -19.986182858751874],
          [117.34530673172037, -19.987358290652537],
          [117.346500070921593, -19.987950773909063],
          [117.349675262303549, -19.989543409400767],
          [117.350863291907444, -19.990145391296721],
          [117.353233968672725, -19.991358824949771],
          [117.354416594250438, -19.991970266814292],
          [117.357562976750046, -19.993613337185707],
          [117.358740123657867, -19.994234192254112],
          [117.361088867757076, -19.995485283219182],
          [117.362260443364789, -19.99611551012265],
          [117.365414460209195, -19.997828843626166],
          [117.365601143278241, -19.997930365393984],
          [117.365742072438707, -19.998007103644852],
          [117.366766696126206, -19.998570502826396],
          [117.368943441286888, -19.999777643023776],
          [117.37002928632262, -20.000385270863489],
          [117.373115374674853, -20.002127798159336],
          [117.37426973096342, -20.002785850086866],
          [117.376572561074909, -20.004111153107203],
          [117.377721013314158, -20.00477839340806],
          [117.380775631690085, -20.006569911272322],
          [117.38191812682021, -20.007246300376437],
          [117.384197070038795, -20.008608184220293],
          [117.385333497443071, -20.009293666369558],
          [117.405004060988631, -20.021743654146292],
          [117.666197290850093, -20.482417532581998],
          [117.820001336308309, -20.499085951301609],
          [117.844888221939271, -20.822615464504107],
          [117.384675266560478, -20.835058907319588],
          [116.913379869924142, -20.794617718169278],
          [116.914935300276113, -20.732693285658719],
          [116.954225068313875, -20.486062464510798],
          [116.540513523080676, -19.924901737924813],
          [116.623827667113233, -19.890955907289253],
          [116.625161628806154, -19.890415455209052],
          [116.628725793160925, -19.888989526145679],
          [116.630064934049528, -19.888460540421534],
          [116.632748258325478, -19.887414100080605],
          [116.634092417431134, -19.886896655356338],
          [116.637683318630366, -19.885532257907357],
          [116.639032328679036, -19.885026407242833],
          [116.641735167344109, -19.884026323356068],
          [116.643088969880068, -19.883532097328384],
          [116.646705424415813, -19.882229680255477],
          [116.647850793779185, -19.881821932136404],
          [116.650144822225798, -19.881014750130589],
          [116.651244599558709, -19.880632120076257],
          [116.651507172817787, -19.880542049376061],
          [116.651934697928027, -19.880395794430342],
          [116.652148503650551, -19.880322814446288],
          [116.65578931632399, -19.879082805826783],
          [116.657156848809564, -19.878623671345338],
          [116.659896283586704, -19.87771717540727],
          [116.661268160697091, -19.877269822044582],
          [116.66493213181252, -19.876092632868676],
          [116.66630821685078, -19.875657098396346],
          [116.669064531003414, -19.874797875321633],
          [116.669796658139134, -19.874573134622342],
          [115.491124378571115, -19.929980805884085],
          [116.20852495056613, -20.839639905856927],
          [116.229534007488496, -20.881950582653246],
          [116.22958235863905, -20.882052125105417],
          [116.22962414383926, -20.882156541790948],
          [116.2296591931173, -20.882263407330356],
          [116.229687363481048, -20.882372289149771],
          [116.229708541615992, -20.882482743883486],
          [116.229722640287719, -20.882594323669082],
          [116.229729602838916, -20.882706574348902],
          [116.229729401390841, -20.882819040866025],
          [116.229722035943269, -20.882931266364778],
          [116.229707537073295, -20.883042793989716],
          [116.229685963236648, -20.883153172281027],
          [116.229657402567113, -20.883261951577765],
          [116.229621970177845, -20.88336869121207],
          [116.229579810859605, -20.883472956811488],
          [116.190787735165941, -20.969823012422069],
          [116.190774442286738, -20.969851909438034],
          [116.190760614310989, -20.969880583422139],
          [116.190746254835858, -20.969909025381185],
          [116.190731368358001, -20.969937227221237],
          [116.190715959374074, -20.969965179949043],
          [116.190700033279995, -20.96999287457146],
          [116.190683593672929, -20.970020304793195],
          [116.190666646848285, -20.970047459822354],
          [116.190649197302719, -20.970074331565115],
          [116.19063125043192, -20.970100913726128],
          [116.190612810732659, -20.970127197312252],
          [116.190593885399608, -20.970153173330232],
          [116.190574479828456, -20.970178833686191],
          [116.190554599415236, -20.970204172984154],
          [116.190534249555981, -20.970229181331604],
          [116.119523523591852, -21.056828520020133],
          [116.119448521931758, -21.056914631904704],
          [116.116976760469129, -21.059671533314543],
          [116.116898353975898, -21.059757014774391],
          [116.116814854621907, -21.059837530177845],
          [116.116726578069233, -21.059912776453416],
          [115.494192270357075, -21.547772634699299],
          [115.494166227789265, -21.547792562776522],
          [115.494139815600079, -21.547812062776416],
          [115.494113042782715, -21.5478311284038],
          [115.48981832585514, -21.550787151405871],
          [115.489718559563926, -21.55085281990165],
          [115.489615105153007, -21.550912509704517],
          [115.205443675585229, -21.707831723255367],
          [115.205414542946869, -21.707847533336974],
          [114.984329758111926, -21.823959198757962],
          [114.984224389943734, -21.824009136312554],
          [114.984116234776479, -21.824052709364992],
          [114.984005675721392, -21.824089764131259],
          [114.983893106681535, -21.824120168411014],
          [114.98377892605663, -21.824143813386229],
          [114.983663540340217, -21.824160616319318],
          [114.98354735872374, -21.824170516955746],
          [114.983430793096659, -21.824173480221873],
          [114.983314258945938, -21.824169496225238],
          [114.983198168161039, -21.824158577556261],
          [114.983082933530568, -21.8241407646845],
          [114.982968965145687, -21.824116119663131],
          [114.982856665902432, -21.824084730625771],
          [114.982746436898651, -21.824046709088293],
          [114.982638666641265, -21.824002189949056],
          [114.982533740040139, -21.823951330589409],
          [114.845706483567369, -21.749947519662271],
          [114.323903954004322, -21.121768304163879],
          [114.34278350851703, -21.086799435736413],
          [111.723505618970151, -21.07402247042155],
          [111.817764596654072, -28.251170342640737],
          [113.295180642834609, -28.251170342640737],
          [113.285654497548734, -28.219666757284426],
          [114.310422174044106, -28.221923590301401],
          [114.31395301042312, -28.223736663116483],
          [114.313983608057129, -28.223752591009202],
          [114.313985771825969, -28.223753742141469],
          [114.314337572221234, -28.223941084413468],
          [114.316199366707451, -28.224962161174744],
          [114.31622931503091, -28.224979024362426],
          [114.316252835000341, -28.224992731829047],
          [114.316528852224792, -28.225156027128889],
          [114.317618094899217, -28.225807153377389],
          [114.321204047129186, -28.228020011714136],
          [114.321232954936931, -28.228038239173372],
          [114.321261497620071, -28.228056911797012],
          [114.32128966618518, -28.228076022390496],
          [114.321590026258718, -28.228284894432306],
          [114.321617812611976, -28.228304437599661],
          [114.321645208659561, -28.228324408844344],
          [114.322366770710005, -28.228854751645429],
          [114.322451929313161, -28.228921391409017],
          [114.322533385407496, -28.228992509796456],
          [114.322807171413842, -28.229245964829374],
          [114.322824305297559, -28.229262023123852],
          [114.322848283921189, -28.229285177968563],
          [114.322871801192719, -28.229308700635954],
          [114.322894849917475, -28.22933258303226],
          [114.322917422900787, -28.229356817962753],
          [114.32425585782164, -28.230826472963315],
          [114.324277948768326, -28.230851054132813],
          [114.324299549584566, -28.230875974346702],
          [114.324320656673081, -28.230901223712465],
          [114.324341260141068, -28.230926796834183],
          [114.406006793079086, -28.333004179299394],
          [114.519277964206708, -28.477111079013014],
          [114.532205317521402, -28.494092774861599],
          [114.532254842287216, -28.494158193345925],
          [114.532502175634932, -28.494501013111233],
          [114.532955699246145, -28.495129721959074],
          [114.532974317910544, -28.495156486682447],
          [114.532992402377545, -28.49518353559165],
          [114.558197995441219, -28.53344259749781],
          [114.558254320880224, -28.533528298392241],
          [114.558305602921337, -28.533617110041575],
          [114.558501524725671, -28.53398151803259],
          [114.585054479380801, -28.583627432360061],
          [114.585099831292268, -28.583718075928402],
          [114.598314048554585, -28.610776728363305],
          [114.598356268127304, -28.610868775773326],
          [114.604257251933404, -28.623883214004678],
          [114.73953735731925, -28.624767397700012],
          [114.73953735731925, -28.653643730752997],
          [114.729967740216665, -28.901133828233554],
          [114.780920191213909, -29.013507891276106],
          [114.321980178211774, -29.017012202686026],
          [114.058396315837399, -29.016669797872851],
          [113.52644101745571, -29.01596352317447],
          [113.488069650263128, -28.88906690284027],
          [112.719957668771698, -28.900884010247829],
          [112.826283194619236, -31.971033569095813],
          [114.843705321893069, -31.971033569095813],
          [114.844136867663011, -31.908027886683932],
          [114.969617808798432, -31.908242567507088],
          [114.969617808798432, -31.907923238734583],
          [114.915568647575128, -31.907845570416725],
          [114.874159739880156, -31.907786065874177],
          [114.959694884125497, -31.6103],
          [114.9595576778446, -31.610019543567034],
          [114.958930363845298, -31.608720202175562],
          [114.957276569957799, -31.605248632918006],
          [114.956663556078297, -31.603944338060728],
          [114.955451846425603, -31.601330864128045],
          [114.954853162343625, -31.600021710233705],
          [114.953275820722638, -31.596524223414121],
          [114.952691509605529, -31.595210284227164],
          [114.951537308000411, -31.592577750962391],
          [114.950967427404862, -31.591259182065528],
          [114.94946707584495, -31.587737006157852],
          [114.94935958167946, -31.587483942330039],
          [114.949136532724879, -31.586957354198489],
          [114.948592515732116, -31.585653722141501],
          [114.947827055973903, -31.583792360229211],
          [114.945846009585694, -31.582099015057452],
          [114.94470097027363, -31.581111115185763],
          [114.941661911967685, -31.578464583073981],
          [114.940527677110708, -31.577467600049658],
          [114.938270088293962, -31.575464638082565],
          [114.93714675501883, -31.574458678025508],
          [114.934165884647882, -31.571764253417541],
          [114.933053596846094, -31.570749424246515],
          [114.930840094594714, -31.568710948051773],
          [114.929738900829648, -31.56768731901451],
          [114.926817236426359, -31.56494593540657],
          [114.925727206845181, -31.56391355056985],
          [114.923558410792111, -31.561840139310959],
          [114.922479664105254, -31.560799130875125],
          [114.919618205715665, -31.55801173705197],
          [114.918550866029705, -31.556962206640492],
          [114.916427631430111, -31.554854684995689],
          [114.915371756301624, -31.553796711748817],
          [114.912571480589463, -31.550964273582338],
          [114.912185891765603, -31.550572887728549],
          [114.911416261851059, -31.549788970284681],
          [114.911169781060607, -31.549537350768105],
          [114.910376231877649, -31.548719591835663],
          [114.90906889911048, -31.547362596706421],
          [114.908417574111809, -31.546682466422624],
          [114.905679437955769, -31.543805966871844],
          [114.904658513179925, -31.54272319571885],
          [114.902628463632709, -31.540549562212504],
          [114.901619357747222, -31.539458717845491],
          [114.89894429464357, -31.536539150661213],
          [114.897947117365675, -31.535440332905011],
          [114.89596473368556, -31.53323479504968],
          [114.894979546169225, -31.532128093836434],
          [114.892368468929703, -31.529166471655287],
          [114.89139536920095, -31.528051976917141],
          [114.889461306094518, -31.525815276653645],
          [114.888500361602496, -31.524693090913388],
          [114.88595415695886, -31.521690437163898],
          [114.885005475622279, -31.520560664742845],
          [114.883120415674739, -31.518293605165695],
          [114.882184054150798, -31.517156336895368],
          [114.879703586351525, -31.51411369029455],
          [114.878779615686767, -31.512968993624099],
          [114.876944135363601, -31.510672281600478],
          [114.876032640993685, -31.509520286032341],
          [114.87361875630063, -31.506438698786894],
          [114.872719852439332, -31.505279528427479],
          [114.870934658607666, -31.502954064178653],
          [114.870048384825168, -31.501787792772348],
          [114.867701898024279, -31.498668333276896],
          [114.866828320870354, -31.497495029172228],
          [114.865093932439095, -31.495141503377624],
          [114.864233134651499, -31.493961303271476],
          [114.861954840743351, -31.490805046215883],
          [114.861106935636599, -31.489618082308596],
          [114.859424034291806, -31.487237438357056],
          [114.858589052442881, -31.486043780795796],
          [114.856379721247208, -31.482851820654957],
          [114.855734963098143, -31.48191250755616],
          [114.854453434578431, -31.480029870382168],
          [114.853937176059844, -31.479266291106399],
          [114.853641660634139, -31.478824497352605],
          [114.853292257831527, -31.478300078385871],
          [114.853117872092184, -31.478037729057917],
          [114.850978250046296, -31.474811166602024],
          [114.850182466048068, -31.473598016235428],
          [114.848604082112729, -31.471165412153994],
          [114.847821495665585, -31.469945982720901],
          [114.845752304924986, -31.466685934008581],
          [114.844983023048144, -31.465460369400489],
          [114.84345777285796, -31.46300314997535],
          [114.842701819833223, -31.461771519440049],
          [114.840703753775301, -31.458479111321878],
          [114.840032575343116, -31.457361700082345],
          [114.838701172221363, -31.455122073424889],
          [114.83804096192091, -31.453999879590754],
          [114.836093587948767, -31.450654946568477],
          [114.83537020207325, -31.449397707837875],
          [114.833937180956241, -31.446877463923784],
          [114.833227560103865, -31.445614483921247],
          [114.831353631065326, -31.44223892628537],
          [114.830657822900321, -31.440970267963451],
          [114.82928007771352, -31.43842740699921],
          [114.82859815508084, -31.437153228638522],
          [114.826798310393769, -31.433748227198862],
          [114.826130356031172, -31.432468666395778],
          [114.824808436260355, -31.429904224400389],
          [114.824154479845447, -31.428619366590453],
          [114.822429328350836, -31.425186112049403],
          [114.821789434634752, -31.423896060654613],
          [114.820523745874198, -31.421310864105067],
          [114.819897961621677, -31.420015742332623],
          [114.818248086080416, -31.41655543618441],
          [114.817636476941971, -31.415255360946105],
          [114.816427462557385, -31.412650340640653],
          [114.815830067203933, -31.411345421653834],
          [114.814256024296128, -31.407859277983221],
          [114.813672899384869, -31.406549618669942],
          [114.812520954178808, -31.403925662239487],
          [114.811952141977827, -31.402611387605418],
          [114.810454459605694, -31.399100623195181],
          [114.810313766067566, -31.398769600736443],
          [114.810007859874872, -31.398047154652431],
          [114.809482450754558, -31.396787360947883],
          [114.808668470773341, -31.394807779555322],
          [114.808265526832656, -31.393816780619886],
          [114.806844708616495, -31.390282623943904],
          [114.806319130423617, -31.388955172443218],
          [114.805282461216621, -31.386296089392943],
          [114.804771379195813, -31.384964483024419],
          [114.803427901776331, -31.381408168851863],
          [114.802931380678729, -31.380072556902917],
          [114.801952911997319, -31.377397387679252],
          [114.801470971608069, -31.376057854686223],
          [114.800205281048989, -31.372480627678783],
          [114.799737970830734, -31.371137292352103],
          [114.798818002149119, -31.368446910196724],
          [114.79836535177958, -31.367099887649658],
          [114.797177867164919, -31.363502996965678],
          [114.796739910818246, -31.36215237083519],
          [114.795878725422881, -31.359447645392493],
          [114.79545550266937, -31.358093567663957],
          [114.794346619700832, -31.354478269656397],
          [114.793938187197682, -31.35312090310714],
          [114.793136116938285, -31.35040293065066],
          [114.79274248637671, -31.349042349924446],
          [114.791712565682474, -31.34540990724139],
          [114.791333762243426, -31.344046178887993],
          [114.79059101486348, -31.341315721143587],
          [114.790227078117255, -31.339949016034211],
          [114.789276459640973, -31.336300695820398],
          [114.788927439050099, -31.334931189322901],
          [114.788244314923304, -31.33218941091252],
          [114.787910217682452, -31.330817165979397],
          [114.787039207193743, -31.327154242574181],
          [114.786720057584603, -31.325779343741658],
          [114.78609673207859, -31.32302702078033],
          [114.785792558879507, -31.321649622731854],
          [114.785001439664825, -31.317973375870565],
          [114.784824971095645, -31.317140172880613],
          [114.784477507231259, -31.315472899954329],
          [114.784353380104449, -31.314870202198051],
          [114.784197414279333, -31.314091741840343],
          [114.783981570692958, -31.312997198561845],
          [114.783874831058711, -31.312449767742521],
          [114.783163854028658, -31.30876147895907],
          [114.782904765642456, -31.307377314411497],
          [114.782401651615032, -31.304606942056694],
          [114.782157631369614, -31.303220761229113],
          [114.781527022254295, -31.299521714755315],
          [114.78133450078667, -31.298360782624002],
          [114.780960020388648, -31.296037637726783],
          [114.78077806415638, -31.294875449242568],
          [114.78027785224117, -31.291583151741008],
          [114.780096235952556, -31.290347883448021],
          [114.779815430737585, -31.288372099892456],
          [114.779575250597418, -31.286639549675442],
          [114.776851089905904, -31.267510014675395],
          [115.439319999918098, -31.271760000223765],
          [115.441435210766372, -31.271769724593071],
          [115.441747056981171, -31.272684846828156],
          [115.441764437279062, -31.272737443678011],
          [115.441779985657831, -31.27279061069811],
          [115.441928600424603, -31.273333695093925],
          [115.441936436217588, -31.273363460854966],
          [115.441943888000083, -31.273394218568285],
          [115.441950713854453, -31.273425085998895],
          [115.441956911082684, -31.273456052354902],
          [115.441962478785399, -31.27348710864311],
          [115.441967414264809, -31.27351824676964],
          [115.441971716621538, -31.27354945504328],
          [115.441975384956095, -31.273580725370152],
          [115.441978416570691, -31.273612047857682],
          [115.441980814163344, -31.273643414411993],
          [115.441982572337906, -31.273674812442607],
          [115.441983693792508, -31.273706233855592],
          [115.441984176728397, -31.273737669657692],
          [115.441984104782705, -31.273752166729082],
          [115.442098090254717, -31.274127667857556],
          [115.442447037101147, -31.275070990134054],
          [115.44329304823566, -31.276684107685355],
          [115.444688771769506, -31.279032758255141],
          [115.44535784668733, -31.280091000399295],
          [115.445364532247481, -31.280096905347875],
          [115.445433729682918, -31.280161023412461],
          [115.445499604123484, -31.280228553504912],
          [115.445561985597237, -31.28029932115669],
          [115.445620715823452, -31.28037314740277],
          [115.445723516427165, -31.280509711254126],
          [115.445782145929343, -31.280592551405107],
          [115.445794400990849, -31.280601576101787],
          [115.445883022883208, -31.280670617954627],
          [115.445967480914533, -31.280744696910176],
          [115.446047489100351, -31.28082356025908],
          [115.446122775845538, -31.280906941801902],
          [115.446354632760176, -31.281180385166579],
          [115.446424153052249, -31.281267524076952],
          [115.44648795635419, -31.281358932968317],
          [115.44654578006373, -31.28145423592423],
          [115.446597388558644, -31.281553042638791],
          [115.446682149661569, -31.281729728843857],
          [115.446814678254896, -31.281911182355145],
          [115.447163003669743, -31.28229610658002],
          [115.447226754810913, -31.282370429251841],
          [115.447286406842295, -31.282448080314623],
          [115.447517531708741, -31.282766620183338],
          [115.447529745401539, -31.282783662336101],
          [115.447548450400745, -31.282810623111743],
          [115.447566603216274, -31.282837862677184],
          [115.447584200250731, -31.282865371139906],
          [115.447601234309559, -31.282893142204728],
          [115.447617701795593, -31.282921165079642],
          [115.447633596413425, -31.282949432570206],
          [115.447648913666512, -31.282977936582483],
          [115.4476636490582, -31.283006668123164],
          [115.447677798091945, -31.283035617299845],
          [115.447691356271093, -31.283064776917854],
          [115.447704319099103, -31.283094136185412],
          [115.447716683877957, -31.283123687907846],
          [115.44772357987938, -31.283141122165034],
          [115.447952931282771, -31.283372727269523],
          [115.448029844002122, -31.283455158228946],
          [115.44810151007664, -31.283542189220611],
          [115.448167655213183, -31.283633486596102],
          [115.448398416753548, -31.283974571569161],
          [115.448450412856346, -31.284056024066217],
          [115.448497602982002, -31.284140352595159],
          [115.448539827051491, -31.284227272970213],
          [115.448576945669515, -31.284316493811104],
          [115.44860883203205, -31.284407714744191],
          [115.448624018883379, -31.284455920204493],
          [115.448636620183947, -31.284469867790108],
          [115.448658508783183, -31.284494988552808],
          [115.448679882970282, -31.284520437568119],
          [115.448700734651197, -31.284546204943354],
          [115.448721060228763, -31.284572282584747],
          [115.448740850709783, -31.284598662398309],
          [115.448760101597486, -31.284625336290219],
          [115.448778808395332, -31.284652297065804],
          [115.448796962110123, -31.284679535731925],
          [115.448814560043957, -31.284707045094024],
          [115.448815134710799, -31.284707963301798],
          [115.448943092949435, -31.284912488920156],
          [115.448959552341535, -31.284939339978507],
          [115.448976019827569, -31.284967363752799],
          [115.448991915344664, -31.284995631243362],
          [115.449007232597751, -31.285024135255583],
          [115.449021969788191, -31.285052865897001],
          [115.449036118821937, -31.285081815073681],
          [115.449049677900348, -31.285110973792371],
          [115.44906264162762, -31.285140333959191],
          [115.449063532855803, -31.285142462654505],
          [115.44907189655089, -31.285151721174941],
          [115.449093786049502, -31.285176842836961],
          [115.449115159337225, -31.285202291852215],
          [115.449136011917517, -31.285228058328187],
          [115.449156336595706, -31.285254135070261],
          [115.449176128875365, -31.285280514883823],
          [115.449195380662331, -31.285307189674995],
          [115.449214086560914, -31.285334149551318],
          [115.449216449079927, -31.285337634424252],
          [115.449293372591114, -31.285451329415253],
          [115.449309164686269, -31.285475084107816],
          [115.449326762620103, -31.285502592570538],
          [115.449343797578308, -31.285530362735983],
          [115.449360265963605, -31.285558387409594],
          [115.449376160581437, -31.285586654000838],
          [115.449379369362418, -31.285592623700552],
          [115.449388562232457, -31.285601764409876],
          [115.449411953598883, -31.285625861744109],
          [115.449434853036109, -31.285650308914569],
          [115.4494572497523, -31.285675097827436],
          [115.449479138351649, -31.285700220388833],
          [115.449500513438011, -31.285725669404087],
          [115.449521366018303, -31.285751434980682],
          [115.449529709028866, -31.285762020900506],
          [115.449761220603932, -31.286058006671624],
          [115.449820363618983, -31.286138120977455],
          [115.449874885017948, -31.28622144856098],
          [115.450111508339546, -31.286606781078035],
          [115.450321944302345, -31.286854927412946],
          [115.450684576132289, -31.287175223657584],
          [115.450755052403792, -31.287240626853418],
          [115.450822109452815, -31.28730953200926],
          [115.450885572810989, -31.287381761059407],
          [115.451246163179917, -31.287814621847303],
          [115.451312266947639, -31.287898881128399],
          [115.451373122271889, -31.287987005695697],
          [115.45142850342279, -31.288078669994604],
          [115.45159965879725, -31.288383253284451],
          [115.451603075321714, -31.288385728218714],
          [115.451630579287894, -31.288406370357677],
          [115.451657658774025, -31.288427422587461],
          [115.451684304786909, -31.288448881310785],
          [115.451710509232726, -31.288470736635134],
          [115.451736264017427, -31.288492983164588],
          [115.451761561946569, -31.28851561370459],
          [115.451786394926216, -31.288538621959788],
          [115.451810755761812, -31.288562000735681],
          [115.451834636359422, -31.288585742837711],
          [115.451858030423864, -31.288609841071263],
          [115.451880928961714, -31.288634288241781],
          [115.45190332657728, -31.288659076255328],
          [115.451925216975269, -31.288684197917348],
          [115.451946592961008, -31.288709646033283],
          [115.451967446440563, -31.288735413408574],
          [115.451969737013769, -31.288738302030993],
          [115.452149852333832, -31.288966005876432],
          [115.452207390958392, -31.289042794489319],
          [115.4522605831595, -31.289122656085681],
          [115.452309266159773, -31.289205344251172],
          [115.452353287973892, -31.289290603578422],
          [115.452428608893229, -31.289447578442946],
          [115.452459078823495, -31.289474487957193],
          [115.452528286151505, -31.28953860152518],
          [115.452594169585268, -31.289606126221713],
          [115.452656561850858, -31.289676889376892],
          [115.452715302869024, -31.289750711126374],
          [115.452920943646745, -31.290023827137873],
          [115.45296618853888, -31.290086706836007],
          [115.453008592472656, -31.290151535364998],
          [115.45304807271043, -31.29021818502116],
          [115.453252242197323, -31.290581495839319],
          [115.453292906842194, -31.290658403162752],
          [115.453329477773195, -31.290737339356667],
          [115.453361855165554, -31.290818085885917],
          [115.453487619957741, -31.291157899217637],
          [115.453491646222574, -31.291168902422839],
          [115.453502194370799, -31.291198974852762],
          [115.453512130080753, -31.291229202865395],
          [115.453521449755158, -31.291259576568166],
          [115.453530150695997, -31.291290088766516],
          [115.453538230205254, -31.291320727769346],
          [115.453545685585027, -31.291351484583288],
          [115.453552515935939, -31.291382352013898],
          [115.453558716761449, -31.291413318369905],
          [115.45356381142085, -31.291441715362851],
          [115.453578449685779, -31.291457237661348],
          [115.453638828369321, -31.291524432306687],
          [115.453695791427663, -31.291594544352677],
          [115.453749197667435, -31.291667402928283],
          [115.453954476917602, -31.291963064943445],
          [115.45400436051284, -31.292039024381438],
          [115.454050137803733, -31.292117528001484],
          [115.454091676589655, -31.29219835277172],
          [115.45411242844591, -31.292241595772964],
          [115.454114279250689, -31.292243372833354],
          [115.454138161646938, -31.292267114935385],
          [115.454161556610643, -31.292291212269561],
          [115.454184456947246, -31.292315659440078],
          [115.454206856361338, -31.292340446554306],
          [115.45422874765859, -31.292365569115702],
          [115.454250125442968, -31.292391016332317],
          [115.454270979821899, -31.292416782808232],
          [115.454291307198105, -31.292442859550306],
          [115.454311101276403, -31.292469237565228],
          [115.454330354862009, -31.292495912356401],
          [115.454349062559231, -31.292522872232723],
          [115.454367219871415, -31.292550110898844],
          [115.454384821402414, -31.292577617562984],
          [115.454401858159258, -31.292605388627749],
          [115.454418328343195, -31.29263341240204],
          [115.454426605703361, -31.292647972425925],
          [115.454503173083026, -31.292784211622006],
          [115.454510793038708, -31.292797917289988],
          [115.454526112989811, -31.292826421302266],
          [115.454540851978777, -31.292855151044364],
          [115.454555003710539, -31.292884100220988],
          [115.454568564587703, -31.292913258939677],
          [115.454581531012877, -31.292942618207235],
          [115.454593897590371, -31.29297216903035],
          [115.454605663420693, -31.293001903315144],
          [115.454616821309287, -31.293031811169101],
          [115.454627370356889, -31.293061883599023],
          [115.454637306066843, -31.2930921116116],
          [115.454646625741248, -31.293122485314427],
          [115.45465228067826, -31.293142313566875],
          [115.454654096409513, -31.293144319954365],
          [115.454718724389636, -31.293219603102159],
          [115.454779043717963, -31.293298381015404],
          [115.454834865536668, -31.293380406380606],
          [115.454886016276646, -31.293465423790224],
          [115.454988106416067, -31.293647076951004],
          [115.454995721875093, -31.293660775424428],
          [115.455011042725459, -31.293689279436649],
          [115.455025781714539, -31.293718009178747],
          [115.455039933446187, -31.293746958355428],
          [115.455053495222728, -31.293776116174797],
          [115.455066461647903, -31.293805475442298],
          [115.455078829124773, -31.293835027164732],
          [115.455087827741067, -31.293857769220608],
          [115.455142623433403, -31.293934168427086],
          [115.455219560434443, -31.294047860720127],
          [115.455266470871038, -31.294121152768923],
          [115.455777762433854, -31.294535083727112],
          [115.455853137312488, -31.294599294421857],
          [115.455925151424708, -31.29466725259158],
          [115.456338675889242, -31.295078184310739],
          [115.456350789757153, -31.295090330554274],
          [115.456374187418874, -31.295114428787826],
          [115.456397087755477, -31.295138875058967],
          [115.456419488068946, -31.295163662173252],
          [115.456441380265574, -31.295188783835272],
          [115.456462758049952, -31.295214231051887],
          [115.456483614227523, -31.295239998427121],
          [115.456503943402367, -31.295266073370556],
          [115.456523738379929, -31.295292452284798],
          [115.456542992864911, -31.295319126176707],
          [115.456561702360773, -31.295346086052973],
          [115.456570625434097, -31.295359469763696],
          [115.456810733628572, -31.295529200612066],
          [115.456897404891379, -31.295593988671612],
          [115.456980451886352, -31.295663362374228],
          [115.457394719191029, -31.29602919219343],
          [115.457472541124957, -31.296101813347946],
          [115.45754618660726, -31.29617866671208],
          [115.457752589110783, -31.296406678125663],
          [115.457764757837367, -31.296420254291263],
          [115.457786650933258, -31.296445375053963],
          [115.457808028717636, -31.296470823169898],
          [115.45782888579447, -31.29649658874655],
          [115.457849214969315, -31.296522664589247],
          [115.457869010846252, -31.296549044402809],
          [115.457888266230611, -31.296575715596759],
          [115.45790697572636, -31.296602676372345],
          [115.457925134837183, -31.296629914139203],
          [115.457936975311213, -31.296648418589598],
          [115.458121390289989, -31.296790940449512],
          [115.458200099854821, -31.296854998259505],
          [115.458275358720925, -31.296923077837732],
          [115.458346960943572, -31.296994992125121],
          [115.45860515180641, -31.297268729568145],
          [115.458620860264546, -31.297285590957188],
          [115.458643260578128, -31.297310378071472],
          [115.458665154573282, -31.297335499733492],
          [115.458686533256923, -31.297360946950107],
          [115.458707390333871, -31.297386713426022],
          [115.458727720407978, -31.297412788369456],
          [115.458747516284916, -31.297439167283699],
          [115.458766771669275, -31.297465840276288],
          [115.4587854820644, -31.297492800152554],
          [115.458803641175109, -31.297520037919355],
          [115.458821242706222, -31.297547544583495],
          [115.458838283060345, -31.29757531474894],
          [115.458854755042921, -31.297603336724592],
          [115.458870654157408, -31.297631604215098],
          [115.458885976806414, -31.297660106428737],
          [115.458900716694757, -31.297688837070154],
          [115.458912942978031, -31.297713841820325],
          [115.459021985776076, -31.29776846933936],
          [115.459127690290757, -31.297829305777782],
          [115.45922970308834, -31.297896146090238],
          [115.459327685124663, -31.297968769043393],
          [115.459820385902162, -31.298358084657821],
          [115.459903348360854, -31.298427386414687],
          [115.460783722590804, -31.299204753196761],
          [115.460847879326252, -31.299264023915555],
          [115.460909265250507, -31.29932615897502],
          [115.461425674855036, -31.299873626666511],
          [115.461498060387271, -31.299954754508292],
          [115.461565300897973, -31.300040194599262],
          [115.46162713828187, -31.300129623183523],
          [115.461683337815884, -31.300222697619347],
          [115.461733684561977, -31.300319063573909],
          [115.461771281619463, -31.300397391826152],
          [115.461858171417589, -31.300461349811428],
          [115.461931221548753, -31.300517676149809],
          [115.462001526049676, -31.300577392932269],
          [115.462068929337647, -31.300640367958579],
          [115.462133279427348, -31.300706459135711],
          [115.462365595895562, -31.300957325919796],
          [115.462434442595509, -31.301035894291033],
          [115.462498558861512, -31.301118369317237],
          [115.462557722560859, -31.301204465013996],
          [115.462611730447065, -31.301293886403698],
          [115.462620955692614, -31.301310298131682],
          [115.46263679095523, -31.301323046021707],
          [115.462663000796965, -31.301344900446736],
          [115.462688760977585, -31.301367145177551],
          [115.462714064302645, -31.301389773918913],
          [115.462738902678325, -31.301412780375472],
          [115.462763268909839, -31.301436157352725],
          [115.462787154903367, -31.301459898555436],
          [115.462810552564974, -31.301483994990349],
          [115.462833458297496, -31.30150844036217],
          [115.462855861308981, -31.301533226577078],
          [115.462877756203511, -31.301558347339835],
          [115.462882885936551, -31.301564367401568],
          [115.462960204250066, -31.301655505597068],
          [115.462976454999421, -31.301674932751894],
          [115.462997313875007, -31.301700697429226],
          [115.463017645747868, -31.301726773271923],
          [115.463037443423332, -31.301753151286846],
          [115.46305670240497, -31.301779824279436],
          [115.463075412800094, -31.301806783256382],
          [115.463093573709557, -31.301834020123863],
          [115.463111177039195, -31.301861527687322],
          [115.463128219192072, -31.301889296953448],
          [115.463144692973287, -31.30191731802978],
          [115.463158680129027, -31.301942181586355],
          [115.463177610858111, -31.301959152692689],
          [115.463202450133053, -31.301982159149304],
          [115.463226814565928, -31.302005536126558],
          [115.463250702358096, -31.302029276429892],
          [115.46327410091908, -31.302053372864805],
          [115.463297005752224, -31.302077818236683],
          [115.463319409663086, -31.30210260535091],
          [115.463341304557616, -31.302127726113611],
          [115.463362685039897, -31.302153172430906],
          [115.463374556090912, -31.302167717166355],
          [115.463503299437775, -31.30232713009292],
          [115.46351228816161, -31.302338350934122],
          [115.463532619135094, -31.302364425877499],
          [115.463552417709934, -31.302390803892422],
          [115.463571675792309, -31.302417476885012],
          [115.463590387986073, -31.302444435861958],
          [115.463608548895422, -31.302471673628816],
          [115.463613832412534, -31.302479929405195],
          [115.463624321205543, -31.302491963233479],
          [115.463645701687824, -31.302517409550774],
          [115.463666560563411, -31.302543175127369],
          [115.463686893335534, -31.302569250070803],
          [115.463706691010998, -31.302595628085726],
          [115.463725949093373, -31.302622301078316],
          [115.463744661287137, -31.302649260055261],
          [115.463746993229165, -31.302652694566177],
          [115.463823948216714, -31.30276638236262],
          [115.463839778083297, -31.302790184719186],
          [115.463857382312426, -31.302817691383325],
          [115.463874423565812, -31.302845460649451],
          [115.463890898246405, -31.302873482625102],
          [115.463906800058794, -31.30290174831697],
          [115.463922125405816, -31.302930251429927],
          [115.463928322634047, -31.302942331123631],
          [115.463932139356757, -31.302946709922708],
          [115.463953519839151, -31.302972156240003],
          [115.463974379614001, -31.302997920917278],
          [115.463994710587485, -31.303023996759975],
          [115.464002853049237, -31.303034721175379],
          [115.464259980913425, -31.303376095730187],
          [115.464297893632988, -31.30342837781734],
          [115.464333865615458, -31.303482013384155],
          [115.464695492003443, -31.304043395386316],
          [115.464764278448797, -31.304129588209889],
          [115.464765881939911, -31.304130709664491],
          [115.464793808587501, -31.304150932719324],
          [115.464821319748125, -31.304171573059591],
          [115.464848406428928, -31.304192624390055],
          [115.46487505783773, -31.30421408041542],
          [115.464901268578728, -31.304235933041809],
          [115.464927030558101, -31.304258177772624],
          [115.464952334782538, -31.304280807413306],
          [115.464977174057367, -31.304303812970545],
          [115.465001541188258, -31.304327189048479],
          [115.465025428081049, -31.30435092935187],
          [115.465048828440786, -31.304375025786783],
          [115.465071734173307, -31.304399471158604],
          [115.465094138084055, -31.304424257373512],
          [115.465116034777225, -31.304449377236949],
          [115.465137416158882, -31.304474823554244],
          [115.465149274619421, -31.304489352101882],
          [115.465278025160842, -31.304648763229807],
          [115.465287025575776, -31.304659999359444],
          [115.465307359247277, -31.304686074302822],
          [115.465327157822117, -31.304712452317801],
          [115.465346416803754, -31.304739125310334],
          [115.465365129896895, -31.304766084287337],
          [115.465383291705621, -31.304793321154818],
          [115.465400895934636, -31.304820827818901],
          [115.465417938986775, -31.304848597085027],
          [115.465434413667367, -31.304876618161359],
          [115.46545031458038, -31.304904884752602],
          [115.465459798830693, -31.304922521357241],
          [115.465463019303002, -31.304924891970131],
          [115.465550590787188, -31.304992916689685],
          [115.465634063161588, -31.30506591466019],
          [115.465713152240255, -31.30514363946736],
          [115.465787591823982, -31.305225828509151],
          [115.465857131001826, -31.305312202995708],
          [115.466062842825977, -31.305585299222116],
          [115.466118336392128, -31.305662938593684],
          [115.466169336945427, -31.305743600586652],
          [115.466215680809114, -31.305827025296935],
          [115.466257217796397, -31.305912944726572],
          [115.466293815707104, -31.306001081884403],
          [115.4663253549312, -31.30609115168528],
          [115.466333679056106, -31.306117551283933],
          [115.466344884608816, -31.306127443826426],
          [115.466427359634963, -31.306204517524407],
          [115.466504987315375, -31.30628647184318],
          [115.466577478967565, -31.306373001912448],
          [115.466644565694196, -31.306463785775065],
          [115.466926879971538, -31.30687311400294],
          [115.466985433930745, -31.306963902362156],
          [115.467038162980884, -31.307058192681382],
          [115.467282569035433, -31.307529989617308],
          [115.467419568158562, -31.307716578257441],
          [115.467629522984112, -31.307901924933844],
          [115.467713293933457, -31.307980368299297],
          [115.467792112316147, -31.308063786714342],
          [115.467865684054118, -31.30815186721486],
          [115.468097304447156, -31.30844782240905],
          [115.468109329282129, -31.308463361794679],
          [115.468129129655722, -31.308489738910282],
          [115.468148390435886, -31.308516411003495],
          [115.468167104428403, -31.308543369980498],
          [115.468185267136391, -31.308570606847979],
          [115.468202873164159, -31.308598114411382],
          [115.468219917115562, -31.308625881878925],
          [115.468236392695417, -31.30865390385452],
          [115.468252296306446, -31.308682170445763],
          [115.468267622552844, -31.308710671760025],
          [115.468282366937729, -31.308739400602803],
          [115.468296524065408, -31.308768348880164],
          [115.468310091237754, -31.308797505800214],
          [115.468312051759881, -31.308801943055187],
          [115.468320616003666, -31.308809338180367],
          [115.468345922026742, -31.308831966022353],
          [115.468370763100324, -31.308854971579649],
          [115.468395132029741, -31.308878348556902],
          [115.468419020721285, -31.308902087960973],
          [115.468442421980285, -31.30892618259719],
          [115.468465330410709, -31.308950627969068],
          [115.46848773612021, -31.308975414183976],
          [115.468509633712642, -31.309000534047357],
          [115.468531016892939, -31.309025980364652],
          [115.468551877567165, -31.309051744142607],
          [115.468572213037305, -31.309077819086042],
          [115.46858034470722, -31.309088530011593],
          [115.468683208263542, -31.309225075876498],
          [115.46869487606773, -31.30924074206655],
          [115.468714136848007, -31.30926741415982],
          [115.468732851739787, -31.309294373136765],
          [115.468751014447776, -31.309321610004247],
          [115.468768621374807, -31.309349116668329],
          [115.468785665326209, -31.309376885035192],
          [115.46880214180544, -31.309404906111467],
          [115.468818045416469, -31.309433171803391],
          [115.468833371662868, -31.309461674016973],
          [115.468848116047752, -31.309490403759071],
          [115.468862274074695, -31.309519351137112],
          [115.468875840347778, -31.309548508956482],
          [115.468888812168984, -31.309577866425343],
          [115.468889676417461, -31.309579931268786],
          [115.468898095870486, -31.309589243748576],
          [115.468919992563656, -31.309614363611956],
          [115.468941378441968, -31.309639809929251],
          [115.468962239116081, -31.309665573707207],
          [115.468982573686844, -31.309691648650642],
          [115.469002374060324, -31.309718026665564],
          [115.469021634840601, -31.309744698758777],
          [115.469040349732381, -31.30977165683646],
          [115.469058513339746, -31.309798893703942],
          [115.469064604448022, -31.309808282626079],
          [115.469167104678149, -31.309967377192663],
          [115.469178618698379, -31.309985495833928],
          [115.469195664448421, -31.310013264200734],
          [115.469212140028276, -31.310041285277066],
          [115.469228043639419, -31.310069550968933],
          [115.469243370784966, -31.310098053182571],
          [115.469258115169964, -31.31012678202535],
          [115.469272273196907, -31.310155730302654],
          [115.469285840369253, -31.310184887222704],
          [115.469298812190459, -31.310214245590942],
          [115.469311185063248, -31.310243796414056],
          [115.469320166592524, -31.310266485409954],
          [115.469334679851613, -31.3102858190353],
          [115.469353940631891, -31.310312491128514],
          [115.469372656423047, -31.310339449206197],
          [115.469390819131036, -31.310366686073678],
          [115.469408426058067, -31.31039419273776],
          [115.469408961154727, -31.310395047093721],
          [115.469536996735087, -31.310599552027668],
          [115.469553505589829, -31.310626466038514],
          [115.469569982069061, -31.310654487114846],
          [115.469585886579466, -31.310682753706089],
          [115.469601212825751, -31.310711255020351],
          [115.469615957210749, -31.31073998386313],
          [115.469630116137068, -31.310768932140434],
          [115.469643683309414, -31.31079808906054],
          [115.469647676299246, -31.310807126347754],
          [115.469651030770478, -31.310810344122046],
          [115.469674920361399, -31.310834084425437],
          [115.469698323418925, -31.310858179061654],
          [115.469721230950086, -31.310882624433532],
          [115.46974363755885, -31.31090740974912],
          [115.469765536050659, -31.310932528713181],
          [115.469786919230955, -31.310957975030476],
          [115.469807781703821, -31.310983738808432],
          [115.469828117173961, -31.311009813751866],
          [115.469847918446703, -31.311036190867469],
          [115.469867179226981, -31.311062862960739],
          [115.469885894118761, -31.311089821937685],
          [115.469904057726126, -31.311117057905847],
          [115.469910149733664, -31.311126446828041],
          [115.470012652661808, -31.311285542293888],
          [115.4700241675813, -31.311303660035833],
          [115.470041212432079, -31.311331428402639],
          [115.470057688911311, -31.311359448579651],
          [115.470073593421716, -31.311387715170895],
          [115.470088920567264, -31.311416217384476],
          [115.470103664952262, -31.311444946227255],
          [115.470117823878581, -31.311473893605239],
          [115.470131391050927, -31.311503051424666],
          [115.470144363771396, -31.311532409792846],
          [115.470156736644185, -31.311561959716641],
          [115.470165718173462, -31.31158464601458],
          [115.47018023323119, -31.311603981438566],
          [115.470199494011467, -31.311630654431099],
          [115.470218209802624, -31.311657611609462],
          [115.470236373409989, -31.311684847577624],
          [115.47025398033702, -31.311712355141026],
          [115.470271025187685, -31.311740124407152],
          [115.470287502566293, -31.311768144584164],
          [115.470295760141312, -31.311782663239285],
          [115.470346829942287, -31.311873483974068],
          [115.470354475978297, -31.311887231910191],
          [115.470369803123958, -31.311915733224453],
          [115.470384548408219, -31.311944462067231],
          [115.470398707334539, -31.311973410344592],
          [115.470412275406261, -31.312002567264642],
          [115.470416673091108, -31.312012520961048],
          [115.470422488107374, -31.312020898145875],
          [115.470440652614116, -31.312048135013356],
          [115.47045826044041, -31.312075641677495],
          [115.470475304391812, -31.312103409144981],
          [115.47049178177042, -31.312131430221257],
          [115.470500036647422, -31.312145942581139],
          [115.470653246949837, -31.312418406584129],
          [115.470702183558956, -31.312512200477613],
          [115.4707450623348, -31.312608913570443],
          [115.470895912816218, -31.31298106472434],
          [115.470905558944423, -31.312989709907129],
          [115.470930400917382, -31.313012714565104],
          [115.470954771645438, -31.313036092441678],
          [115.470978662135622, -31.313059830946372],
          [115.471002065193261, -31.313083925582646],
          [115.471024973623685, -31.313108370055204],
          [115.471047381131825, -31.313133156270112],
          [115.471069281422274, -31.313158275234173],
          [115.471090664602571, -31.313183721551468],
          [115.471111527974699, -31.313209485329423],
          [115.471131863444839, -31.313235559373538],
          [115.471151665616958, -31.313261937388461],
          [115.471170927296498, -31.313288608582354],
          [115.471183371215716, -31.313306413360237],
          [115.471465720566584, -31.313715732594915],
          [115.471509168613352, -31.313781871436163],
          [115.471549542777211, -31.31384992943066],
          [115.471861915994737, -31.314405418175454],
          [115.471880656067469, -31.314422173444484],
          [115.471905498939691, -31.31444517810246],
          [115.471929869667861, -31.314468554180394],
          [115.471953761057307, -31.314492293584465],
          [115.471977164114946, -31.314516389120001],
          [115.472000073444747, -31.31454083269324],
          [115.47202248185215, -31.314565618008828],
          [115.472044381243222, -31.314590737872209],
          [115.472065766222158, -31.314616183290184],
          [115.472086629594287, -31.314641947068139],
          [115.472106965963803, -31.314668022011574],
          [115.472126768135922, -31.314694399127177],
          [115.472146030714839, -31.31472107032107],
          [115.472164747405259, -31.314748028398753],
          [115.472182911911887, -31.314775265266235],
          [115.472200519738294, -31.314802771030998],
          [115.472213904348223, -31.314824474369971],
          [115.472393025917427, -31.315119797340742],
          [115.472438464163815, -31.315199460186875],
          [115.472479507423373, -31.315281474760184],
          [115.472652313953176, -31.315651907309643],
          [115.472674841071125, -31.315672049425473],
          [115.47269968484261, -31.315695054083449],
          [115.472724055570779, -31.315718429262063],
          [115.472747946960226, -31.315742168666134],
          [115.472771350917128, -31.31576626420167],
          [115.472794261146305, -31.315790707774909],
          [115.472816669553708, -31.315815493090497],
          [115.472838569844157, -31.315840612953878],
          [115.472859954823093, -31.315866058371853],
          [115.472880819094598, -31.315891822149808],
          [115.472901154564738, -31.315917896193923],
          [115.472920959434759, -31.315944273309526],
          [115.472940221114413, -31.315970945402739],
          [115.472941875866923, -31.315973285438702],
          [115.473070289162592, -31.316155238973067],
          [115.473130680436611, -31.316246607394987],
          [115.4731850093807, -31.316341705305433],
          [115.473233047567192, -31.316440130707406],
          [115.473274591749032, -31.316541469013544],
          [115.473303085868793, -31.316618393424051],
          [115.473413567582156, -31.316778545593365],
          [115.473819192401834, -31.317256500187284],
          [115.473869705522588, -31.317318746762737],
          [115.473917394772002, -31.317383182287983],
          [115.474174228557899, -31.317747087558018],
          [115.474191294092975, -31.317771708297641],
          [115.474209460398356, -31.317798944265803],
          [115.474227069124026, -31.317826450929942],
          [115.474244115773331, -31.317854218397429],
          [115.474260594950579, -31.317882238574384],
          [115.474276501259624, -31.317910504266308],
          [115.474277809773184, -31.31791293873107],
          [115.474293948107288, -31.317925926740088],
          [115.474320164244205, -31.317947777567838],
          [115.474345931619496, -31.317970021399333],
          [115.474371241239851, -31.317992649241319],
          [115.474396085910712, -31.318015653899238],
          [115.474420458437521, -31.318039029977228],
          [115.474444349826967, -31.318062767582603],
          [115.474467754683246, -31.318086863118197],
          [115.47449066491231, -31.318111307590755],
          [115.47451307421909, -31.318136092007023],
          [115.474534975408801, -31.318161210971084],
          [115.474556362186377, -31.318186656389059],
          [115.474577227357258, -31.318212420167015],
          [115.474597564625924, -31.318238494211073],
          [115.47460568460474, -31.318249188049549],
          [115.474914330132265, -31.31865881305373],
          [115.474959602903368, -31.318721686456627],
          [115.475002036514866, -31.318786510489019],
          [115.475041546430248, -31.318853157447222],
          [115.475342519841433, -31.319388305325958],
          [115.475519688083182, -31.319623432175604],
          [115.475738236830239, -31.319816315170783],
          [115.475818807991686, -31.319891486802646],
          [115.475894772825541, -31.319971310627466],
          [115.475965864233331, -31.320055503358731],
          [115.476031832203375, -31.320143769119625],
          [115.476365666842071, -31.32062134869625],
          [115.476416676388567, -31.320698561789129],
          [115.476463434839729, -31.320778420687532],
          [115.476505804599242, -31.320860691567646],
          [115.476765251814982, -31.321400891837641],
          [115.476918874006856, -31.321639267038506],
          [115.477101970579497, -31.321827857569531],
          [115.477173800330661, -31.321906132761796],
          [115.477240934721408, -31.321988470191684],
          [115.477303144424582, -31.322074588371493],
          [115.477457115553534, -31.322301946877303],
          [115.477472975997102, -31.322325785206772],
          [115.477490587420789, -31.322353290971535],
          [115.47750763496947, -31.322381058439078],
          [115.477524115045981, -31.322409078616033],
          [115.477540023153551, -31.322437343408637],
          [115.477555353896491, -31.322465844722899],
          [115.477570101878769, -31.322494573565677],
          [115.477584264402367, -31.322523520943719],
          [115.477597834272729, -31.322552676964449],
          [115.477602221165625, -31.322562603681149],
          [115.477608055067776, -31.322571005147722],
          [115.477610357332196, -31.322574395591857],
          [115.477841319421373, -31.322915431102217],
          [115.477880203408745, -31.322975463546754],
          [115.477916566596377, -31.323037056315059],
          [115.478229006363563, -31.323592527972721],
          [115.478247774315378, -31.323609304825538],
          [115.478272620784878, -31.323632308584138],
          [115.478296995110327, -31.323655684662072],
          [115.478320889197789, -31.323679423166823],
          [115.478344295852594, -31.32370351690372],
          [115.478367208779673, -31.323727959577639],
          [115.478389619885093, -31.323752744893227],
          [115.478411522873557, -31.323777863857288],
          [115.478432910550396, -31.323803308375943],
          [115.47845377841918, -31.323829071254579],
          [115.478474116587222, -31.323855145298694],
          [115.478493922356733, -31.323881522414297],
          [115.478513189432192, -31.323908192708871],
          [115.478531907921251, -31.323935149887234],
          [115.478550076025272, -31.323962385855395],
          [115.478556146449023, -31.32397173790531],
          [115.478761207163984, -31.324289912649306],
          [115.47880324597304, -31.3243586064645],
          [115.478841998659391, -31.324429205943034],
          [115.479105545884295, -31.32493771680214],
          [115.479178787571072, -31.325048057321965],
          [115.479200426158854, -31.325067152626957],
          [115.479274711958396, -31.32513605688348],
          [115.479345093801044, -31.325208944237318],
          [115.479411357648132, -31.325285593455305],
          [115.47947330385, -31.325365772512328],
          [115.479530745347688, -31.325449238591432],
          [115.479838347661712, -31.325926499808077],
          [115.479876928577482, -31.325989258097763],
          [115.479912770158307, -31.326053618979302],
          [115.480284016594169, -31.32675579884102],
          [115.480319478661045, -31.326810092711582],
          [115.480325076041481, -31.326814756595695],
          [115.480350846114675, -31.32683700042719],
          [115.480376158433046, -31.326859625571217],
          [115.480401006701186, -31.326882630229136],
          [115.480425381925897, -31.326906005407807],
          [115.480449277811999, -31.326929743013181],
          [115.48047268536618, -31.326953836750135],
          [115.480495599192636, -31.326978280323317],
          [115.480518012096695, -31.327003064739586],
          [115.480539915984423, -31.327028182804327],
          [115.480561304560638, -31.327053627322982],
          [115.480573132444192, -31.327068108206561],
          [115.480701937844174, -31.327227505844689],
          [115.480768887873978, -31.327315634908587],
          [115.480830050766258, -31.327407874773542],
          [115.480885172912508, -31.327503845925719],
          [115.480934028582624, -31.32760315356262],
          [115.480946066907563, -31.327613776354667],
          [115.481022163042439, -31.327684437886433],
          [115.481094145678298, -31.327759284863077],
          [115.481161787286737, -31.327838077165495],
          [115.481224871130962, -31.327920564782175],
          [115.481283194863636, -31.328006483312492],
          [115.481513817908422, -31.328370063027933],
          [115.481569204455241, -31.328463820049194],
          [115.481618450431256, -31.328560943232901],
          [115.481797099856294, -31.328943762144888],
          [115.482011234730749, -31.329227882260909],
          [115.482473320787221, -31.329672740004924],
          [115.482524809672327, -31.329724239681866],
          [115.482574268787516, -31.329777690887681],
          [115.482858163173773, -31.330096791034009],
          [115.482859229769701, -31.330097991628975],
          [115.482881134556806, -31.330123109693716],
          [115.482902525830923, -31.330148554212371],
          [115.482923394599084, -31.330174316191687],
          [115.482943736364405, -31.330200389336483],
          [115.482963543932442, -31.330226765552766],
          [115.482982811008014, -31.330253435847339],
          [115.482989769961932, -31.330263455194256],
          [115.48300186044753, -31.330273889128648],
          [115.483027173665164, -31.330296515171995],
          [115.48305202283268, -31.330319518930594],
          [115.483076399856031, -31.330342893209888],
          [115.483100295742133, -31.33036663081532],
          [115.483123705994331, -31.330390724552274],
          [115.483146620720049, -31.330415167226136],
          [115.483169035422748, -31.330439950743084],
          [115.483174185840085, -31.330445775651981],
          [115.483354815572397, -31.330650889426977],
          [115.48341434889312, -31.33072195745234],
          [115.483470077182346, -31.330796046300463],
          [115.483521849353906, -31.330872951825199],
          [115.483569522415564, -31.330952463585277],
          [115.483578750359129, -31.330968866320063],
          [115.483594664761995, -31.330981670867345],
          [115.483620885395567, -31.331003520795832],
          [115.483646657267514, -31.331025762828631],
          [115.483671972283787, -31.331048388871977],
          [115.483696820551927, -31.331071392630633],
          [115.483721197575278, -31.331094766010608],
          [115.483745096159282, -31.331118503615983],
          [115.483768506411479, -31.331142597352937],
          [115.483791421137198, -31.331167040026855],
          [115.483813834940634, -31.331191824443124],
          [115.483835740627001, -31.331216941608545],
          [115.483857131901232, -31.331242386127201],
          [115.483878001568542, -31.331268148106517],
          [115.483898343333976, -31.331294221251255],
          [115.483918150902014, -31.331320596568219],
          [115.483937418876849, -31.331347267762169],
          [115.483956140963187, -31.331374224940475],
          [115.483971264862021, -31.331396815010976],
          [115.484150815407816, -31.331669574890952],
          [115.484198908452868, -31.331746966948913],
          [115.484242771087111, -31.331826833941193],
          [115.484282273807935, -31.33190894384262],
          [115.484386562789723, -31.332141986063789],
          [115.484452035233289, -31.332211565711134],
          [115.484513703544621, -31.33228453939995],
          [115.484571391456598, -31.332360697588058],
          [115.48462493439331, -31.332439825337644],
          [115.484674181268474, -31.332521696019398],
          [115.484725273552613, -31.332612512257583],
          [115.484754438566597, -31.332666794436989],
          [115.484808844852409, -31.332732924284983],
          [115.485040577660584, -31.333028851600204],
          [115.485099777332948, -31.333108947919584],
          [115.485154355389227, -31.333192262013256],
          [115.485386652072407, -31.333570080694642],
          [115.485495434067047, -31.333695726776341],
          [115.485694429754176, -31.333846255300386],
          [115.485776958739734, -31.333912073083638],
          [115.485855758236767, -31.333982312833427],
          [115.485930591723445, -31.334056764108311],
          [115.486001234369496, -31.334135202977166],
          [115.486310700078775, -31.334499705397036],
          [115.486380835507248, -31.334587643804696],
          [115.486445218871836, -31.334679876475093],
          [115.486503590268512, -31.334776028390934],
          [115.486702480734948, -31.335129520410987],
          [115.486866250876801, -31.335346783127477],
          [115.487139627691704, -31.33562250627358],
          [115.487206623586872, -31.335693590486756],
          [115.487269689444702, -31.335768183854555],
          [115.487328640904138, -31.335846069640354],
          [115.487383307093978, -31.335927021215014],
          [115.487613972406962, -31.3362905919372],
          [115.48766432544835, -31.336374997807866],
          [115.48770956404519, -31.336462252730712],
          [115.487749527218966, -31.336552045540429],
          [115.487784071977444, -31.336644059675564],
          [115.487813076912062, -31.336737966883618],
          [115.487868673900266, -31.336940635401959],
          [115.488008115582147, -31.337213840446339],
          [115.488371498346055, -31.337777484243475],
          [115.488410090053662, -31.337840242533105],
          [115.488445943325701, -31.337904605213339],
          [115.488649982410834, -31.338290414371102],
          [115.488651883577631, -31.338294020652484],
          [115.48866663785509, -31.338322748595942],
          [115.488680803975967, -31.338351695074607],
          [115.488694379242247, -31.338380850196017],
          [115.488707360056651, -31.338410207664936],
          [115.48871974102326, -31.338439756689354],
          [115.488731519444173, -31.338469488276246],
          [115.488742690822619, -31.338499393432244],
          [115.48875325335996, -31.33852946406347],
          [115.488763201660504, -31.338559690277464],
          [115.488772534824648, -31.338590063080915],
          [115.488781248355963, -31.338620572581306],
          [115.488789339556433, -31.338651209785439],
          [115.488796809325322, -31.338681966599438],
          [115.488803649568808, -31.338712831332032],
          [115.488809863884171, -31.338743796788719],
          [115.488815446875378, -31.338774852177664],
          [115.488819250108349, -31.33879876964744],
          [115.488924735188448, -31.338986233327944],
          [115.488928275819376, -31.338988794597128],
          [115.48895579957059, -31.339009431340116],
          [115.488982898841755, -31.339030479073301],
          [115.489009564639787, -31.339051930602068],
          [115.489035788870638, -31.339073779631178],
          [115.489061563440487, -31.339096020764714],
          [115.489086881154662, -31.339118645908741],
          [115.489111733919458, -31.33914164876802],
          [115.489136113640825, -31.339165022147995],
          [115.489160014023469, -31.339188758854107],
          [115.489183426074305, -31.339212851691684],
          [115.489206344397303, -31.339237292566963],
          [115.489216498642577, -31.339248408187416],
          [115.489319783980932, -31.339362390961526],
          [115.489332047136372, -31.339376059757285],
          [115.489353956420018, -31.339401176922706],
          [115.489375348593512, -31.339426619642722],
          [115.489396221858215, -31.339452381622095],
          [115.489416566321552, -31.339478453867514],
          [115.489436376587605, -31.339504829184477],
          [115.489455648159719, -31.339531498579731],
          [115.489474372944073, -31.339558454858775],
          [115.489483367963089, -31.339571935696256],
          [115.489495639212464, -31.339580958594297],
          [115.489581229490227, -31.339647484144052],
          [115.48966301293774, -31.339718636705697],
          [115.489740740442926, -31.339794200441929],
          [115.489895849214122, -31.339953897554267],
          [115.489907143799655, -31.339965628311063],
          [115.489930062122767, -31.339990070085605],
          [115.489952480422744, -31.340014852703234],
          [115.489974388807013, -31.340039969868656],
          [115.48999578277926, -31.340065412588672],
          [115.490016655144586, -31.340091174567988],
          [115.490037001406563, -31.340117246813463],
          [115.490056811672616, -31.340143622130427],
          [115.490076082345354, -31.340170292425],
          [115.490094807129708, -31.340197247804724],
          [115.490112980629647, -31.340224482873566],
          [115.490130597449138, -31.340251986839689],
          [115.490147651293114, -31.340279753407856],
          [115.49016413766492, -31.340307772685492],
          [115.490180051168522, -31.340336036578776],
          [115.490195387307381, -31.340364536993718],
          [115.490206687288833, -31.34038653890758],
          [115.490775179331081, -31.340929886804815],
          [115.490827650275946, -31.340982019604496],
          [115.490878036592221, -31.341036168684184],
          [115.491265278369951, -31.34146923361817],
          [115.491327526744044, -31.341542531962261],
          [115.491385708383746, -31.341619098442607],
          [115.491439651518817, -31.341698708228762],
          [115.491489196968928, -31.341781125698333],
          [115.49152937867791, -31.341852529170865],
          [115.491537970800778, -31.341858970115311],
          [115.491565070971319, -31.341880016949176],
          [115.491591737668614, -31.341901467578623],
          [115.491617963698104, -31.341923318406373],
          [115.49164373916733, -31.341945557741269],
          [115.491669057780882, -31.341968182885296],
          [115.491693911444941, -31.341991184845256],
          [115.491718292964947, -31.34201455822523],
          [115.491742194246967, -31.342038294032022],
          [115.4917588955567, -31.342055480975603],
          [115.491771183893093, -31.342064692731356],
          [115.491798284063634, -31.342085739565164],
          [115.491824950760929, -31.342107190194611],
          [115.491851176790419, -31.342129039223721],
          [115.491876953158908, -31.342151278558617],
          [115.49190227177246, -31.342173904601964],
          [115.491927125436519, -31.342196906561924],
          [115.491951506956525, -31.342220279941898],
          [115.491975408238545, -31.34224401574869],
          [115.491998822088021, -31.342268108586325],
          [115.492005931228846, -31.342275596341665],
          [115.492135135028548, -31.342412433586901],
          [115.49215094600936, -31.342429387606103],
          [115.492173364309338, -31.342454170223732],
          [115.492195273593097, -31.342479287389153],
          [115.49221666936387, -31.342504730109169],
          [115.492237542628573, -31.342530492088486],
          [115.492257888890549, -31.342556563434584],
          [115.492277700955242, -31.342582938751605],
          [115.492296973426619, -31.342609608146859],
          [115.492315699110236, -31.342636564425845],
          [115.492333874408814, -31.342663798595368],
          [115.492351490329042, -31.342691302561548],
          [115.492368545072395, -31.342719068230394],
          [115.492385032343464, -31.34274708840735],
          [115.492400947645706, -31.342775351401315],
          [115.492416283784564, -31.342803851816257],
          [115.492427015394469, -31.34282474396673],
          [115.492590977991313, -31.342948747886339],
          [115.492669069721842, -31.343010838879081],
          [115.492743851947239, -31.343076877895555],
          [115.492815125018069, -31.343146690467336],
          [115.492882699177244, -31.343220090434784],
          [115.493140753343141, -31.343516312727616],
          [115.493200645493403, -31.343588565160132],
          [115.493256569834898, -31.343663930146192],
          [115.493308364489508, -31.343742190949285],
          [115.493355880169815, -31.343823120940215],
          [115.493398979279505, -31.343906487194602],
          [115.493474405419533, -31.344063432381461],
          [115.493582648720349, -31.344158911604438],
          [115.49366181514074, -31.344232658710212],
          [115.493736553299414, -31.344310891634279],
          [115.49380660778877, -31.344393342378794],
          [115.493871742986585, -31.344479733952539],
          [115.494000233623979, -31.344661670399717],
          [115.494017350420449, -31.344686348695973],
          [115.494035525719028, -31.344713582865495],
          [115.494053143437895, -31.344741086831675],
          [115.494070199080511, -31.344768853399842],
          [115.494086687250842, -31.344796871778158],
          [115.494102602553085, -31.344825134772123],
          [115.49411793959132, -31.344853635187064],
          [115.494132695667417, -31.344882362231203],
          [115.494146863586934, -31.344911307810548],
          [115.49416044155123, -31.344940462931959],
          [115.494162245591269, -31.344944543156089],
          [115.49432983155657, -31.345092362922173],
          [115.494407723637551, -31.345164964291598],
          [115.494481440166396, -31.345241800568601],
          [115.49460966910101, -31.345383290006794],
          [115.494733821408772, -31.345468528649633],
          [115.494799828049736, -31.345515780828578],
          [115.494863874168573, -31.345565658128578],
          [115.494925853645327, -31.345618079610631],
          [115.495288656346474, -31.345938080877659],
          [115.495347341606589, -31.345992008724181],
          [115.49540371470971, -31.346048348552415],
          [115.495457676730439, -31.346107003235545],
          [115.495638360422049, -31.346312101722049],
          [115.495655137274866, -31.346331413763664],
          [115.495676533944902, -31.346356855584361],
          [115.495697409008244, -31.346382617563734],
          [115.495717756169597, -31.346408688909833],
          [115.495737570032929, -31.346435063327476],
          [115.495756843403683, -31.34646173272273],
          [115.495775570885939, -31.346488688102454],
          [115.495793747083781, -31.346515922271976],
          [115.495811365702025, -31.3465434262381],
          [115.495828422243903, -31.346571191007627],
          [115.495838954204487, -31.346589088415669],
          [115.496044458285155, -31.346787636240379],
          [115.497099831591981, -31.347718466933657],
          [115.497182728400276, -31.347796011876426],
          [115.497803628434781, -31.348412224644392],
          [115.497872328545213, -31.348483902410123],
          [115.497936961021992, -31.34855926739624],
          [115.497997327115058, -31.348638091174905],
          [115.498053244261882, -31.3487201318286],
          [115.498104538893472, -31.348805139345643],
          [115.498175900997126, -31.348931921271117],
          [115.498209698418918, -31.34897171357369],
          [115.49841723316888, -31.349154749891738],
          [115.49848650974468, -31.349218835580757],
          [115.498552464224872, -31.349286335995544],
          [115.498614929335531, -31.349357077567049],
          [115.498673744098028, -31.349430882229399],
          [115.498931116577864, -31.349772193831654],
          [115.498992113994973, -31.349858249058911],
          [115.499047742459425, -31.349947868299466],
          [115.49909779422785, -31.35004071790479],
          [115.499238401431171, -31.350322510575381],
          [115.499266242642989, -31.350360816298576],
          [115.499368977596305, -31.350451420296793],
          [115.499450476858101, -31.350527448083199],
          [115.499527260974332, -31.350608235981269],
          [115.499599052953954, -31.350693490811921],
          [115.499665592892825, -31.350782904107689],
          [115.499871139241691, -31.351078499573077],
          [115.499880792564568, -31.351092528097638],
          [115.499898970561048, -31.351119761367841],
          [115.499916590977932, -31.351147265333964],
          [115.499933649318564, -31.351175030103491],
          [115.499950140186911, -31.351203047582544],
          [115.499966057287793, -31.351231310576452],
          [115.499981397923193, -31.351259810991451],
          [115.499996155798044, -31.351288537136213],
          [115.500010326415463, -31.351317482715615],
          [115.500023906178399, -31.351346637837025],
          [115.500028859644203, -31.351357835295801],
          [115.500033560400539, -31.35136148384538],
          [115.500060229795849, -31.351382933575508],
          [115.500086459422619, -31.351404781705241],
          [115.500112239388386, -31.351427021040138],
          [115.500137561599217, -31.351449644385525],
          [115.500162419759931, -31.351472645446165],
          [115.50018680577648, -31.3514960170275],
          [115.500210710655779, -31.351519752834292],
          [115.500234128102647, -31.35154384387323],
          [115.500257051821563, -31.35156828384919],
          [115.50027947371882, -31.351593065567499],
          [115.500301419874745, -31.351618153055256],
          [115.500319357752232, -31.351633037734473],
          [115.500345137718, -31.351655276169993],
          [115.500370460828208, -31.351677900414757],
          [115.500395318988808, -31.351700900576077],
          [115.500419704106093, -31.351724273056732],
          [115.500443608985393, -31.351748007964147],
          [115.500467027331524, -31.351772099003142],
          [115.500489950151177, -31.351796539878364],
          [115.500512372947696, -31.351821321596674],
          [115.500534286727998, -31.351846436963456],
          [115.500555685196787, -31.351871878784152],
          [115.500576562958031, -31.351897638964829],
          [115.500596912817286, -31.351923710310928],
          [115.500604989628641, -31.351934337599573],
          [115.500656466822534, -31.35200260063948],
          [115.500713956883715, -31.352082541376149],
          [115.500766537545701, -31.352165794315908],
          [115.500814016353843, -31.352252057286591],
          [115.500856222436823, -31.352341019122719],
          [115.500893004708473, -31.352432357866974],
          [115.500924227371229, -31.352525742568901],
          [115.500949778909217, -31.352620835982748],
          [115.500969567591483, -31.35271729366815],
          [115.500983519673809, -31.352814765788764],
          [115.501405520248568, -31.353450053177369],
          [115.501459656737779, -31.353537021216539],
          [115.501508481831024, -31.353627078426882],
          [115.501839697643959, -31.354284991858833],
          [115.50188494703275, -31.354382568300821],
          [115.501923643061787, -31.354482922748616],
          [115.501955617557769, -31.354585617232431],
          [115.502104694576019, -31.355128635977735],
          [115.502123921182033, -31.35520630772487],
          [115.502139172784609, -31.355284856311016],
          [115.50221120758124, -31.355714210642248],
          [115.502223977954259, -31.355807491922178],
          [115.502231062813394, -31.355901375747862],
          [115.502232436977465, -31.355995516779615],
          [115.502231834431655, -31.356033541015051],
          [115.502241882556859, -31.356062199710721],
          [115.502476667664155, -31.356479245920411],
          [115.502523973802454, -31.356569551343682],
          [115.502565664573808, -31.356662581712726],
          [115.502742810332506, -31.357093161819932],
          [115.502744754666764, -31.357097906643048],
          [115.502756537584219, -31.357127638229883],
          [115.50276771525796, -31.357157541587242],
          [115.502778283191333, -31.357187612218468],
          [115.502788236887682, -31.357217838432462],
          [115.502797575447858, -31.357248209437273],
          [115.502806294375091, -31.357278718937664],
          [115.502814391870743, -31.357309355242535],
          [115.502821864337648, -31.357340111157157],
          [115.502828710876315, -31.357370975889808],
          [115.502834929688333, -31.357401940447176],
          [115.502840517176196, -31.357432995836064],
          [115.502843494831495, -31.357451617198308],
          [115.502858484731291, -31.357469438164003],
          [115.502879364291289, -31.357495198344679],
          [115.502899715049921, -31.357521268791459],
          [115.502919533409795, -31.357547642309783],
          [115.502938808579188, -31.357574310805774],
          [115.5029575405581, -31.357601265286121],
          [115.50297572035322, -31.357628498556323],
          [115.502993342568743, -31.357656001623127],
          [115.503010402708014, -31.357683766392654],
          [115.503026893576362, -31.357711784771027],
          [115.503035095393443, -31.357726187413562],
          [115.503137345612117, -31.357907804601439],
          [115.50314506359382, -31.357921666751452],
          [115.503160406027973, -31.357950165367811],
          [115.50317516570135, -31.357978892411893],
          [115.503189338117522, -31.358007837091975],
          [115.503202919679097, -31.358036991314066],
          [115.503215905889419, -31.358066346984288],
          [115.503216726071059, -31.358068303009759],
          [115.503225239053563, -31.358077710817668],
          [115.503247154632504, -31.358102826184449],
          [115.503268555799309, -31.358128268005146],
          [115.503289433560553, -31.358154028185822],
          [115.503309786117825, -31.358180098632602],
          [115.503329603578436, -31.358206472150925],
          [115.503348881445731, -31.35823314064686],
          [115.503367613424643, -31.358260095127264],
          [115.503369873420979, -31.358263424417487],
          [115.503523964159626, -31.358490755943592],
          [115.503539882159885, -31.358514660822891],
          [115.503557505274671, -31.358542163889695],
          [115.503574565413942, -31.358569928659222],
          [115.503591057181552, -31.358597947037595],
          [115.50360697698045, -31.358626210031503],
          [115.503622319414603, -31.358654708647862],
          [115.50363707908798, -31.358683434792624],
          [115.503651252403415, -31.358712378573387],
          [115.503664833065613, -31.358741534594117],
          [115.503677820175312, -31.358770890264339],
          [115.503678638558426, -31.358772842692474],
          [115.50368715333957, -31.358782253198399],
          [115.503709069817774, -31.358807368565181],
          [115.503730470984465, -31.35883281038582],
          [115.503751351443725, -31.358858569667234],
          [115.503771702202357, -31.358884641013333],
          [115.503791519662968, -31.358911015430976],
          [115.50381079842964, -31.358937682128271],
          [115.503829528609913, -31.358964636608675],
          [115.503831784109593, -31.358967956905644],
          [115.503908830827982, -31.359081622219037],
          [115.503924755123421, -31.359105535192271],
          [115.503942378238207, -31.359133038259074],
          [115.503959438377478, -31.359160803028601],
          [115.503975931044465, -31.359188821406917],
          [115.503991850843249, -31.359217084400882],
          [115.50400719237814, -31.359245583017184],
          [115.504021952950779, -31.359274309162004],
          [115.504036125366952, -31.359303253842029],
          [115.504049707827789, -31.359332408963439],
          [115.504053657650275, -31.359341338332058],
          [115.504057111046905, -31.35934464783719],
          [115.50408101862422, -31.359368381845286],
          [115.504104439668254, -31.359392472884281],
          [115.504127365185809, -31.359416912860183],
          [115.504149789781081, -31.359441694578493],
          [115.504171706259285, -31.359466809045955],
          [115.504193107425976, -31.359492250866651],
          [115.504213986985974, -31.359518011047328],
          [115.504234338643869, -31.359544080594787],
          [115.504254157003857, -31.359570455012431],
          [115.504273434871152, -31.359597122609102],
          [115.504292165950801, -31.359624077988769],
          [115.504294423249121, -31.359627399185058],
          [115.504448517585047, -31.35985473071122],
          [115.504464440981224, -31.359878640986437],
          [115.50448206409601, -31.359906144053241],
          [115.504499125134544, -31.359933908822768],
          [115.50451561780153, -31.359961927201141],
          [115.504531537600428, -31.359990190195106],
          [115.504546880034582, -31.360018688811408],
          [115.504561640607335, -31.360047414956171],
          [115.50457581392277, -31.360076359636253],
          [115.504589394584968, -31.360105514757663],
          [115.50460238259393, -31.360134870427885],
          [115.504603200077668, -31.360136819258742],
          [115.504611717556827, -31.360146231563306],
          [115.504633634035031, -31.360171347829407],
          [115.504655036101099, -31.360196788750784],
          [115.504675915661096, -31.360222548931461],
          [115.504696268218254, -31.36024861937824],
          [115.504716085678865, -31.360274992896564],
          [115.504735364445537, -31.360301661392498],
          [115.504754096424449, -31.360328615872902],
          [115.504772276219683, -31.360355848243785],
          [115.504789900233732, -31.360383351310588],
          [115.504806960373003, -31.360411116080115],
          [115.504823453939366, -31.360439133559112],
          [115.504831655756334, -31.360453538899662],
          [115.504882784013375, -31.360544347943232],
          [115.504890501095815, -31.360558205596647],
          [115.504905844429231, -31.360586705112325],
          [115.504920604102608, -31.360615431257088],
          [115.504934777418157, -31.36064437593717],
          [115.504948359878995, -31.36067353105858],
          [115.50496134698858, -31.360702886728802],
          [115.504973735149861, -31.360732433954638],
          [115.504985519865954, -31.360762164642153],
          [115.504996698438958, -31.360792069798151],
          [115.505007266372331, -31.360822140429377],
          [115.50501722186732, -31.360852364844732],
          [115.505026560427495, -31.360882735849543],
          [115.505035280253992, -31.360913245349934],
          [115.50504337864902, -31.360943881654748],
          [115.505050852914565, -31.360974637569427],
          [115.505057700352609, -31.361005502302021],
          [115.505063919164627, -31.361036466859389],
          [115.505069507551752, -31.361067522248334],
          [115.505073305388805, -31.361091381262213],
          [115.505257721266844, -31.361418922445296],
          [115.50562106266193, -31.361846609433428],
          [115.506320766690123, -31.36250472521283],
          [115.50637798695459, -31.362560846505801],
          [115.506432777250893, -31.362619342008998],
          [115.506923510311822, -31.36316633485842],
          [115.506986291084559, -31.363240036098716],
          [115.507044954760886, -31.363317054938079],
          [115.507099327771812, -31.363397160250713],
          [115.507149246440576, -31.363480114615527],
          [115.507231888740762, -31.363626884872815],
          [115.507250754718598, -31.363643736369283],
          [115.507275615577214, -31.363666737429924],
          [115.507300006090418, -31.363690107212619],
          [115.50732391456711, -31.363713841220772],
          [115.507347337409783, -31.36373793136039],
          [115.507370264725978, -31.36376237043703],
          [115.50739269111989, -31.363787151255963],
          [115.507414607598093, -31.363812266622745],
          [115.507436010563538, -31.363837708443441],
          [115.507456892821438, -31.363863466825478],
          [115.507477246277972, -31.363889537272257],
          [115.507497066436486, -31.363915909891261],
          [115.507516345203271, -31.363942578387253],
          [115.507535078980823, -31.36396953196828],
          [115.507553260574582, -31.363996765238483],
          [115.507559273441757, -31.364006020161639],
          [115.507661895080446, -31.364165086849255],
          [115.507709274063814, -31.364242876407559],
          [115.50775234979119, -31.364323130108346],
          [115.507790993659455, -31.364405608731829],
          [115.50782509235421, -31.364490067662473],
          [115.507826577134892, -31.364494069645559],
          [115.508026972167045, -31.364670749555387],
          [115.508085674514291, -31.364724669307975],
          [115.508142064704543, -31.364781002840971],
          [115.508196043812404, -31.364839650329543],
          [115.508376789557246, -31.365044732628292],
          [115.508393609577524, -31.365064086038672],
          [115.508415013442232, -31.365089526960048],
          [115.508435894800755, -31.365115286241405],
          [115.508456248257289, -31.365141356688241],
          [115.508476068415916, -31.365167729307245],
          [115.508495348081965, -31.36519439690386],
          [115.508514081859403, -31.365221351384207],
          [115.508532264352539, -31.36524858375509],
          [115.508549889266078, -31.365276086821893],
          [115.508566952103251, -31.365303850692101],
          [115.508583446568878, -31.365331868171154],
          [115.508588043003897, -31.365340027720038],
          [115.508663130998798, -31.3654145203638],
          [115.509393979448646, -31.366058857630151],
          [115.509622553837858, -31.366231631784331],
          [115.509628917440637, -31.366234070745747],
          [115.509662033176369, -31.366247365423533],
          [115.509694871920829, -31.366261154728477],
          [115.509727424680932, -31.366275435962564],
          [115.509759678866203, -31.366290202830555],
          [115.509791627281857, -31.366305452634492],
          [115.509823258236793, -31.366321179978456],
          [115.509854563637305, -31.366337380365792],
          [115.509885532691214, -31.366354048400581],
          [115.509916156405552, -31.366371178686904],
          [115.509946425787007, -31.366388765828844],
          [115.509976330943005, -31.366406806229065],
          [115.510005863779611, -31.366425293592386],
          [115.51003501440448, -31.36644422072419],
          [115.510063773824186, -31.366463584027144],
          [115.510086813555631, -31.366479609945998],
          [115.510216788074331, -31.366571332700801],
          [115.510222107564232, -31.366575099061549],
          [115.510250059392774, -31.366595314921824],
          [115.510277594835202, -31.366615947168157],
          [115.510304704898317, -31.366636991304063],
          [115.510331380588809, -31.36665843923555],
          [115.510357617410136, -31.366680285566702],
          [115.510383402771936, -31.366702523102902],
          [115.510408731277948, -31.366725144649649],
          [115.510433594834581, -31.36674814481097],
          [115.510457985347784, -31.366771514593665],
          [115.510481897421641, -31.366795248601818],
          [115.510498546570716, -31.366812372592904],
          [115.510541420849904, -31.366845373215369],
          [115.510801015554534, -31.367051367426598],
          [115.510889363153638, -31.367125762044225],
          [115.510973150290738, -31.36720525941513],
          [115.511205795011506, -31.367439722565109],
          [115.511385711581397, -31.367563180596278],
          [115.511812254631877, -31.367769285424117],
          [115.511907009001334, -31.367817945042077],
          [115.511999249765609, -31.367871216383492],
          [115.512337690731897, -31.368078123406633],
          [115.512341826713964, -31.368080657696169],
          [115.512371359550684, -31.368099144160112],
          [115.512400511074816, -31.368118071291917],
          [115.512429272293161, -31.368137433695551],
          [115.512457633313147, -31.368157225975153],
          [115.512485586041066, -31.368177440936108],
          [115.512513122382757, -31.368198074081818],
          [115.512540233345135, -31.368219117318347],
          [115.512551637648016, -31.368228285906639],
          [115.512563185842396, -31.368234501121265],
          [115.512593811355373, -31.368251631407645],
          [115.512624081636091, -31.368269219448848],
          [115.512653987691465, -31.368287258050486],
          [115.512683521427448, -31.36830574541375],
          [115.512712672951579, -31.368324671646235],
          [115.512741433270548, -31.368344034049869],
          [115.512769794290648, -31.368363826329471],
          [115.51279774791783, -31.368384041290426],
          [115.51282528425952, -31.368404674436135],
          [115.512852395221898, -31.368425716773345],
          [115.512879072711144, -31.368447164704833],
          [115.512883313913903, -31.368450645081168],
          [115.513272544092729, -31.368770903554321],
          [115.513325324404263, -31.368815908327463],
          [115.513376475144241, -31.368862756710826],
          [115.513999330304955, -31.369454115814733],
          [115.51402620294698, -31.369466941046426],
          [115.514057835700669, -31.36948266659175],
          [115.51408914200033, -31.369498866979086],
          [115.514120112852993, -31.369515534114555],
          [115.51415073836597, -31.369532664400879],
          [115.514181010445327, -31.369550250643499],
          [115.514210917399964, -31.369568290144457],
          [115.514240450236684, -31.369586775709081],
          [115.514269602660079, -31.369605702840886],
          [115.514298363878424, -31.36962506524452],
          [115.514326725797787, -31.369644856624802],
          [115.514354679424969, -31.369665071585757],
          [115.514382215766659, -31.369685703832147],
          [115.514409327628414, -31.369706747068676],
          [115.514436006016922, -31.369728195000164],
          [115.514462242838249, -31.369750040431995],
          [115.514488030897951, -31.369772277068876],
          [115.514513361202717, -31.369794898615623],
          [115.514538225658612, -31.369817896978304],
          [115.514562617970455, -31.369841266761],
          [115.514586530943689, -31.369864999869776],
          [115.514609955585001, -31.369889089110131],
          [115.514632885599212, -31.369913527287395],
          [115.514642990381731, -31.369924579955352],
          [115.514746337773317, -31.370038543843691],
          [115.514758662082613, -31.370052271095403],
          [115.514780583057473, -31.370077384663546],
          [115.514801988720819, -31.370102824685546],
          [115.514822873676735, -31.370128583966959],
          [115.514843229831285, -31.370154654413739],
          [115.514863051788438, -31.370181025234103],
          [115.514882334152503, -31.370207691931398],
          [115.514901070627957, -31.370234646411745],
          [115.514919255819109, -31.370261877883308],
          [115.514936883430437, -31.370289379151473],
          [115.514953948066363, -31.37031714302168],
          [115.514970444330629, -31.370345161400053],
          [115.514986368626069, -31.370373421696002],
          [115.515001715556764, -31.370401919412984],
          [115.515016479726796, -31.370430645557803],
          [115.51503065843815, -31.370459589338509],
          [115.515037537352555, -31.370474354407861],
          [115.515086928119331, -31.370528815552348],
          [115.515524795433066, -31.370914789286076],
          [115.51560272168831, -31.370987377165704],
          [115.515676474189945, -31.371064201751437],
          [115.515986526257279, -31.371406088919798],
          [115.515998859559772, -31.371419825164764],
          [115.516020781434008, -31.371444938732907],
          [115.516042187097355, -31.371470378754907],
          [115.516063072053157, -31.371496137137001],
          [115.516083429107084, -31.37152220668446],
          [115.516103251963614, -31.371548578404145],
          [115.516122534327565, -31.37157524510144],
          [115.516141271702395, -31.371602198682467],
          [115.516159456893433, -31.37162943015403],
          [115.516177085404252, -31.371656932321514],
          [115.516194150040064, -31.371684696191721],
          [115.516210647203707, -31.371712712771455],
          [115.516226572398409, -31.371740974866043],
          [115.516227817060212, -31.371743285224397],
          [115.516244092990519, -31.371756370360174],
          [115.516270330711222, -31.371778214892686],
          [115.516296119670301, -31.371800452428886],
          [115.516321449974953, -31.371823073076314],
          [115.516346316229601, -31.371846071438995],
          [115.516370709440707, -31.371869441221691],
          [115.516394622413941, -31.371893173431147],
          [115.51641804795463, -31.371917262671502],
          [115.516440979767481, -31.371941700848765],
          [115.516451075556802, -31.371952745422846],
          [115.516554428344307, -31.372066706613168],
          [115.5165667616468, -31.372080441958758],
          [115.516588684420299, -31.37210555642622],
          [115.516610090083645, -31.372130996448277],
          [115.516630975039561, -31.372156753930994],
          [115.516651332093375, -31.372182822579134],
          [115.516671154949904, -31.372209195198138],
          [115.516690438213232, -31.37223586189549],
          [115.516709175588062, -31.372262814577198],
          [115.5167273607791, -31.372290046948081],
          [115.516744989289919, -31.372317549115564],
          [115.516762054824994, -31.372345312086452],
          [115.516778552888013, -31.372373328666129],
          [115.516792470795963, -31.372398029445435],
          [115.516811576892792, -31.372415129154831],
          [115.516836442248064, -31.372438128416832],
          [115.516860836358546, -31.372461497300208],
          [115.51688474933178, -31.37248523040904],
          [115.516908175771732, -31.372509318750019],
          [115.516931107584583, -31.372533756927282],
          [115.516953537575773, -31.372558536846952],
          [115.516975458550633, -31.372583650415095],
          [115.516996866012619, -31.372609090437152],
          [115.517017750968535, -31.372634848819189],
          [115.517038108921611, -31.372660916568009],
          [115.517046144364144, -31.372671486300021],
          [115.517200644294348, -31.372876252037372],
          [115.517212431708458, -31.372892054924364],
          [115.517231714971786, -31.372918721621659],
          [115.517250452346616, -31.372945675202686],
          [115.517268638437031, -31.372972906674249],
          [115.517286266048359, -31.373000408841733],
          [115.517303331583548, -31.373028171812621],
          [115.517319831445093, -31.373056188392354],
          [115.517335755740646, -31.373084449587623],
          [115.517338855703656, -31.373090206148049],
          [115.517348248223129, -31.373099527621036],
          [115.517371674663082, -31.373123616861392],
          [115.517394605576669, -31.373148055038655],
          [115.517417035567746, -31.373172834059005],
          [115.517438958341359, -31.373197947627148],
          [115.517460365803345, -31.373223387649205],
          [115.517481251658523, -31.373249146031242],
          [115.517483393843577, -31.373251843098046],
          [115.517663821228439, -31.373479462407204],
          [115.517718997333873, -31.37355282280447],
          [115.517770253294657, -31.373628974697397],
          [115.517817447017592, -31.373707709443181],
          [115.517958860912813, -31.373958768682201],
          [115.5180940083319, -31.374132393595062],
          [115.518377295675691, -31.374417838412455],
          [115.518450976231634, -31.374496418474905],
          [115.518519894877272, -31.37457920826381],
          [115.518583809695087, -31.374665918197536],
          [115.518866538560019, -31.375075144802054],
          [115.518923051957358, -31.375162342168323],
          [115.518974133449547, -31.375252828355315],
          [115.519019593279722, -31.3753462652179],
          [115.519119693219295, -31.375569646921633],
          [115.519127708876681, -31.37557680462578],
          [115.519152576929969, -31.375599802988461],
          [115.519176971040451, -31.375623171871837],
          [115.519200885812324, -31.375646904081293],
          [115.51922431315154, -31.375670993321648],
          [115.519247245863767, -31.375695430599592],
          [115.51926967675422, -31.375720211418582],
          [115.519291600427096, -31.375745323188085],
          [115.519313007889082, -31.375770763210085],
          [115.519333894643637, -31.375796520692859],
          [115.519354252596713, -31.375822590240318],
          [115.519374077251882, -31.375848961060683],
          [115.519393362313849, -31.375875627757978],
          [115.519402405896358, -31.375888503351689],
          [115.519608063761211, -31.376184070038732],
          [115.519650941637678, -31.376248681831157],
          [115.519690858046715, -31.376315163314075],
          [115.519727731149942, -31.376383379589242],
          [115.519931506733656, -31.376782168662089],
          [115.520063693584689, -31.376973487736223],
          [115.520266811764031, -31.377182421831264],
          [115.520325957476985, -31.37724613070435],
          [115.520382011320862, -31.377312574415726],
          [115.520434849188973, -31.377381603678032],
          [115.520666444400945, -31.377700023037562],
          [115.520724710577042, -31.377785232902113],
          [115.520777748094702, -31.377873791841978],
          [115.520825366297686, -31.377965378799161],
          [115.520846162220664, -31.378008607411232],
          [115.520848198285762, -31.378010558040785],
          [115.520872113957012, -31.378034290250241],
          [115.520895542195603, -31.378058378591277],
          [115.520918475807093, -31.37808281586922],
          [115.520940907596923, -31.37810759488957],
          [115.520962832169062, -31.378132707558336],
          [115.520984241429687, -31.378158147580393],
          [115.521005128184129, -31.378183905063111],
          [115.521025487935958, -31.37820997371125],
          [115.521045312591127, -31.378236345430935],
          [115.521064597653094, -31.378263011228967],
          [115.521083336826564, -31.378289963910674],
          [115.521101524715618, -31.378317195382238],
          [115.521119155025076, -31.378344696650402],
          [115.5211237901309, -31.37835212055387],
          [115.521405836410281, -31.378806439165771],
          [115.521434662379875, -31.378854610451867],
          [115.521461887556143, -31.378903705341656],
          [115.521895249266436, -31.379716667290324],
          [115.521946734554263, -31.379799598272825],
          [115.521951995588211, -31.379804462705749],
          [115.521976390597956, -31.379827830689806],
          [115.522000308067845, -31.379851562899262],
          [115.522023736306437, -31.379875651240241],
          [115.522046670817303, -31.379900089417561],
          [115.522069104405659, -31.379924868437911],
          [115.522091028078535, -31.379949980207357],
          [115.52211243733916, -31.379975419330094],
          [115.522133324992978, -31.380001177712131],
          [115.522153685644184, -31.380027246360271],
          [115.522173511198616, -31.380053617180636],
          [115.52219279715996, -31.380080282978611],
          [115.522211537232693, -31.380107235660375],
          [115.522229725121747, -31.380134467131882],
          [115.52224251617929, -31.380154304377584],
          [115.522473419812513, -31.380517818442513],
          [115.522509924193741, -31.380577963302301],
          [115.52254391766769, -31.380639562365843],
          [115.522862515093038, -31.381246405996819],
          [115.522875611919972, -31.381258517166771],
          [115.522900007829207, -31.381281885150827],
          [115.522923925298983, -31.381305617360283],
          [115.522947354436951, -31.381329705701319],
          [115.522970288947704, -31.381354142979262],
          [115.52299272343555, -31.381378921999612],
          [115.523014647108312, -31.381404034668435],
          [115.523036057268314, -31.381429473791115],
          [115.523056945821509, -31.381455231273833],
          [115.523077305573224, -31.38148129902271],
          [115.523097132926409, -31.381507670742394],
          [115.523116418887639, -31.381534337439689],
          [115.523135158960486, -31.381561289222077],
          [115.523153347748917, -31.38158851979432],
          [115.523170978957523, -31.381616021062484],
          [115.523188047190729, -31.381643784033372],
          [115.523204547951536, -31.381671800613049],
          [115.523220475844369, -31.381700061808374],
          [115.523235826372343, -31.381728558626037],
          [115.523250594139654, -31.38175728297216],
          [115.523262948126671, -31.381782417224713],
          [115.523339330245904, -31.38194117094821],
          [115.523341157668369, -31.381944979577099],
          [115.523354747323765, -31.38197413379919],
          [115.523367741628022, -31.382003487670772],
          [115.523380136983747, -31.382033033997288],
          [115.523391928894512, -31.382062763785484],
          [115.523403113762697, -31.382092667142842],
          [115.523413688890741, -31.382122735975429],
          [115.523423651580288, -31.382152958592144],
          [115.523432996435645, -31.382183329596955],
          [115.52343392543537, -31.382186576149536],
          [115.523476936411498, -31.38225171584395],
          [115.523733426656349, -31.382660628585086],
          [115.523765643969341, -31.382714122059042],
          [115.523795880975172, -31.382768758571331],
          [115.524175327429475, -31.383485302404722],
          [115.524196971413176, -31.383519807593018],
          [115.524207106772565, -31.383529180327344],
          [115.524231503581063, -31.3835525483114],
          [115.524255421950215, -31.383576279621536],
          [115.524278851987447, -31.383600367962572],
          [115.524301787397576, -31.383624805240515],
          [115.524324221885422, -31.383649583361546],
          [115.524346147356823, -31.383674696030369],
          [115.524367558416202, -31.383700135153049],
          [115.524388446969283, -31.383725892635766],
          [115.524408809419128, -31.383751961283963],
          [115.524428635872937, -31.383778332104328],
          [115.524447922733543, -31.383804997902303],
          [115.524466663705653, -31.383831949684691],
          [115.524484851594707, -31.383859181156254],
          [115.524502484602067, -31.383886682424418],
          [115.524519553734535, -31.383914443596666],
          [115.524536055394719, -31.383942461075662],
          [115.524544231131472, -31.383956809758899],
          [115.524672127316876, -31.384183813931827],
          [115.52471288549134, -31.384260696074193],
          [115.524749549951821, -31.384339613382394],
          [115.524782019075019, -31.384420347321111],
          [115.524888219116065, -31.384706400080233],
          [115.524906147101092, -31.384738219892881],
          [115.524976924645443, -31.384816240576981],
          [115.525041664141554, -31.384891483255331],
          [115.525102095885131, -31.384970226094993],
          [115.52515803101835, -31.385052224480546],
          [115.525209295972331, -31.385137221205753],
          [115.525311618136698, -31.385318825803097],
          [115.525319376588072, -31.385332749107022],
          [115.525334728015309, -31.385361245924742],
          [115.525349496681997, -31.385389970270865],
          [115.52536367899063, -31.38541891315225],
          [115.525377270444778, -31.385448065575702],
          [115.525381600680362, -31.3854578501996],
          [115.525387534407287, -31.385466382067818],
          [115.525389744940867, -31.385469634915694],
          [115.525621023591384, -31.385810593084386],
          [115.52565996243743, -31.385870610240431],
          [115.525696378684984, -31.385932190418202],
          [115.526009292394974, -31.38648755325795],
          [115.526028221325419, -31.386504452418478],
          [115.526053092975872, -31.386527449881839],
          [115.52607749158301, -31.386550817865896],
          [115.526101409952162, -31.386574549176032],
          [115.52612484088877, -31.386598638416388],
          [115.526147777198275, -31.386623073895692],
          [115.526170212585271, -31.386647852016722],
          [115.526192138956162, -31.386672964685545],
          [115.52621355091469, -31.386698402908905],
          [115.526234441266524, -31.386724160391623],
          [115.526254803716256, -31.3867502281405],
          [115.526274631069441, -31.386776598960807],
          [115.526293919728687, -31.386803264758839],
          [115.526312661600059, -31.386830217440547],
          [115.526330851287867, -31.38685744801279],
          [115.526336833578057, -31.386866649875969],
          [115.526542186572669, -31.387184757170758],
          [115.526584290132973, -31.387253441093378],
          [115.526623105771819, -31.38732403427673],
          [115.526866138561559, -31.387792138596296],
          [115.526874506753188, -31.387799874564507],
          [115.526898906259589, -31.387823243447883],
          [115.526922826427381, -31.38784697475802],
          [115.526946255565349, -31.387871062199736],
          [115.526969193673381, -31.387895498578359],
          [115.52699162906049, -31.38792027759871],
          [115.527013556330644, -31.387945389368156],
          [115.527034968289172, -31.387970827591573],
          [115.527055860439646, -31.387996585074291],
          [115.527076221990114, -31.388022652823111],
          [115.527096050242562, -31.388049023643475],
          [115.527115338901808, -31.38807568944145],
          [115.527134080773294, -31.388102641223895],
          [115.527152271360251, -31.388129871796082],
          [115.527169905266987, -31.388157373064246],
          [115.52717795419926, -31.388170317006484],
          [115.527331796725093, -31.388420170254619],
          [115.527386378378765, -31.388515549652823],
          [115.527434624308512, -31.388614285320955],
          [115.527539076067569, -31.38884729426718],
          [115.527611106367544, -31.388924214181088],
          [115.52767851774945, -31.389005211621168],
          [115.527741081785507, -31.389090010495522],
          [115.527798582638525, -31.389178320323197],
          [115.527978010876609, -31.389473574046178],
          [115.528023528263247, -31.389553216207901],
          [115.528064649763792, -31.389635213694135],
          [115.528241162399809, -31.390012769773477],
          [115.528255908583333, -31.390027401743168],
          [115.528279342217957, -31.390051489184827],
          [115.528302279426725, -31.390075925563451],
          [115.528324715713097, -31.390100703684482],
          [115.528346643882514, -31.390125816353304],
          [115.528368056740533, -31.390151254576665],
          [115.52838894799163, -31.390177011160119],
          [115.528409311340738, -31.390203078908939],
          [115.528429139593186, -31.390229449729304],
          [115.528448430051071, -31.390256116426599],
          [115.52846717282182, -31.390283067309667],
          [115.528469379758121, -31.390286312063608],
          [115.528700680891802, -31.390627266635022],
          [115.528739621536374, -31.390687281992427],
          [115.528776039582567, -31.39074885857292],
          [115.529134206278627, -31.391384463422185],
          [115.529166136707886, -31.39144386454268],
          [115.529195651558098, -31.39150450313025],
          [115.529373683149061, -31.391889950760572],
          [115.529377900969394, -31.391899157120349],
          [115.529390897971666, -31.391928510991931],
          [115.529403296025407, -31.391958056419128],
          [115.529415090633961, -31.391987786207324],
          [115.529426278200276, -31.392017688665362],
          [115.529428209044681, -31.392023177227827],
          [115.529438657368246, -31.392034229895728],
          [115.529498024314421, -31.392100030591905],
          [115.529554079956938, -31.392168674944344],
          [115.529606688497893, -31.392239994779914],
          [115.529655722233883, -31.392313819227354],
          [115.529783993436581, -31.392518269302627],
          [115.529800649780213, -31.392545368573849],
          [115.529817153239037, -31.392573385153582],
          [115.529833084729148, -31.392601645449531],
          [115.529848437955138, -31.392630142267194],
          [115.529863209319728, -31.392658866613374],
          [115.529877393427, -31.39268780859544],
          [115.529890985780412, -31.392716961918211],
          [115.529895309720814, -31.392726726757019],
          [115.529937501414565, -31.392790673051081],
          [115.530065771718, -31.392995122227092],
          [115.530112272063775, -31.393073783228488],
          [115.53015442688536, -31.393154856211595],
          [115.530192112076406, -31.393238101057477],
          [115.530227575042659, -31.393322640027748],
          [115.530303441850378, -31.393407107052326],
          [115.530373847974715, -31.393496176807048],
          [115.530438513726494, -31.393589496757841],
          [115.530746584587291, -31.394066645559178],
          [115.53079998722967, -31.394155059708169],
          [115.531271600703917, -31.394991922039537],
          [115.531510080226099, -31.39533450888041],
          [115.531650241365583, -31.395457991193268],
          [115.531719571001418, -31.395522057097196],
          [115.531785579441021, -31.395589540424908],
          [115.531848099410354, -31.39566026850656],
          [115.531906969930787, -31.395734060578377],
          [115.532267631346144, -31.396211811026205],
          [115.532321021398047, -31.396286470044515],
          [115.532370429251955, -31.39636382343167],
          [115.532733469374193, -31.396966960057114],
          [115.533011043325018, -31.397334637083816],
          [115.533330433952415, -31.397651253302627],
          [115.533391495221395, -31.397714647413011],
          [115.533449464621185, -31.397780881582378],
          [115.533504209951388, -31.397849803825352],
          [115.533710310282686, -31.398122802025625],
          [115.53372213996488, -31.398138652576733],
          [115.533741431322028, -31.398165318374708],
          [115.533760176790793, -31.398192269257777],
          [115.533778370975142, -31.39821949983002],
          [115.533796007579781, -31.398246999299545],
          [115.533813081208791, -31.398274761371113],
          [115.533829587365631, -31.39830277705147],
          [115.533845519755005, -31.398331036448155],
          [115.533860874779634, -31.398359533265818],
          [115.533866973981731, -31.3983713917263],
          [115.533870970568842, -31.398375968376172],
          [115.533892387024139, -31.39840140570027],
          [115.533913280973252, -31.398427162283667],
          [115.533933647020262, -31.398453229133167],
          [115.533941643791877, -31.398463740409227],
          [115.534096221063805, -31.398668487260807],
          [115.534145986847875, -31.398737734159056],
          [115.534192263262412, -31.398809359764073],
          [115.534234936992789, -31.398883187808849],
          [115.53427390371769, -31.398959039328133],
          [115.534295644828262, -31.399004205979281],
          [115.534299073043826, -31.399006865274544],
          [115.534325762224171, -31.399028309608752],
          [115.534352010736711, -31.399050152342625],
          [115.534377808688987, -31.399072385382226],
          [115.534403149785589, -31.399095004231015],
          [115.534428025932698, -31.399117999895736],
          [115.534452429036378, -31.399141366980473],
          [115.534476351902185, -31.39916509739129],
          [115.534499788234712, -31.399189183933629],
          [115.534522729040759, -31.39921361941299],
          [115.534545168924524, -31.399238396634644],
          [115.534567099791843, -31.399263508404147],
          [115.534572061351582, -31.399269318024551],
          [115.534726991157754, -31.399451516174508],
          [115.534788166640624, -31.399527296647364],
          [115.534844991203499, -31.399606392021326],
          [115.534897284981753, -31.399688553184149],
          [115.534944883399703, -31.399773521131067],
          [115.534987636270444, -31.399861027864119],
          [115.534999698877073, -31.399871654253388],
          [115.535081262890003, -31.399947655959522],
          [115.535158114455498, -31.400028421374486],
          [115.53522997388427, -31.400113657319366],
          [115.535296583970194, -31.400203056226019],
          [115.535502344357724, -31.400498600430012],
          [115.535548002038695, -31.40056758022962],
          [115.535590278268842, -31.400638683328509],
          [115.535629075021802, -31.400711744251566],
          [115.535757019770699, -31.400967801023171],
          [115.535826825147979, -31.401057424760324],
          [115.536056191839862, -31.401259470947764],
          [115.536114929260634, -31.401313375411917],
          [115.536171355423789, -31.40136969545506],
          [115.536225371403816, -31.401428330353099],
          [115.53640624844968, -31.401633375779625],
          [115.53646843836782, -31.401707557257907],
          [115.536526424854628, -31.401785068925733],
          [115.536580030743835, -31.401865672462748],
          [115.536629090560155, -31.40194912145472],
          [115.536673454116681, -31.402035157796263],
          [115.536872252852277, -31.402235436815886],
          [115.536946091688833, -31.402314186850219],
          [115.53701520998402, -31.402397109738786],
          [115.537247271044748, -31.402692951618405],
          [115.537259482039531, -31.402708697848084],
          [115.537279315687897, -31.402735067769129],
          [115.537298609743061, -31.402761731768464],
          [115.537317357010465, -31.402788682651533],
          [115.537335552094078, -31.402815912324456],
          [115.537353189598093, -31.402843411793981],
          [115.537370265925119, -31.402871173865549],
          [115.537386772981222, -31.402899188646586],
          [115.537402708068612, -31.402927448043272],
          [115.53740391136148, -31.402929681059902],
          [115.537420275425461, -31.402942827349534],
          [115.537446523938002, -31.402964669184087],
          [115.53747232458818, -31.402986902223688],
          [115.537497666584159, -31.403009520173157],
          [115.537522545429169, -31.403032515837879],
          [115.537546949432226, -31.403055882023295],
          [115.537570874096673, -31.403079612434112],
          [115.537594311328462, -31.403103698077189],
          [115.537617253933149, -31.403128133556493],
          [115.537639694716177, -31.403152909878827],
          [115.537661627382249, -31.40317802074901],
          [115.537683044736809, -31.403203458073108],
          [115.537694758406474, -31.40321777617936],
          [115.537823759858725, -31.403377121656774],
          [115.537832942836076, -31.403388560133919],
          [115.537853311581102, -31.40341462698342],
          [115.537873145229582, -31.403440996005145],
          [115.53789243838537, -31.40346766000448],
          [115.537911186552037, -31.403494610887549],
          [115.537929381635763, -31.403521840560472],
          [115.537947020039041, -31.403549340029997],
          [115.537964096366068, -31.403577102101565],
          [115.53798060342217, -31.403605116882602],
          [115.537996539408823, -31.403633376279231],
          [115.537999598902388, -31.403639054598671],
          [115.53800906426693, -31.403648444420128],
          [115.538032500599456, -31.403672529163828],
          [115.53805544410352, -31.403696964643132],
          [115.53807788578581, -31.403721740965523],
          [115.53809981755262, -31.403746851835706],
          [115.53812123670582, -31.403772289159747],
          [115.538132944979452, -31.403786601870138],
          [115.538261949129719, -31.403945946448232],
          [115.538271136603726, -31.403957389421919],
          [115.538291505348752, -31.403983456271419],
          [115.538311338997119, -31.404009826192464],
          [115.538330633052283, -31.4040364901918],
          [115.538349380319687, -31.404063441074925],
          [115.538367576302676, -31.404090670747792],
          [115.538385215605331, -31.404118170217316],
          [115.53840229103298, -31.404145931389564],
          [115.538418798988459, -31.404173946170658],
          [115.538434734075736, -31.404202205567287],
          [115.538450090899005, -31.404230700586311],
          [115.538464865860988, -31.404259424932491],
          [115.538479053565538, -31.404288366914557],
          [115.538485901003583, -31.404303049246266],
          [115.538535323246606, -31.404357504095515],
          [115.538973440571908, -31.404743399588199],
          [115.539046173242355, -31.404810840647713],
          [115.539115308624673, -31.40488196443107],
          [115.539451628989582, -31.405246792405478],
          [115.539519291282318, -31.405324302274664],
          [115.539582356240771, -31.405405595591731],
          [115.539640614322934, -31.405490400761323],
          [115.539693870375913, -31.405578433597782],
          [115.539711960238833, -31.405610523207031],
          [115.539715681633425, -31.405613212179958],
          [115.539743232364344, -31.405633840829069],
          [115.539770358615215, -31.405654879568999],
          [115.539797049594199, -31.405676323003831],
          [115.539823301704018, -31.405698164838384],
          [115.539849102354196, -31.405720396978666],
          [115.539874446148815, -31.405743014928134],
          [115.539899324993939, -31.405766009693536],
          [115.539923730795635, -31.405789375878953],
          [115.539947657258608, -31.40581310539045],
          [115.539971095389774, -31.40583719103347],
          [115.539994038893838, -31.40586162741215],
          [115.540004067234008, -31.405872586550572],
          [115.540107485672024, -31.40598653155314],
          [115.54011989991352, -31.406000347837733],
          [115.540141832579593, -31.406025457808596],
          [115.540163251732793, -31.406050895132637],
          [115.540184149279071, -31.406076650816715],
          [115.540204518024098, -31.406102716766895],
          [115.54022435257184, -31.406129085788621],
          [115.540243648425644, -31.406155749787956],
          [115.540257749795387, -31.406176021406225],
          [115.54026185340183, -31.406179204106934],
          [115.540288545280191, -31.406200648441143],
          [115.540314795591371, -31.406222487577679],
          [115.540340598040189, -31.406244722415977],
          [115.540365941834807, -31.406267338566749],
          [115.540390820679931, -31.406290334231471],
          [115.54041522738089, -31.406313700416888],
          [115.5404391529446, -31.406337429029065],
          [115.540462591975142, -31.406361515571461],
          [115.54048553457983, -31.406385950151446],
          [115.540507978060759, -31.40641072557446],
          [115.540529913424848, -31.406435837343963],
          [115.5405348534008, -31.406441622682678],
          [115.540689806589398, -31.406623813638021],
          [115.540706284867269, -31.406643464724084],
          [115.540727182413548, -31.406669220408162],
          [115.540747552057951, -31.406695286358342],
          [115.540767386605694, -31.406721655380068],
          [115.540786681560121, -31.406748319379403],
          [115.540805430626165, -31.406775270262472],
          [115.540823628407793, -31.406802499036075],
          [115.540841267710448, -31.40682999940492],
          [115.54085834403736, -31.406857759677848],
          [115.540874852892216, -31.406885773559566],
          [115.540890788878869, -31.406914033855514],
          [115.54090614840004, -31.406942529773914],
          [115.5409122368103, -31.406954366650666],
          [115.54091624958528, -31.406958961286989],
          [115.540937668738479, -31.406984397711767],
          [115.540958566284871, -31.407010153395845],
          [115.540978935929161, -31.407036219346026],
          [115.54099877137628, -31.407062589267014],
          [115.541018066330707, -31.407089252367086],
          [115.541036815396751, -31.407116203250155],
          [115.541055012279003, -31.407143432923021],
          [115.541072651581658, -31.407170930593907],
          [115.541089728807947, -31.407198692665474],
          [115.541106238562065, -31.407226707446569],
          [115.54111438282257, -31.407240992277934],
          [115.54124235095378, -31.407467982061689],
          [115.54128313430931, -31.407544862405416],
          [115.541319823051481, -31.407623779713617],
          [115.541352315556992, -31.407704514551654],
          [115.541429971116372, -31.407913529585699],
          [115.541443633616836, -31.407926156966539],
          [115.541468040317909, -31.407949522252579],
          [115.541491966780882, -31.407973251764133],
          [115.541515405811424, -31.407997337407153],
          [115.541538350214751, -31.408021771987137],
          [115.54156079369568, -31.408046548309528],
          [115.541582728160392, -31.408071658280335],
          [115.541604147313592, -31.408097095604433],
          [115.541625045759361, -31.408122850389191],
          [115.54164541540365, -31.408148916339371],
          [115.541665250850656, -31.408175285361096],
          [115.541672091993519, -31.408184621223256],
          [115.541903832895628, -31.40850300460994],
          [115.541960667350963, -31.40858596167277],
          [115.542012604098431, -31.408672069060685],
          [115.542268546656146, -31.409126045930236],
          [115.542313591898846, -31.409211580450005],
          [115.542353602736625, -31.409299581810217],
          [115.542505775221457, -31.409662165076838],
          [115.542511841148666, -31.409676816831563],
          [115.542523641153139, -31.40970654482112],
          [115.542534834115372, -31.409736447279158],
          [115.542545417337237, -31.409766514313162],
          [115.542555386322078, -31.40979673782914],
          [115.54256473927137, -31.409827107934632],
          [115.542573472587719, -31.409857614737064],
          [115.542579793023037, -31.409881482744197],
          [115.542591357405286, -31.409896280189116],
          [115.542611192852291, -31.409922649210841],
          [115.542630488706095, -31.409949313210177],
          [115.542649238671515, -31.409976263193926],
          [115.542667435553767, -31.410003492866849],
          [115.542685077554324, -31.410030991437054],
          [115.54270215567999, -31.410058752609302],
          [115.542718665434109, -31.410086767390339],
          [115.542726810593877, -31.410101054020402],
          [115.542829190314933, -31.41028264512795],
          [115.542836981141818, -31.410296616995254],
          [115.542852340663103, -31.410325112913597],
          [115.542867117423611, -31.410353834561761],
          [115.542881306027539, -31.410382777443203],
          [115.542894904676132, -31.410411928967278],
          [115.542907907074323, -31.410441281939541],
          [115.542920311423245, -31.410470825568098],
          [115.542929218308814, -31.410493267250445],
          [115.542943925821533, -31.410512819411053],
          [115.54296322167545, -31.410539483410389],
          [115.542981971640756, -31.410566431595498],
          [115.543000170321648, -31.410593662167742],
          [115.543017811422942, -31.410621160737946],
          [115.543034888649231, -31.410648921910195],
          [115.543051399302726, -31.410676935791912],
          [115.543067336188642, -31.410705195188541],
          [115.543082695709927, -31.410733691106941],
          [115.543097471571173, -31.410762413654425],
          [115.543109798578371, -31.410787472363893],
          [115.543186235556391, -31.410946214396233],
          [115.5432221077142, -31.41102588623562],
          [115.543253588482344, -31.411107392691974],
          [115.543280584331569, -31.411190492746982],
          [115.54330301432276, -31.41127493998647],
          [115.543320812805291, -31.411360482600173],
          [115.543336672349596, -31.411449341913567],
          [115.543463351752393, -31.411645458870794],
          [115.543511821613379, -31.41172495084578],
          [115.543555749898019, -31.411807040062797],
          [115.543594999010111, -31.411891466617874],
          [115.543629444843077, -31.411977963412255],
          [115.54365897857906, -31.4120662588507],
          [115.543734024305877, -31.41231519658902],
          [115.543735845432934, -31.41232128230132],
          [115.54374457964866, -31.412351789103752],
          [115.543752692432918, -31.412382425408566],
          [115.543760179288938, -31.412413178625229],
          [115.543765317115799, -31.412436291201857],
          [115.543778359084058, -31.412456621276021],
          [115.543795437209724, -31.41248438244827],
          [115.543811947863219, -31.412512396329987],
          [115.543827885648511, -31.412540655726616],
          [115.543843245169683, -31.412569150745639],
          [115.54384763026394, -31.412577534225761],
          [115.544000857653486, -31.412872467790123],
          [115.544043382096447, -31.4129604160903],
          [115.544080533090209, -31.413050764680975],
          [115.544112176635736, -31.413143186209027],
          [115.544138199418398, -31.41323734522723],
          [115.5441873887371, -31.413439811398121],
          [115.544199450444353, -31.413453099780668],
          [115.544263696212624, -31.413527589726414],
          [115.544323671100642, -31.413605560048495],
          [115.544379186250467, -31.413686765232001],
          [115.54443006809322, -31.413770951668027],
          [115.544476157448798, -31.413857854956007],
          [115.544654637801386, -31.414220734099558],
          [115.544691833761135, -31.414301763915205],
          [115.544724537607408, -31.414384709286878],
          [115.544752651313843, -31.414469320202898],
          [115.544824482863646, -31.414707585686472],
          [115.544836474423846, -31.414722362447037],
          [115.544856845866775, -31.414748426598578],
          [115.544876683112534, -31.414774797418943],
          [115.544895980764977, -31.414801459619639],
          [115.54491473162966, -31.414828411402027],
          [115.544932931209814, -31.414855638376991],
          [115.544950573210485, -31.414883137846516],
          [115.544967652235414, -31.414910898119388],
          [115.544970611904319, -31.414915831800158],
          [115.545201335673141, -31.415301857694544],
          [115.545235517105539, -31.415361763334658],
          [115.545267226301462, -31.415423012561916],
          [115.545585651056967, -31.416070401228012],
          [115.545592708936397, -31.416081642753568],
          [115.545605547657942, -31.416092705314043],
          [115.54563089504984, -31.416115320565552],
          [115.545655776592866, -31.416138316230274],
          [115.545680186891218, -31.416161682415691],
          [115.545704116052207, -31.416185410128548],
          [115.545727558679914, -31.416209494872248],
          [115.545750505781257, -31.416233928552913],
          [115.54577295106094, -31.416258704875304],
          [115.545777952190747, -31.416264349020423],
          [115.54595887600135, -31.416469380957096],
          [115.546016281526249, -31.416537688963103],
          [115.54607021386937, -31.416608771377639],
          [115.546120539031676, -31.416682451034262],
          [115.546326020629408, -31.417000528651442],
          [115.546370678264225, -31.417073542809703],
          [115.546411583927465, -31.417148722535501],
          [115.546448632398551, -31.417225876273108],
          [115.546702877036182, -31.417792592154342],
          [115.546743678378107, -31.4178921740845],
          [115.547001486129716, -31.418585886829192],
          [115.54715268195082, -31.418854014301303],
          [115.547341347125553, -31.41904393043302],
          [115.547405578504709, -31.41911185262984],
          [115.547466269252936, -31.419182957527426],
          [115.54752326019036, -31.419257060764721],
          [115.547755044259929, -31.419575434258832],
          [115.5477675133601, -31.419592778583819],
          [115.547786266023422, -31.419619728567568],
          [115.547804467402329, -31.419646958240492],
          [115.547822110302263, -31.419674456810696],
          [115.547839190226455, -31.419702217083625],
          [115.547855703577966, -31.419730230965342],
          [115.547871643161898, -31.419758488563332],
          [115.547887003582446, -31.419786983582355],
          [115.547901783940233, -31.419815707029215],
          [115.547915975242177, -31.419844649011281],
          [115.547929576588785, -31.419873799636093],
          [115.547942581684879, -31.419903152608356],
          [115.54794334161204, -31.419904962044313],
          [115.547951977801631, -31.419914494858006],
          [115.547973916762885, -31.419939603929549],
          [115.54799534041274, -31.419965040354271],
          [115.548016241556411, -31.419990795139029],
          [115.548036614797979, -31.420016860189889],
          [115.548056453842378, -31.420043228312295],
          [115.548068363564198, -31.420059559101333],
          [115.548248605688627, -31.420309688441307],
          [115.548302711600968, -31.420389273046453],
          [115.54835232090295, -31.420471734582861],
          [115.54846019278375, -31.42066302397933],
          [115.548472460435733, -31.42067127435979],
          [115.548500841240866, -31.420691059444778],
          [115.548528814653082, -31.420711269009814],
          [115.54855637077992, -31.420731895860285],
          [115.548583502426709, -31.420752933700896],
          [115.548610200600365, -31.420774375337089],
          [115.548636456307463, -31.420796215373002],
          [115.548662263252936, -31.420818448412604],
          [115.54866544055767, -31.420821239008944],
          [115.548769231315077, -31.420912628115275],
          [115.54879140230139, -31.420932451871124],
          [115.548816287441809, -31.420955446636526],
          [115.548840697740047, -31.420978811023247],
          [115.548864628699675, -31.421002538736104],
          [115.54888807222676, -31.421026622580541],
          [115.548911021126742, -31.421051057160525],
          [115.548933468205064, -31.42107583258354],
          [115.548955407166318, -31.421100942554403],
          [115.548976830816173, -31.421126378079862],
          [115.548997732859107, -31.42115213286462],
          [115.549018107000052, -31.421178197915481],
          [115.549037946943713, -31.421204566037829],
          [115.549057246394909, -31.421231229137845],
          [115.549075999957495, -31.421258179121651],
          [115.549094201336402, -31.421285406995878],
          [115.549099328371312, -31.421293398371574],
          [115.549110053686036, -31.421305673218228],
          [115.549131477335891, -31.42133110874363],
          [115.549152379378825, -31.421356864427707],
          [115.549172754419146, -31.421382928579249],
          [115.549192592564168, -31.421409296701654],
          [115.549211892914627, -31.42143595980167],
          [115.549220870846625, -31.421448729275369],
          [115.549426719367716, -31.421744251895689],
          [115.549472040702199, -31.421812684907422],
          [115.549514065122025, -31.421883190856533],
          [115.54976457037867, -31.4223273902968],
          [115.549890560900735, -31.422494181261413],
          [115.550057600977539, -31.422641254590189],
          [115.550126962089735, -31.422705310601543],
          [115.550193002005471, -31.422772784936058],
          [115.550255552551789, -31.422843504923776],
          [115.55031445634711, -31.422917291599674],
          [115.550469105564844, -31.423122021364179],
          [115.550480985609056, -31.423137928572487],
          [115.550500285959515, -31.423164592571823],
          [115.550519040421477, -31.423191541656252],
          [115.550537241800384, -31.423218770429855],
          [115.550554885599581, -31.423246268100741],
          [115.550571968221789, -31.423274028373669],
          [115.550588481573186, -31.423302042255386],
          [115.550604422955871, -31.423330300752752],
          [115.550619785175058, -31.423358795771776],
          [115.550634566432109, -31.42338751741994],
          [115.550648758633315, -31.423416459402063],
          [115.550662360879301, -31.423445610026818],
          [115.55066666143739, -31.423455312812393],
          [115.550672650022875, -31.423463920223696],
          [115.550690852301045, -31.4234911489973],
          [115.550708496999619, -31.423518646668185],
          [115.550725578722563, -31.423546406941057],
          [115.550742092973223, -31.423574420822831],
          [115.550750221945236, -31.42358867417795],
          [115.550852631343901, -31.423770258990203],
          [115.550892576531282, -31.423845378461408],
          [115.550928583587279, -31.423922463850602],
          [115.550960555385359, -31.424001308313677],
          [115.550988405590488, -31.424081701409364],
          [115.550996757594362, -31.424108077625647],
          [115.551007989227401, -31.424117966570861],
          [115.55107735123886, -31.424182021682896],
          [115.551143392953236, -31.424249494218714],
          [115.551205945298193, -31.424320213307169],
          [115.55126484999289, -31.424393999083748],
          [115.551419506405182, -31.424598727049556],
          [115.551431390046673, -31.424614642351798],
          [115.551450691296395, -31.424641304552495],
          [115.551469445758357, -31.42466825543562],
          [115.551487648036641, -31.424695483309847],
          [115.551505292735101, -31.424722980980732],
          [115.551522375357422, -31.424750741253661],
          [115.551538889608082, -31.424778755135378],
          [115.551554830990767, -31.424807013632744],
          [115.551557869799922, -31.424812649683986],
          [115.551567377432548, -31.424822074579026],
          [115.551590820959632, -31.424846159322726],
          [115.551613771658253, -31.424870592104071],
          [115.551636221434478, -31.424895368426462],
          [115.551658160395846, -31.424920476598686],
          [115.551663066197648, -31.42492621787062],
          [115.551740567972843, -31.425017306603365],
          [115.551757089418174, -31.425037000856832],
          [115.551777990561845, -31.425062754742271],
          [115.551798367400806, -31.425088819793132],
          [115.551818208243731, -31.425115187016218],
          [115.55183750859419, -31.425141850116233],
          [115.551856263056152, -31.425168799200662],
          [115.551874466233699, -31.425196027974266],
          [115.551892111831535, -31.425223525645151],
          [115.551909193554479, -31.42525128591808],
          [115.551925708704516, -31.425279299799797],
          [115.551941650087088, -31.425307557397787],
          [115.551957013205651, -31.425336052416867],
          [115.551971793563439, -31.425364774964351],
          [115.551985987563285, -31.425393716047097],
          [115.55199958980927, -31.425422866671909],
          [115.552012596704003, -31.425452218744852],
          [115.552025004650318, -31.425481763272728],
          [115.552030647896117, -31.425495977057665],
          [115.552203513781251, -31.425699144699706],
          [115.552265475271497, -31.425775426994335],
          [115.552322877199117, -31.4258551968598],
          [115.552375522612351, -31.425938182700918],
          [115.552423231646912, -31.426024100331915],
          [115.552465842424795, -31.42611265837246],
          [115.552503209255747, -31.426203553750952],
          [115.552535203536877, -31.426296475302024],
          [115.552561718248739, -31.426391107363656],
          [115.552710145057176, -31.427001722751243],
          [115.552730453547611, -31.427098309039707],
          [115.552744590890256, -31.427195988903748],
          [115.552752498628934, -31.42729437023894],
          [115.552754146186999, -31.427393053746414],
          [115.552742560221077, -31.428147247697268],
          [115.552809744973842, -31.428717859441633],
          [115.552947896128558, -31.429219705424998],
          [115.553094382200015, -31.429559576313352],
          [115.553311581963953, -31.429879452574653],
          [115.553360322520916, -31.429955310389232],
          [115.553404939686288, -31.430033663822485],
          [115.55344530665559, -31.43011428984255],
          [115.553481307416519, -31.430196958223007],
          [115.553709331420578, -31.430763363838139],
          [115.553740578365023, -31.430847617723316],
          [115.553767038218325, -31.430933495784132],
          [115.553788627343351, -31.431020726425345],
          [115.553920471552601, -31.431627398285741],
          [115.553997700833293, -31.431871277337507],
          [115.554066580808126, -31.431993390882212],
          [115.554112469614893, -31.432080559470194],
          [115.554153077602564, -31.43217030911245],
          [115.554188259980265, -31.432262321448945],
          [115.554314213630164, -31.432624594449408],
          [115.554342956862001, -31.432715987153017],
          [115.554366138686419, -31.432808945576312],
          [115.554464412103016, -31.43326112110384],
          [115.554481385007989, -31.433352085730121],
          [115.554492932302992, -31.433443896618485],
          [115.554538261731409, -31.433918024597119],
          [115.554544050667459, -31.434003433211842],
          [115.554545107370814, -31.434089030684163],
          [115.554543700831232, -31.434180644620994],
          [115.554672227441415, -31.434373756043954],
          [115.554706395383846, -31.43442718206876],
          [115.554738573126656, -31.434481829372885],
          [115.555148285365135, -31.435208156031536],
          [115.55518445969517, -31.435275830015485],
          [115.555217493592522, -31.43534509130285],
          [115.555420967903387, -31.435798453036114],
          [115.555430541186638, -31.435820201341187],
          [115.555442950931479, -31.435849745869007],
          [115.555454756331983, -31.435879472959243],
          [115.555465955589398, -31.435909375417282],
          [115.555476544207181, -31.435939441551966],
          [115.555486518588054, -31.435969664168624],
          [115.555495876933264, -31.436000033374796],
          [115.555504615645532, -31.436030539277908],
          [115.555512732926331, -31.436061174683402],
          [115.55552022517827, -31.436091927900122],
          [115.555527089703446, -31.436122790834077],
          [115.555533327401236, -31.436153753592805],
          [115.555538931076853, -31.436184807183054],
          [115.555543904327806, -31.436215942611625],
          [115.555548242657323, -31.436247149086626],
          [115.55555194606552, -31.436278417614858],
          [115.555553831943826, -31.436297684690373],
          [115.555578075867516, -31.436340662391615],
          [115.555624752480412, -31.436429349934485],
          [115.555665909953859, -31.436520730047619],
          [115.555701394503785, -31.436614459189911],
          [115.555731073030643, -31.43671018482712],
          [115.5557809053646, -31.436891171590275],
          [115.555804757183864, -31.43699044685161],
          [115.55613366893374, -31.437442072893305],
          [115.556189070769051, -31.437522722295739],
          [115.556239794331077, -31.437606392520934],
          [115.556285675943286, -31.437692812872967],
          [115.556744901256252, -31.438622669600477],
          [115.556780320155667, -31.438699230684904],
          [115.556811759555103, -31.438777508575129],
          [115.557247795849207, -31.439950195744871],
          [115.557389094631048, -31.440264991735944],
          [115.557397291052212, -31.440274035318453],
          [115.557419235409498, -31.4402991425913],
          [115.557440663555894, -31.440324578116758],
          [115.557461571894123, -31.440350331102877],
          [115.557481951430987, -31.440376396153738],
          [115.557501796770566, -31.440402763376767],
          [115.557521101617567, -31.440429425577463],
          [115.557539859676808, -31.440456373762572],
          [115.557558065552371, -31.440483601636856],
          [115.557575715646863, -31.440511099307741],
          [115.557592801866349, -31.44053885868135],
          [115.557595734555548, -31.440543744698005],
          [115.557826567142456, -31.44092974900866],
          [115.55786406347579, -31.440995742159714],
          [115.55789855607361, -31.441063354090488],
          [115.558171690970767, -31.441630211165261],
          [115.558223565665116, -31.44171695527325],
          [115.558227830250189, -31.441721034598004],
          [115.558251768404489, -31.441744762310861],
          [115.558275218226754, -31.441768846155298],
          [115.558298173422031, -31.441793278037323],
          [115.558320626795535, -31.441818052561018],
          [115.558342572052084, -31.441843160733242],
          [115.55836400199712, -31.441868595359324],
          [115.558384909436086, -31.441894348345443],
          [115.558405289872326, -31.441920413396304],
          [115.558425135211905, -31.44194677972007],
          [115.558444440958283, -31.441973441920766],
          [115.558463199916787, -31.442000391005195],
          [115.558481406691612, -31.442027617980159],
          [115.558499055886728, -31.442055115651044],
          [115.558516143005704, -31.442082875024596],
          [115.558532660853643, -31.442110888007051],
          [115.55854860673287, -31.44213914560504],
          [115.558563973448713, -31.442167639724744],
          [115.558578758303156, -31.442196361372908],
          [115.558592955900281, -31.442225301556391],
          [115.558606561743545, -31.442254453080523],
          [115.558619572235557, -31.442283804254146],
          [115.558619852823995, -31.442284453564639],
          [115.558746868573166, -31.442579075064202],
          [115.558784678769939, -31.442674955384859],
          [115.558816243175102, -31.44277306872209],
          [115.558841433185648, -31.44287300858241],
          [115.55890557733062, -31.4431680626559],
          [115.558916969042912, -31.443176587329617],
          [115.558944107884372, -31.443197621572949],
          [115.558970813252472, -31.443219063209142],
          [115.558997077053505, -31.443240902345735],
          [115.559022891193536, -31.443263131788058],
          [115.55904824757863, -31.443285747039567],
          [115.559073139014231, -31.443308739106953],
          [115.559097557406403, -31.443332102594411],
          [115.559121495560589, -31.443355829407949],
          [115.559144946282345, -31.443379912353009],
          [115.559151875558655, -31.44338719506294],
          [115.559281311383529, -31.44352397115432],
          [115.559297338201645, -31.443541120326415],
          [115.559319791575149, -31.44356589485011],
          [115.559341737731074, -31.443591003022334],
          [115.559363168575487, -31.443616436749096],
          [115.559384076913716, -31.443642190634534],
          [115.559404457349842, -31.443668254786076],
          [115.559424303588798, -31.443694621109842],
          [115.559443609335176, -31.443721283310538],
          [115.559462369193056, -31.443748232394967],
          [115.559480575967882, -31.443775459369931],
          [115.559498226062374, -31.443802957040816],
          [115.559515313181237, -31.443830716414368],
          [115.559531832827929, -31.443858727598183],
          [115.559545632025333, -31.443883183761898],
          [115.559776341405041, -31.444086237190049],
          [115.559849823210811, -31.444154324862154],
          [115.559919590816548, -31.444226213968534],
          [115.559985447270606, -31.444301702161795],
          [115.560192067410071, -31.444552110291625],
          [115.56021158359772, -31.444576178847512],
          [115.560231964933337, -31.444602242999053],
          [115.560251812071556, -31.444628610222139],
          [115.560271117817933, -31.444655272422835],
          [115.560289877675814, -31.444682220607945],
          [115.560308085349902, -31.444709447582909],
          [115.560325736343771, -31.444736945253794],
          [115.560342822563257, -31.444764704627346],
          [115.560359343109212, -31.444792716710481],
          [115.560375288988439, -31.44482097430847],
          [115.560390658402184, -31.444849468428174],
          [115.560405442357364, -31.444878190076395],
          [115.560419640853752, -31.444907130259821],
          [115.560433247596393, -31.444936280884633],
          [115.560446258987668, -31.444965632058256],
          [115.560458671430638, -31.444995176586076],
          [115.560470478629782, -31.445024902776993],
          [115.560481679685836, -31.445054804335712],
          [115.560492270102259, -31.445084869571019],
          [115.560502247181034, -31.445115093087054],
          [115.560511607324884, -31.445145461393906],
          [115.560520347835791, -31.445175968196338],
          [115.56052846691523, -31.445206602702513],
          [115.560535960965922, -31.445237355919176],
          [115.560542827289737, -31.445268218853187],
          [115.560549065886789, -31.445299181611915],
          [115.560554672260423, -31.445330235202164],
          [115.560555126417967, -31.445333068066589],
          [115.560598946784012, -31.445425671257681],
          [115.560979045246768, -31.446099336315285],
          [115.561015229469376, -31.446167011198554],
          [115.561048272359926, -31.446236275183935],
          [115.561251794334908, -31.446689627923945],
          [115.561261378409995, -31.446711394215413],
          [115.561273789953475, -31.44674093784397],
          [115.561285598051995, -31.446770664934206],
          [115.561296800007426, -31.446800565593605],
          [115.561307390423735, -31.446830632627552],
          [115.561317368401888, -31.446860854344891],
          [115.561318096852801, -31.446863218662543],
          [115.561327103563031, -31.44687849184885],
          [115.56134305034152, -31.446906749446896],
          [115.561358419755379, -31.4469352435666],
          [115.561373206408462, -31.446963965214763],
          [115.56138550913397, -31.446988960072417],
          [115.561538498203163, -31.44730642435195],
          [115.561578201472912, -31.447395431154177],
          [115.561612525897431, -31.447486647590665],
          [115.561746335125349, -31.447877620655618],
          [115.561748960246405, -31.447880624391246],
          [115.56177039199008, -31.447906058118065],
          [115.561791302126949, -31.447931811104183],
          [115.561811682563189, -31.447957875255668],
          [115.56183153239931, -31.447984241579434],
          [115.561850838145688, -31.44801090378013],
          [115.561869598902945, -31.448037851965239],
          [115.561887808375673, -31.448065078940203],
          [115.561905459369541, -31.448092576611089],
          [115.561922547387667, -31.448120335085378],
          [115.561939067933736, -31.448148348067775],
          [115.561955014712225, -31.448176605665765],
          [115.561970384125971, -31.448205098886149],
          [115.56198516987979, -31.448233821433689],
          [115.561999369275554, -31.448262760717796],
          [115.562012976917458, -31.448291911342608],
          [115.562025988308733, -31.448321263415551],
          [115.562038400751703, -31.448350806144731],
          [115.562050209749486, -31.448380533234968],
          [115.562061411704804, -31.448410433894367],
          [115.562072003020603, -31.448440500928314],
          [115.562081980998641, -31.448470722645709],
          [115.562091342041867, -31.448501091851881],
          [115.562100082552774, -31.448531597754993],
          [115.562108203430853, -31.448562232261168],
          [115.562115696582168, -31.448592984578511],
          [115.562122564704623, -31.448623848411842],
          [115.562128803301675, -31.44865481117057],
          [115.562129052413866, -31.448656120583451],
          [115.562202106142308, -31.449040346035076],
          [115.562217789419492, -31.449140434283549],
          [115.562226918437545, -31.449241331921883],
          [115.562265011021509, -31.4499029271783],
          [115.56230958501942, -31.450229141861371],
          [115.562369030206696, -31.450416774614439],
          [115.562396752708082, -31.450515011158814],
          [115.562418010882539, -31.450614846697761],
          [115.562432712100076, -31.450715854952705],
          [115.562440796105875, -31.450817607846261],
          [115.562460553311894, -31.451246339846648],
          [115.562462155903859, -31.451327963214908],
          [115.562459453441079, -31.451409557804823],
          [115.562452452218963, -31.451490896087932],
          [115.562421970597484, -31.45176157673535],
          [115.562496721346633, -31.452074064166709],
          [115.562841480949601, -31.452841940403175],
          [115.562876404322651, -31.452925841754166],
          [115.562906542403084, -31.453011579520762],
          [115.562931799862781, -31.453098879409708],
          [115.563130525753195, -31.453867919368918],
          [115.563153292090874, -31.453969735215082],
          [115.563169178614771, -31.454072849682234],
          [115.563178114278571, -31.454176796921615],
          [115.563180058612829, -31.454281109285716],
          [115.563174142872413, -31.454668515639469],
          [115.563181016390899, -31.4546801717525],
          [115.563196964968029, -31.45470842755185],
          [115.56321233528115, -31.454736922570874],
          [115.563227122833496, -31.454765643319718],
          [115.563241323128636, -31.454794584402521],
          [115.563254931669803, -31.454823734127956],
          [115.563267943960454, -31.454853085301579],
          [115.563280357302688, -31.454882628930136],
          [115.563281251228773, -31.454884820577945],
          [115.563382683963709, -31.455134045199998],
          [115.563393599934784, -31.455161580642368],
          [115.563404802789478, -31.455191481301767],
          [115.56341539500454, -31.455221547436395],
          [115.563425372982692, -31.45525176915379],
          [115.563434734925181, -31.455282138359962],
          [115.563443477234728, -31.455312644263074],
          [115.563451597213543, -31.455343278769249],
          [115.563459092163384, -31.455374031985968],
          [115.563465960285953, -31.455404894919923],
          [115.563472199782268, -31.455435857678651],
          [115.563477807954541, -31.4554669112689],
          [115.563480762227414, -31.455485303304044],
          [115.563495937387643, -31.455503311328698],
          [115.56351684932315, -31.455529064314817],
          [115.563537233356669, -31.455555127567038],
          [115.563557082293528, -31.455581493890804],
          [115.563576390737921, -31.4556081560915],
          [115.563595153293704, -31.45563510427661],
          [115.563613363665809, -31.455662330352197],
          [115.56363101555894, -31.455689828023083],
          [115.563648106275195, -31.455717585598052],
          [115.563664627720414, -31.455745598580449],
          [115.563680576297656, -31.455773856178496],
          [115.563695946610665, -31.4558023502982],
          [115.563710735062386, -31.455831071047044],
          [115.563724935357527, -31.45586001123047],
          [115.563738543898694, -31.455889161855282],
          [115.563751557088722, -31.455918513028905],
          [115.563763970430955, -31.455948056657462],
          [115.563775780328115, -31.455977783747699],
          [115.563786983182808, -31.456007684407041],
          [115.563792657904855, -31.456023557441199],
          [115.563943949054078, -31.456453764329694],
          [115.563973944142276, -31.456548260593706],
          [115.563997953342891, -31.456644452079729],
          [115.564015882227295, -31.456741960173304],
          [115.564087471859352, -31.457215731121039],
          [115.56409853801722, -31.457233704971486],
          [115.564115060361814, -31.457261717953884],
          [115.564131008938944, -31.457289974652554],
          [115.564146379252065, -31.457318468772257],
          [115.564161167703787, -31.457347190420478],
          [115.564175367998928, -31.457376129704585],
          [115.564188977439471, -31.457405280329397],
          [115.564201990629385, -31.45743463240234],
          [115.564214403971619, -31.45746417513152],
          [115.564226214768041, -31.457493901322437],
          [115.564233232178026, -31.457512421061324],
          [115.564334325868458, -31.457784192586359],
          [115.564358946608195, -31.457855417093754],
          [115.564380169709125, -31.457927726183584],
          [115.564397948406622, -31.458000957977788],
          [115.564465189816701, -31.458310135904014],
          [115.564478354992161, -31.458341470982077],
          [115.564553650730431, -31.458441084388483],
          [115.564613432264196, -31.458524357113333],
          [115.5646679104957, -31.458611192052842],
          [115.564716874983901, -31.458701251961145],
          [115.564760134172957, -31.45879418700207],
          [115.564797520789057, -31.45888963564812],
          [115.564828890041326, -31.4589872273786],
          [115.564854119621941, -31.459086583578937],
          [115.564873110605618, -31.459187319339264],
          [115.564944803659841, -31.459661741396189],
          [115.564956038890159, -31.459755086527991],
          [115.5649615850092, -31.45984894247465],
          [115.564961420433292, -31.459942962097955],
          [115.56495554696096, -31.46003679825958],
          [115.564901543571409, -31.460616780939631],
          [115.564911771561015, -31.460942601719637],
          [115.5649316888464, -31.461034170690368],
          [115.565033036145792, -31.46122208672989],
          [115.565404271789816, -31.461694816262707],
          [115.565464080303173, -31.461775503436684],
          [115.565519139496701, -31.461859503713072],
          [115.565569265908948, -31.461946537402753],
          [115.565825114037807, -31.462423020705785],
          [115.565868751841435, -31.462509942879535],
          [115.565907042276194, -31.462599349880065],
          [115.565939845947241, -31.462690911656182],
          [115.565967041445901, -31.462784293660206],
          [115.565988528947514, -31.462879151451659],
          [115.566004230211092, -31.462975136992952],
          [115.56601163432947, -31.463031924683548],
          [115.56602628338635, -31.463056760361155],
          [115.566042233762118, -31.463085017059825],
          [115.56605760587388, -31.463113511179529],
          [115.566072394325602, -31.46314223192843],
          [115.566086596419382, -31.463171172111856],
          [115.566100206759188, -31.463200321837348],
          [115.566113220848479, -31.463229673010972],
          [115.566125635989351, -31.463259216639472],
          [115.566137446785774, -31.463288942830388],
          [115.566148651439221, -31.463318844389107],
          [115.566159244553546, -31.463348909624415],
          [115.566169225229601, -31.46337913224113],
          [115.566178588071466, -31.463409501447302],
          [115.566187331280389, -31.463440005551774],
          [115.566195452158468, -31.463470640957269],
          [115.566202626949689, -31.463500014613942],
          [115.56627673558296, -31.463816588564669],
          [115.566292459329588, -31.463892031791772],
          [115.566304435601296, -31.463968159403009],
          [115.566312635619738, -31.464044786137947],
          [115.566321376130645, -31.464151522174973],
          [115.566332660823718, -31.46416158379003],
          [115.5663575585545, -31.464184575857473],
          [115.566381983241968, -31.464207938445554],
          [115.566405926792186, -31.464231662561133],
          [115.566417832916727, -31.464243780026379],
          [115.566573271739117, -31.464403394401074],
          [115.566584822631512, -31.464415359880888],
          [115.56660778412197, -31.464439790863594],
          [115.566630244690145, -31.464464563588706],
          [115.566652196241876, -31.464489671760873],
          [115.566673631582944, -31.464515104588372],
          [115.566694546216354, -31.464540857574491],
          [115.566714932048512, -31.464566920826712],
          [115.566734783683387, -31.464593287150421],
          [115.566754094825683, -31.464619947552478],
          [115.566772859180219, -31.464646895737587],
          [115.566791072250226, -31.464674122712552],
          [115.566808726841373, -31.464701618584797],
          [115.566825819356154, -31.464729377958406],
          [115.566842342600125, -31.464757390041484],
          [115.566858292975894, -31.464785646740154],
          [115.566859432416891, -31.464787759247656],
          [115.566875934976451, -31.464801003563423],
          [115.566902205972042, -31.46482284180064],
          [115.566928026407368, -31.464845070343699],
          [115.56695338998702, -31.464867684695832],
          [115.566978287717916, -31.464890675863955],
          [115.567002712405269, -31.464914037552774],
          [115.56702665685475, -31.464937762567672],
          [115.567050113871687, -31.464961846412052],
          [115.567073075362146, -31.464986277394758],
          [115.567083019166034, -31.464997134010503],
          [115.567186532032906, -31.46511105832866],
          [115.567225104854742, -31.465154879593968],
          [115.567262253150489, -31.465199914944094],
          [115.567352428172057, -31.465237317747949],
          [115.567440866602738, -31.465278657783813],
          [115.567527399370078, -31.465323854112512],
          [115.567736144607466, -31.465438955643265],
          [115.567761456925723, -31.465453135253938],
          [115.567778033229729, -31.465462749905953],
          [115.567870391805172, -31.46548142972415],
          [115.567988438615657, -31.465508430969294],
          [115.568104932296819, -31.465541493644992],
          [115.56821956258284, -31.465580531416322],
          [115.568533541090119, -31.465696806562335],
          [115.568539545863359, -31.465699039578965],
          [115.568572968267972, -31.465711823441836],
          [115.568606123573772, -31.465725106428465],
          [115.568639001888528, -31.465738884941516],
          [115.56867159242006, -31.465753153585126],
          [115.568703886175513, -31.465767910560601],
          [115.568735873261971, -31.465783149572644],
          [115.568767542887826, -31.465798865225395],
          [115.568798886059767, -31.465815053921574],
          [115.568829893784596, -31.465831711164469],
          [115.568860555270476, -31.465848830658956],
          [115.568890862423473, -31.465866408807699],
          [115.568920806250276, -31.465884438416083],
          [115.568950375959162, -31.46590291408819],
          [115.568979564355459, -31.465921832226741],
          [115.568992028059711, -31.465930207612928],
          [115.568997656017018, -31.465932463112665],
          [115.569030534331773, -31.465946240726396],
          [115.569063124863419, -31.465960510269269],
          [115.569095418618758, -31.465975266345424],
          [115.569127405705217, -31.465990503558828],
          [115.569159075331072, -31.466006221010275],
          [115.569190419402389, -31.466022409706397],
          [115.569221426227955, -31.466039066949349],
          [115.569252088613098, -31.46605618644378],
          [115.569282395765981, -31.466073763693203],
          [115.569312339592898, -31.466091793301587],
          [115.569341909301784, -31.466110269873013],
          [115.569371097698081, -31.466129187112244],
          [115.56939989488933, -31.466148539623362],
          [115.569428292781595, -31.46616832201039],
          [115.569456280582926, -31.466188527978147],
          [115.569483853796896, -31.466209151231283],
          [115.569492591609901, -31.466215841287976],
          [115.56970065606049, -31.466376038423391],
          [115.569772801473619, -31.466434273123184],
          [115.569842101431846, -31.466495867690071],
          [115.56990840035246, -31.466560681829947],
          [115.570219298681764, -31.46687989888818],
          [115.570296803154974, -31.466964516099495],
          [115.57036887842105, -31.467053802590897],
          [115.570484201184968, -31.467206340200391],
          [115.570570644919371, -31.467264484967984],
          [115.570653986892012, -31.467326995044743],
          [115.570734006769044, -31.467393704056178],
          [115.570785938120594, -31.467439391414757],
          [115.570808210730434, -31.467459288914995],
          [115.570833110259855, -31.467482280083118],
          [115.570857535846699, -31.467505641771879],
          [115.570881482094819, -31.467529366786778],
          [115.570904940011019, -31.467553448832575],
          [115.570927904199493, -31.467577878915961],
          [115.570950365666931, -31.467602651641016],
          [115.570972319017415, -31.467627758014601],
          [115.570993756157009, -31.467653191741363],
          [115.571014672589172, -31.467678942928842],
          [115.57103506021997, -31.467705006181063],
          [115.571054912754107, -31.467731371605453],
          [115.571074225695043, -31.467758032007509],
          [115.571088256917619, -31.467778180418634],
          [115.571092498120379, -31.467781467440716],
          [115.571119211582413, -31.46780290458031],
          [115.571145484376643, -31.467824741918264],
          [115.571171306610609, -31.467846969561947],
          [115.571196671089524, -31.467869583014817],
          [115.571221570619059, -31.467892574182883],
          [115.571245997105166, -31.467915934972382],
          [115.571269943353286, -31.4679396608866],
          [115.571293402168862, -31.467963742033021],
          [115.571300280183891, -31.467970968985014],
          [115.57142976816931, -31.468107731586485],
          [115.571445853443493, -31.468124937415894],
          [115.571468315810193, -31.468149709241629],
          [115.5714902682613, -31.468174815615214],
          [115.571511706300271, -31.468200248442656],
          [115.571532622732434, -31.468226001428775],
          [115.571553010363232, -31.468252062882357],
          [115.571572863796632, -31.468278429206123],
          [115.571592176737681, -31.46830508960818],
          [115.57161094379012, -31.468332036893969],
          [115.571629157759503, -31.468359262969557],
          [115.571634229935853, -31.468367160815774],
          [115.571645038887482, -31.468379521997292],
          [115.571666476926453, -31.468404955724111],
          [115.571687391559976, -31.468430706911533],
          [115.571707780989414, -31.468456769264435],
          [115.571727634422814, -31.468483135588201],
          [115.571746947363749, -31.468509795990258],
          [115.571765714416301, -31.468536743276047],
          [115.571783928385685, -31.468563969351635],
          [115.571801585674734, -31.468591465223881],
          [115.571818679088778, -31.46861922369817],
          [115.571835205030766, -31.468647234881928],
          [115.571851157205174, -31.468675491580655],
          [115.571866531115575, -31.468703984801039],
          [115.571881323164575, -31.468732706449202],
          [115.571895527056995, -31.46876164483399],
          [115.571909139195441, -31.468790793660162],
          [115.571922155982747, -31.468820144833785],
          [115.57193457292226, -31.468849687562965],
          [115.571946386416698, -31.468879413753882],
          [115.57195340022929, -31.468897916405695],
          [115.572003962812687, -31.469033798570877],
          [115.57203241466425, -31.469117127053721],
          [115.572056196336462, -31.469201906142985],
          [115.57207523678278, -31.469287874136057],
          [115.572083631054738, -31.469299023031454],
          [115.572102943995674, -31.46932568343351],
          [115.572121711048226, -31.4693526307193],
          [115.572139925916872, -31.469379855895568],
          [115.572157583205922, -31.469407352667133],
          [115.572174676620079, -31.469435110242102],
          [115.572191202562067, -31.46946312232518],
          [115.572199286567866, -31.469477283050139],
          [115.572301783200828, -31.469658850775318],
          [115.572331053435391, -31.469713140149281],
          [115.572335180424261, -31.469717858892011],
          [115.572356617563855, -31.46974329261883],
          [115.572377533996018, -31.469769043806309],
          [115.572397923425456, -31.469795106159154],
          [115.572417775959707, -31.4698214715836],
          [115.572437089799905, -31.469848132884977],
          [115.572438510728716, -31.469850135675188],
          [115.572567317028074, -31.470031996579337],
          [115.572584663151702, -31.470056941974235],
          [115.572602878919838, -31.47008416804988],
          [115.572620536208888, -31.470111663922125],
          [115.572637631421571, -31.470139420597718],
          [115.572654155564919, -31.470167433580173],
          [115.572670108638704, -31.470195690278842],
          [115.572685483448367, -31.470224182599907],
          [115.572700274598105, -31.470252903348751],
          [115.572714480289051, -31.470281842632915],
          [115.57272809242761, -31.47031099235835],
          [115.57274111011418, -31.470340342632653],
          [115.572753527053692, -31.47036988626121],
          [115.572765341447393, -31.470399611552807],
          [115.572766955730458, -31.470403871641338],
          [115.572811718585967, -31.47045541808302],
          [115.573286190105705, -31.47087279794124],
          [115.573359021701549, -31.470940244396729],
          [115.573428255110002, -31.471011379871243],
          [115.573764880345038, -31.471376061256194],
          [115.573787196122225, -31.47140067390194],
          [115.573809150372085, -31.471425780275467],
          [115.573830590209582, -31.471451213102966],
          [115.573851508440384, -31.471476964290446],
          [115.573871896071182, -31.471503026643347],
          [115.573891750404073, -31.471529392067737],
          [115.573911065143648, -31.471556051570474],
          [115.573925089171553, -31.471576189189761],
          [115.573929342964902, -31.471579484305721],
          [115.573956058225576, -31.471600922344635],
          [115.573982331919183, -31.471622758783269],
          [115.574008155951674, -31.471644986426952],
          [115.574033522229342, -31.471667598980446],
          [115.57405842265814, -31.471690589249249],
          [115.574082850942887, -31.471713950938067],
          [115.57410679809027, -31.471737675053589],
          [115.574130258704486, -31.471761756200067],
          [115.574153223792337, -31.471786187182772],
          [115.574175687058414, -31.471810959008508],
          [115.57419764130816, -31.471836065382092],
          [115.574219080246394, -31.471861498209535],
          [115.574239997577934, -31.471887249397014],
          [115.574260387007371, -31.471913311749915],
          [115.574280242239411, -31.471939677174305],
          [115.574299556079723, -31.471966337576362],
          [115.574318324031537, -31.471993283962831],
          [115.57433653979956, -31.472020510038476],
          [115.574354197987873, -31.472048005910722],
          [115.57436215339078, -31.47206077808238],
          [115.574516250424722, -31.472310580968497],
          [115.574564236450442, -31.472393367160123],
          [115.574607367036378, -31.472478783868723],
          [115.574645498291147, -31.472566546009261],
          [115.574678503410269, -31.472656362201292],
          [115.574768395145384, -31.47292584405244],
          [115.574861582895778, -31.473075632434472],
          [115.575164967389355, -31.473409453583372],
          [115.575218961785708, -31.473471590441477],
          [115.575270099035947, -31.473536099711168],
          [115.575476479955682, -31.473809035858267],
          [115.575514527573432, -31.473861419568834],
          [115.575526949908863, -31.473872113407253],
          [115.575552317085794, -31.473894725061484],
          [115.575577218413969, -31.473917715330231],
          [115.575601647597978, -31.473941076119729],
          [115.575625597443377, -31.473964800235308],
          [115.57564905715833, -31.473988881381729],
          [115.575672023145444, -31.474013310565795],
          [115.575681955258119, -31.474024154591007],
          [115.575785487910025, -31.474138072613925],
          [115.57579801996269, -31.474152002213089],
          [115.57581493441171, -31.474171343932312],
          [115.575830080793708, -31.474181520660579],
          [115.575858481383875, -31.474201302148344],
          [115.575886473681862, -31.474221507216726],
          [115.575914049593734, -31.474242129570598],
          [115.575941199227032, -31.47426316291461],
          [115.575967915387082, -31.474284600953524],
          [115.575994190879214, -31.474306435593462],
          [115.576020015811196, -31.474328664136522],
          [115.576045382988127, -31.474351275790696],
          [115.576070284316188, -31.474374266059499],
          [115.576094714399574, -31.47439762684894],
          [115.576118662446333, -31.474421351863839],
          [115.576142123060549, -31.47444543211094],
          [115.576165089047663, -31.474469862194326],
          [115.57618755411238, -31.474494634020118],
          [115.576209509261503, -31.474519740393646],
          [115.576230949998376, -31.474545172321825],
          [115.576242553950806, -31.474559339341965],
          [115.576371714583047, -31.474718647047894],
          [115.576381029760796, -31.474730232114496],
          [115.576401420089496, -31.474756293568078],
          [115.57642127532165, -31.474782658992467],
          [115.576440590960601, -31.474809319394524],
          [115.576447354761626, -31.474819031173297],
          [115.576459780694336, -31.474829725011773],
          [115.576485147871381, -31.474852337565267],
          [115.576510050098818, -31.47487532693475],
          [115.576534479282827, -31.474898687724192],
          [115.576558428228964, -31.47492241273909],
          [115.57658188884318, -31.474946492986192],
          [115.576604855729556, -31.474970923069577],
          [115.57662731989501, -31.47499569489537],
          [115.576632225696699, -31.475001224826599],
          [115.5768133266738, -31.475206218092467],
          [115.576873923892549, -31.475278177345956],
          [115.576930524524187, -31.475353319300211],
          [115.576982963093315, -31.475431423621274],
          [115.577031084916712, -31.475512259183347],
          [115.57707474700203, -31.475595587666191],
          [115.577113821645639, -31.475681163554782],
          [115.577149349363026, -31.475765679142739],
          [115.577225320492175, -31.475850119187612],
          [115.577295832736581, -31.4759391691573],
          [115.577360606406955, -31.476032475618183],
          [115.577463460070703, -31.47619149104446],
          [115.577510946972666, -31.476269250925156],
          [115.577554128819997, -31.476349481243517],
          [115.577592878808332, -31.476431943679188],
          [115.577627080025763, -31.476516393616635],
          [115.57766526344119, -31.476618979282421],
          [115.577746522583993, -31.476708385383631],
          [115.577818264201596, -31.476791945891534],
          [115.57788459100118, -31.476879866312743],
          [115.577945239481323, -31.476971795012275],
          [115.577999968623658, -31.477067366865469],
          [115.578048558993828, -31.47716620055968],
          [115.578201310642044, -31.47750619555444],
          [115.578233581914333, -31.47758313525344],
          [115.578261808935395, -31.477661647866739],
          [115.578285917061521, -31.477741522053577],
          [115.578305839742825, -31.477822541077387],
          [115.578359933064576, -31.478071039946485],
          [115.578431938183485, -31.478155395455076],
          [115.578498498806766, -31.478244109078332],
          [115.57855935323164, -31.478336830979913],
          [115.57861425864121, -31.478433194236459],
          [115.578793325351739, -31.478773480611608],
          [115.578832581658389, -31.478853116478092],
          [115.578867471756439, -31.478934759631386],
          [115.578897892224063, -31.479018170851873],
          [115.578980319586094, -31.479265223611151],
          [115.57899451358594, -31.479278797078791],
          [115.579018464330716, -31.47930252119437],
          [115.579041927642947, -31.479326601441471],
          [115.579064895428587, -31.479351032424177],
          [115.579087361392681, -31.479375801551953],
          [115.579109318340443, -31.479400907925537],
          [115.579130759976692, -31.47942633985366],
          [115.579151680006134, -31.479452091041139],
          [115.579172072133474, -31.479478151595401],
          [115.579179960087117, -31.47948850459079],
          [115.579283161788567, -31.479624971315332],
          [115.579328469633197, -31.479687771873103],
          [115.579332732419743, -31.479691074183677],
          [115.579359451277696, -31.479712511323271],
          [115.579385727669205, -31.479734346862585],
          [115.579411554399826, -31.479756575405588],
          [115.57943692427466, -31.479779186160442],
          [115.57946182830085, -31.479802176429246],
          [115.579486259283499, -31.479825535420105],
          [115.579510209128898, -31.479849260435003],
          [115.57953367244113, -31.479873339782785],
          [115.579556640226883, -31.47989776986617],
          [115.579579107090126, -31.479922540792586],
          [115.579601064037888, -31.479947646266794],
          [115.579605888001424, -31.479953286814691],
          [115.579761035443539, -31.480135433703254],
          [115.579777653116253, -31.480155225982855],
          [115.579798573145695, -31.480180976271015],
          [115.579818965273034, -31.48020703772454],
          [115.579838822303827, -31.480233402249667],
          [115.579858139741418, -31.480260062651723],
          [115.579876910391135, -31.480287009038193],
          [115.579895128857174, -31.480314234214518],
          [115.579912789743503, -31.480341729187387],
          [115.579929887654203, -31.480369486762356],
          [115.579946416294092, -31.480397497046795],
          [115.579962372965156, -31.480425752846145],
          [115.579977749573573, -31.480454245167209],
          [115.579992546119115, -31.48048296501679],
          [115.580006753608814, -31.480511904300897],
          [115.580020369344652, -31.48054105312707],
          [115.580022042083669, -31.480544823984417],
          [115.580034172139449, -31.480555492641827],
          [115.580111563298033, -31.480627347574],
          [115.580184808582089, -31.480703423024522],
          [115.580253677765086, -31.48078348067304],
          [115.580321000114168, -31.48086650608434],
          [115.580338399297716, -31.480879063318071],
          [115.580365977907604, -31.480899684772567],
          [115.580393130238804, -31.480920717217259],
          [115.58041984909687, -31.48094215435691],
          [115.580446126387642, -31.480963989896168],
          [115.580471954017526, -31.480986216640531],
          [115.580497323892473, -31.481008828294762],
          [115.58052222791855, -31.481031817664189],
          [115.580546659800575, -31.481055177554367],
          [115.580570611444614, -31.481078901669946],
          [115.580594074756846, -31.481102981917047],
          [115.580617043441862, -31.481127411101113],
          [115.580639509405842, -31.481152182926849],
          [115.58066146725298, -31.481177288401113],
          [115.580666284921222, -31.481182919955756],
          [115.580743860440862, -31.481273993400009],
          [115.580760485308247, -31.481293791974849],
          [115.580781406236952, -31.481319543162329],
          [115.580801799263668, -31.48134560461591],
          [115.580821657193837, -31.481371969141037],
          [115.580840974631315, -31.481398628643774],
          [115.580859745281032, -31.481425575030244],
          [115.580877964646447, -31.481452800206512],
          [115.580895626432039, -31.481480295179438],
          [115.580912723443475, -31.481508052754407],
          [115.580929253882005, -31.481536063038845],
          [115.580945209653805, -31.481564318838196],
          [115.580960588060748, -31.48159281115926],
          [115.580975383707028, -31.481621531008784],
          [115.580989592096103, -31.481650469393628],
          [115.581003208731204, -31.481679618219744],
          [115.581016229115789, -31.481708967594727],
          [115.581028649652467, -31.481738511223284],
          [115.581040466744184, -31.481768237414201],
          [115.58105167679355, -31.481798136274904],
          [115.58106227620317, -31.481828202409588],
          [115.58107226137588, -31.481858422328287],
          [115.581081554070579, -31.481888815816149],
          [115.581081951570923, -31.481889910291102],
          [115.581111851330888, -31.481960566426949],
          [115.581263941977454, -31.482345657026428],
          [115.581293380385205, -31.482426405354261],
          [115.581318454383222, -31.482508614181143],
          [115.581489666414996, -31.483129541195353],
          [115.581679731834242, -31.48357629560951],
          [115.581975503566696, -31.484061959192047],
          [115.582019481314092, -31.484138558947279],
          [115.582059391427833, -31.484217354847033],
          [115.582263435908885, -31.484648125610477],
          [115.582273934594468, -31.484670727372134],
          [115.582286955878317, -31.484700077646437],
          [115.582299376415108, -31.484729618576978],
          [115.582311194406202, -31.484759345667214],
          [115.58232240535483, -31.484789245427294],
          [115.58233300476445, -31.484819310662601],
          [115.582342990836423, -31.4848495305813],
          [115.58235235997347, -31.484879898888153],
          [115.582353222423308, -31.484882906221117],
          [115.582360146303813, -31.48489284372971],
          [115.582378365669115, -31.484920068906035],
          [115.582396028354083, -31.484947563878904],
          [115.582413127164159, -31.484975320554554],
          [115.582429657602688, -31.485003331738312],
          [115.582445615173015, -31.485031588437039],
          [115.582460993580071, -31.485060078959407],
          [115.582475790125727, -31.485088798808988],
          [115.582488048784512, -31.485113680352015],
          [115.582564610768259, -31.485272399001985],
          [115.582566561397698, -31.485276455843746],
          [115.582580178932176, -31.485305604669861],
          [115.582593200216024, -31.485334954944165],
          [115.582605621652192, -31.485364496774082],
          [115.582617439643172, -31.485394222964999],
          [115.582628649692538, -31.485424122725021],
          [115.582639250001421, -31.485454187960386],
          [115.582649236073394, -31.485484408778404],
          [115.582658606109817, -31.485514776185937],
          [115.582667355614035, -31.485545282089049],
          [115.582673635579908, -31.485568959439888],
          [115.582685344752917, -31.485583920561453],
          [115.58270520358235, -31.485610284187203],
          [115.582724521919204, -31.48563694368994],
          [115.58274329436756, -31.48566389007641],
          [115.582761514632239, -31.485691114353415],
          [115.582779177317207, -31.485718609326341],
          [115.582796276127283, -31.485746366901253],
          [115.582812806565812, -31.485774377185692],
          [115.582828765035515, -31.485802632985099],
          [115.582844144341834, -31.485831125306163],
          [115.58285894088749, -31.485859844256368],
          [115.582873149276452, -31.485888784439794],
          [115.58288676681093, -31.485917930568007],
          [115.582899788094778, -31.48594728174163],
          [115.582912210430209, -31.485976823571491],
          [115.582924028421189, -31.486006549762408],
          [115.582935239369817, -31.486036450421807],
          [115.582945839678814, -31.486066514757795],
          [115.582955825750787, -31.48609673557587],
          [115.582965194887947, -31.486127102983346],
          [115.582973944392052, -31.486157607987195],
          [115.582982071565425, -31.48618824159405],
          [115.582989574609201, -31.486218993911393],
          [115.58299644902695, -31.486249855946028],
          [115.58300269481856, -31.486280818704756],
          [115.583008310185392, -31.486311871395685],
          [115.583013292429541, -31.486343005025617],
          [115.583017638852994, -31.486374212399937],
          [115.583021350355125, -31.48640547912953],
          [115.583021482555409, -31.486406703106809],
          [115.58306765644727, -31.486835721091609],
          [115.58307516758498, -31.486936032371943],
          [115.583076140651428, -31.487036620643494],
          [115.583070572049337, -31.487137058728251],
          [115.583017131635415, -31.487743798037798],
          [115.583045137423255, -31.488209233169528],
          [115.583133009281028, -31.488612758971612],
          [115.583281302989803, -31.488948912961916],
          [115.583598000147617, -31.489402939294166],
          [115.583640970654301, -31.489467529502861],
          [115.583680979693554, -31.489533994797966],
          [115.583717945426883, -31.489602200281297],
          [115.583973620886013, -31.490101199011065],
          [115.584014567918075, -31.49018696375731],
          [115.584050413995442, -31.490274982204596],
          [115.58408103591114, -31.490364952180755],
          [115.584106328444363, -31.490456563419627],
          [115.584168521959782, -31.490711903431531],
          [115.584215248934697, -31.490812823552915],
          [115.584381472427026, -31.491047405413383],
          [115.584434444294175, -31.491126606907358],
          [115.58448292674575, -31.491208633171823],
          [115.584526769594845, -31.491293229698726],
          [115.584679908850831, -31.491610665199971],
          [115.584715843961135, -31.491690322650243],
          [115.584747385883247, -31.491771820113343],
          [115.584774439289049, -31.491854914772432],
          [115.584796925937439, -31.49193936021328],
          [115.584814778379382, -31.492024904625623],
          [115.584863336373928, -31.492296079000823],
          [115.584877685057222, -31.492394190539414],
          [115.584885742083429, -31.492493017938386],
          [115.584887474177663, -31.49259215830142],
          [115.584882873246102, -31.492691206933614],
          [115.584871958174404, -31.49278975914001],
          [115.584854774828045, -31.492887413823041],
          [115.584831391555554, -31.492983772582988],
          [115.584775704635149, -31.493186134432506],
          [115.584772340271343, -31.493198176354724],
          [115.584763357842803, -31.493228685855115],
          [115.584753755781321, -31.493259057759246],
          [115.584743538583552, -31.493289283073921],
          [115.584732708947399, -31.493319353705147],
          [115.584721269570991, -31.493349258861144],
          [115.584709224950871, -31.49337899044798],
          [115.584696576885563, -31.493408537673815],
          [115.584683330771213, -31.493437893344037],
          [115.584669491104137, -31.493467047566128],
          [115.584658285551541, -31.493489523422738],
          [115.584665111405798, -31.493502768637825],
          [115.584679321593512, -31.493531707022612],
          [115.584692940027253, -31.493560854949465],
          [115.584705963109741, -31.493590205223768],
          [115.584718385445171, -31.493619747053629],
          [115.584730204335528, -31.493649472345226],
          [115.584741417082796, -31.493679372105305],
          [115.584752018291056, -31.493709437340613],
          [115.584762005262405, -31.493739658158631],
          [115.584763010704478, -31.493742815678331],
          [115.584863521634247, -31.494059670217553],
          [115.584871886228598, -31.494086880105385],
          [115.584880638430832, -31.494117385109178],
          [115.584888765604092, -31.494148018716032],
          [115.584896268647981, -31.494178771033432],
          [115.584903144864256, -31.494209633068067],
          [115.584909391555243, -31.494240594927476],
          [115.584915006922074, -31.494271647618405],
          [115.584919989166224, -31.494302782147656],
          [115.584924337388316, -31.494333987723337],
          [115.584928048890447, -31.494365255352193],
          [115.58493040781218, -31.494389281639997],
          [115.584954304597545, -31.494409842839957],
          [115.584979678969034, -31.494432453594811],
          [115.585004586592504, -31.494455442964295],
          [115.585029022971071, -31.494478801955097],
          [115.585052978212389, -31.494502525171356],
          [115.585076445121899, -31.494526605418457],
          [115.585099417404308, -31.494551034602523],
          [115.585121887864943, -31.494575804629619],
          [115.585143849309247, -31.494600910103884],
          [115.585165295442039, -31.494626341132687],
          [115.585186219968136, -31.494652091420846],
          [115.585206615692869, -31.494678151975108],
          [115.585226477220203, -31.494704517399498],
          [115.585245798255073, -31.494731175103595],
          [115.585264573401446, -31.494758120590745],
          [115.585282794565387, -31.49478534576707],
          [115.585300459048995, -31.494812840739939],
          [115.58531755965771, -31.494840597415589],
          [115.585334092794255, -31.494868607700027],
          [115.585350052163221, -31.494896862600058],
          [115.58536543326818, -31.494925354921122],
          [115.585380231612476, -31.494954073871384],
          [115.585394442699453, -31.494983012256171],
          [115.585408061133194, -31.495012161082343],
          [115.58541143538946, -31.495019618260756],
          [115.585462371191511, -31.49513294542902],
          [115.585472020917109, -31.495154839424231],
          [115.585484444151803, -31.495184380354829],
          [115.58549626304216, -31.495214105646426],
          [115.585507475789427, -31.495244005406505],
          [115.585518076997687, -31.495274070641813],
          [115.585528064868413, -31.495304290560512],
          [115.585537435804099, -31.495334658867364],
          [115.585546089980085, -31.495365209736576],
          [115.585546363374078, -31.495365830268781],
          [115.585555135361233, -31.495379484675425],
          [115.585572236869325, -31.495407241351074],
          [115.585588770005756, -31.495435251635513],
          [115.585604729374836, -31.495463507434863],
          [115.585611891575581, -31.495476775133],
          [115.585614829660699, -31.495479788761202],
          [115.585637801943108, -31.495504217945268],
          [115.585660273303006, -31.495528987972364],
          [115.585682234747424, -31.495554093446628],
          [115.585703681779592, -31.495579523576112],
          [115.585724606305575, -31.495605273864271],
          [115.585745002030308, -31.495631335317853],
          [115.585764863557642, -31.495657698943603],
          [115.585784184592512, -31.49568435844634],
          [115.585802959738885, -31.49571130393349],
          [115.585805013790377, -31.495714319360332],
          [115.585959520915253, -31.495941558256277],
          [115.586013616934906, -31.496025735699106],
          [115.586062464511201, -31.496113063467078],
          [115.586105880182231, -31.49620321510622],
          [115.586143701170954, -31.496295853370896],
          [115.586175787182924, -31.496390630223345],
          [115.586202016809693, -31.49648719223012],
          [115.586222292025241, -31.496585177863608],
          [115.586319077063763, -31.497150074416368],
          [115.586332584880893, -31.497247205693952],
          [115.586339928744792, -31.497344996174604],
          [115.586378995294467, -31.498247550384121],
          [115.586380306506044, -31.498334186573402],
          [115.586376776666953, -31.498420760709507],
          [115.586368415669881, -31.498507002995723],
          [115.586355249595158, -31.498592642736241],
          [115.586269176381393, -31.499065305719228],
          [115.586249415578095, -31.499157585154364],
          [115.586224306506551, -31.499248554277301],
          [115.586193932803781, -31.499337903721255],
          [115.586158397891836, -31.499425328615985],
          [115.586117824078428, -31.499510532185241],
          [115.586325411888311, -31.500067996740597],
          [115.586359035740998, -31.500168193807042],
          [115.586385899389825, -31.500270410750829],
          [115.586405883224984, -31.500374193414245],
          [115.586501986577446, -31.500984193665545],
          [115.586513828850229, -31.50107793899565],
          [115.58651994603872, -31.501172231113514],
          [115.586520316559472, -31.501266721082288],
          [115.586514938613618, -31.501361058166253],
          [115.586503831986306, -31.501454893428559],
          [115.586487038046471, -31.501547879730822],
          [115.586464618847117, -31.501639671733415],
          [115.586391494072245, -31.50190537912988],
          [115.586557546693484, -31.501942904241616],
          [115.586647993310294, -31.501965211924926],
          [115.58673748124977, -31.501991099809345],
          [115.586825868419169, -31.502020525626733],
          [115.58734957602212, -31.502206757236024],
          [115.587461958902395, -31.502250064988459],
          [115.58757184256649, -31.502299372118273],
          [115.587678906856127, -31.502354532935328],
          [115.587984394863952, -31.502522851848084],
          [115.588004614321562, -31.502526548961043],
          [115.588111969092211, -31.502548661491517],
          [115.588218164636601, -31.502575799433544],
          [115.588322965332623, -31.502607903431965],
          [115.588426140953743, -31.502644902440238],
          [115.588527461273429, -31.502686713720834],
          [115.588684354299517, -31.502756105409901],
          [115.588692449996643, -31.502759705396045],
          [115.588724758141097, -31.502774457874864],
          [115.588756758717523, -31.502789692390365],
          [115.588788442732493, -31.502805405345157],
          [115.588819800293663, -31.502821590444],
          [115.588850822407608, -31.502838243190354],
          [115.588881497383227, -31.502855359986825],
          [115.588911818026077, -31.502872933638912],
          [115.588941775342732, -31.502890959650017],
          [115.588971359440734, -31.502909432624165],
          [115.589000561326884, -31.502928346266117],
          [115.589012968373822, -31.50293667938422],
          [115.589018679068886, -31.502938964561508],
          [115.589051571772643, -31.5029527403766],
          [115.589084176693405, -31.502967005422931],
          [115.589116484837973, -31.50298175790175],
          [115.589148485414285, -31.502996992417195],
          [115.589180169429369, -31.503012703573347],
          [115.589211526990425, -31.503028889571567],
          [115.589242548205107, -31.503045543217183],
          [115.589273224080102, -31.503062659114391],
          [115.589303545622215, -31.503080232766479],
          [115.589333502938871, -31.503098258777584],
          [115.589363087036872, -31.503116731751732],
          [115.589392288923023, -31.503135646293003],
          [115.589392808731191, -31.503135988934673],
          [115.589601324641535, -31.503273608590121],
          [115.589629616413731, -31.503292615761552],
          [115.589658026896473, -31.503312394551301],
          [115.589686029087034, -31.5033325978211],
          [115.58971361489148, -31.503353216577636],
          [115.589740775316614, -31.503374249022329],
          [115.589767501369124, -31.503395684363284],
          [115.589793785854567, -31.503417518103959],
          [115.589819620679009, -31.503439743949002],
          [115.589844997748514, -31.503462353804537],
          [115.589869908969149, -31.503485342274701],
          [115.589894348045732, -31.503508700366183],
          [115.589903593975691, -31.503517854565303],
          [115.590023424141805, -31.503581267561401],
          [115.59012888314146, -31.503640813472714],
          [115.590230675605312, -31.503706429807835],
          [115.590328452596054, -31.503777894434222],
          [115.590421876868163, -31.503854960038325],
          [115.59057775815711, -31.503991997832372],
          [115.590646515824119, -31.504055293916622],
          [115.590711990965701, -31.504121978646367],
          [115.590774018106458, -31.504191882049668],
          [115.590832438066627, -31.504264827859458],
          [115.590887101558565, -31.504340628117461],
          [115.590950980403477, -31.504434562305164],
          [115.590962747133176, -31.504444685074134],
          [115.590988125101944, -31.504467294929668],
          [115.591013037221956, -31.504490283399832],
          [115.591037476298538, -31.504513640591995],
          [115.591061434237872, -31.504537363808254],
          [115.591084904744662, -31.504561443156035],
          [115.591107880624236, -31.504585871440781],
          [115.591117769569451, -31.504596660607376],
          [115.591221352583375, -31.504710568737721],
          [115.591233938595451, -31.504724548698903],
          [115.591255903637148, -31.504749653273848],
          [115.591277353367218, -31.504775083403331],
          [115.591298280591218, -31.504800832792171],
          [115.591318679913229, -31.504826893346433],
          [115.591338545037843, -31.504853256972183],
          [115.591357868770729, -31.50487991467628],
          [115.591376646615004, -31.50490686016343],
          [115.591394871376224, -31.504934084440379],
          [115.591412538557847, -31.504961579413305],
          [115.591429643663218, -31.504989334290315],
          [115.591436933567707, -31.505001685579259],
          [115.591695259328844, -31.505248548581619],
          [115.592829627285482, -31.506245734852712],
          [115.593111151058793, -31.506473424309036],
          [115.593117841115486, -31.506476478406682],
          [115.593149842591174, -31.506491712022864],
          [115.593181529304161, -31.506507424078336],
          [115.59321288866397, -31.50652360827786],
          [115.593217028243316, -31.506525792731111],
          [115.593347613401647, -31.506594889442567],
          [115.593453077797335, -31.506654431756601],
          [115.593554876556368, -31.506720046293083],
          [115.593652658943142, -31.506791509120831],
          [115.593746090409809, -31.506868572926237],
          [115.593901980691953, -31.507005606223686],
          [115.593970738358962, -31.507068896012697],
          [115.594036214399807, -31.507135575346467],
          [115.594098242440054, -31.507205473353849],
          [115.594156663299486, -31.507278412868402],
          [115.594211330388703, -31.50735420683111],
          [115.594288603736118, -31.507467821782484],
          [115.594295395416225, -31.507477988618234],
          [115.594307683752618, -31.5074869944292],
          [115.594393479975224, -31.507553439939272],
          [115.594475476562025, -31.507624522353808],
          [115.594553421703154, -31.507700024036808],
          [115.594708978336712, -31.507859605136616],
          [115.594720624557226, -31.507871659649311],
          [115.594743601336177, -31.507896087034737],
          [115.59476607719273, -31.507920856162514],
          [115.594788044033066, -31.507945959838139],
          [115.594809494662513, -31.507971389967622],
          [115.594830423685153, -31.507997137557822],
          [115.594850824805803, -31.508023199011404],
          [115.594870690829794, -31.508049561737835],
          [115.594890016361205, -31.508076219441932],
          [115.594896737894146, -31.508085863771555],
          [115.594909237571301, -31.508096616065927],
          [115.594934616439446, -31.508119225921519],
          [115.594959530358096, -31.508142212592986],
          [115.594983971233319, -31.508165570684469],
          [115.595007930971292, -31.508189293001408],
          [115.595031404175984, -31.50821337055055],
          [115.595054380954934, -31.508237798835296],
          [115.595064257309673, -31.508248572713399],
          [115.595167850216171, -31.508362477246465],
          [115.595180449717986, -31.508376471596819],
          [115.595202416558323, -31.508401576171764],
          [115.595223868087146, -31.508427006301247],
          [115.595244797109785, -31.508452754790767],
          [115.595265198230322, -31.508478814445709],
          [115.595285064254426, -31.508505178071459],
          [115.595304389785838, -31.508531835775557],
          [115.595323169428752, -31.508558780363387],
          [115.595341395988726, -31.508586003741016],
          [115.595359064968989, -31.508613497814622],
          [115.595376170973623, -31.508641253590952],
          [115.595392707707333, -31.508669262976071],
          [115.59540644125434, -31.508693568952992],
          [115.595559445612025, -31.508828057169069],
          [115.595618279260293, -31.508881932854877],
          [115.595674803449469, -31.50893822771701],
          [115.595728918355007, -31.508996841930639],
          [115.595910124552688, -31.509201810914817],
          [115.595927242248536, -31.50922144941029],
          [115.595948693777245, -31.50924688043915],
          [115.595969623699261, -31.509272628029294],
          [115.595990024819798, -31.509298687684236],
          [115.596009890843902, -31.509325050410723],
          [115.596029217274577, -31.50935170901414],
          [115.596043199034511, -31.509371770191024],
          [115.596047534666013, -31.509375125561576],
          [115.596074264315916, -31.50939656180185],
          [115.596100550599999, -31.509418394643149],
          [115.59612638902172, -31.509440618689553],
          [115.596151768789127, -31.509463227645767],
          [115.596176682707778, -31.509486215216612],
          [115.596201123583, -31.509509573308094],
          [115.596225085119613, -31.509533294725713],
          [115.596248557425042, -31.509557373174175],
          [115.5962553715882, -31.509564527281043],
          [115.596384953103211, -31.50970126919816],
          [115.596401115719004, -31.509718541577399],
          [115.596423591575558, -31.509743311604495],
          [115.596445559315157, -31.509768415280121],
          [115.59646701084398, -31.509793845409604],
          [115.596487940765883, -31.509819593899067],
          [115.596508341886533, -31.509845653554009],
          [115.5965282088099, -31.509872016280497],
          [115.596547535240575, -31.509898673984594],
          [115.596554246881055, -31.509908303925044],
          [115.596566760047949, -31.50991906701131],
          [115.596592139815471, -31.509941675967525],
          [115.596617054633384, -31.509964664437689],
          [115.596641496407983, -31.509988021629852],
          [115.596665457045219, -31.510011743047471],
          [115.596688930250025, -31.510035820596613],
          [115.596711908827615, -31.51006024798204],
          [115.596721779786321, -31.510071015564847],
          [115.596825377189475, -31.510184920097913],
          [115.596837982087209, -31.510198920743562],
          [115.596859949826921, -31.510224024419131],
          [115.596881401355631, -31.510249453649351],
          [115.59690233217691, -31.510275203038134],
          [115.596922733297561, -31.510301262693076],
          [115.596942600220927, -31.510327625419507],
          [115.596961926651602, -31.510354283123604],
          [115.59698070629463, -31.510381227711434],
          [115.596998934653129, -31.5104084501898],
          [115.597016603633392, -31.510435944263349],
          [115.597029863237708, -31.510457457845348],
          [115.597542966035121, -31.510870881585845],
          [115.597605029148781, -31.510923013486263],
          [115.59766488442699, -31.510977666186307],
          [115.597976358322285, -31.51127426889235],
          [115.597990984896114, -31.511288345081027],
          [115.598014946432727, -31.511312065599327],
          [115.598038419637419, -31.511336144047789],
          [115.598061399114385, -31.511360571433158],
          [115.598083875870202, -31.511385340560992],
          [115.598105843609801, -31.51141044333724],
          [115.598127296037887, -31.511435872567404],
          [115.59814822685928, -31.511461621956244],
          [115.598168628879193, -31.511487681611186],
          [115.598188496701823, -31.511514044337616],
          [115.598207823132611, -31.511540701142394],
          [115.598226603674902, -31.511567645730224],
          [115.598244832033402, -31.511594869107853],
          [115.598262501913041, -31.511622362282139],
          [115.598279608816938, -31.511650118058469],
          [115.598296147349402, -31.511678127443588],
          [115.598309871903098, -31.511702415434058],
          [115.598462887052619, -31.511836900052856],
          [115.598521722499527, -31.511890772141385],
          [115.59857824758808, -31.511947063406183],
          [115.59863236519152, -31.512005674022589],
          [115.598792547038443, -31.512186842448784],
          [115.598875915091526, -31.512249253600146],
          [115.598955925975247, -31.512315914947465],
          [115.59905986602007, -31.512407266282253],
          [115.599082265434276, -31.512427260009986],
          [115.59910718025219, -31.51245024668151],
          [115.599131622926166, -31.512473603873673],
          [115.599155585362041, -31.512497325291292],
          [115.599179058566733, -31.512521402840434],
          [115.599202038942963, -31.512545830225861],
          [115.599224515698893, -31.512570597554998],
          [115.599246484337868, -31.512595701230566],
          [115.599267937665218, -31.512621131360106],
          [115.599288867587234, -31.512646879849569],
          [115.599309271405787, -31.512672938605192],
          [115.599329139228416, -31.512699301331622],
          [115.599348466558581, -31.51272595903572],
          [115.59936243302991, -31.512745995031594],
          [115.599366793842478, -31.512749371985876],
          [115.599393524391644, -31.512770806427511],
          [115.599419813373743, -31.512792638369547],
          [115.599445652694726, -31.512814862415951],
          [115.599471034260887, -31.512837469573526],
          [115.599495949978177, -31.512860457144313],
          [115.599520392652039, -31.512883814336533],
          [115.599542396364541, -31.512905565339508],
          [115.599723956895104, -31.513087978427393],
          [115.599761866017388, -31.513127287794077],
          [115.599819517956462, -31.513164949602697],
          [115.599912369360368, -31.513214522931833],
          [115.600002588448774, -31.513268736762768],
          [115.600089944995034, -31.51332745349913],
          [115.600174213269383, -31.5133905211556],
          [115.600255177434519, -31.513457778753434],
          [115.600333136065387, -31.513526291804851],
          [115.600355549868823, -31.513546297223797],
          [115.600380465586113, -31.513569283895265],
          [115.600404909159238, -31.513592641087484],
          [115.600428871595227, -31.513616363404424],
          [115.600452346598559, -31.513640440054246],
          [115.600475326075525, -31.513664867439616],
          [115.600480337097906, -31.513670372189893],
          [115.600570575072084, -31.5137380983345],
          [115.600656801170544, -31.513810864279947],
          [115.60073873480485, -31.513888431705709],
          [115.600920300731332, -31.514070842095634],
          [115.600985386466505, -31.514139516125738],
          [115.601046803867007, -31.51421148886908],
          [115.601104387457553, -31.514286564273505],
          [115.601157980756284, -31.514364539092185],
          [115.601264586391608, -31.5145292040595],
          [115.60138187687221, -31.51464817627226],
          [115.601749708582247, -31.514935553732755],
          [115.601817579517729, -31.514991001433543],
          [115.601882890083402, -31.515049441178746],
          [115.601945508978133, -31.515110756955835],
          [115.602256677104037, -31.515429900269623],
          [115.602319635942536, -31.515497584146146],
          [115.602379014579924, -31.515568430038968],
          [115.602434653836212, -31.51564224819117],
          [115.602486407122001, -31.515718842550484],
          [115.60253413414307, -31.515798007172236],
          [115.602552269871467, -31.515830094982846],
          [115.602556263760675, -31.515832976410707],
          [115.60258385496104, -31.515853593368604],
          [115.602611020782092, -31.515874623115337],
          [115.602637753129898, -31.515896056657652],
          [115.602664043910522, -31.515917888599631],
          [115.602689884130882, -31.515940111746716],
          [115.602715266596306, -31.515962719803611],
          [115.602740184112236, -31.515985705575815],
          [115.602764627685474, -31.516009062767978],
          [115.602788591919989, -31.516032783286278],
          [115.602812067822697, -31.51605686083542],
          [115.602835048198926, -31.516081287321526],
          [115.602857527652873, -31.516106056449303],
          [115.602879497191111, -31.516131158326232],
          [115.602900952317214, -31.516156587556452],
          [115.602921884937132, -31.516182335146596],
          [115.602929863722238, -31.516192407553547],
          [115.60316240412169, -31.516488137917179],
          [115.603215434444792, -31.516559096225251],
          [115.603264803627894, -31.516632648178131],
          [115.603310386665044, -31.516708604918165],
          [115.603473565053037, -31.516997319670509],
          [115.603489959694002, -31.517010464161558],
          [115.603516249575364, -31.517032296103537],
          [115.603542090694987, -31.517054519250621],
          [115.603567474059787, -31.517077127307516],
          [115.603592391575717, -31.517100113079721],
          [115.603616836048218, -31.517123469372564],
          [115.603640800282733, -31.517147190790183],
          [115.603664277084818, -31.517171267440006],
          [115.60368725836031, -31.517195693926112],
          [115.603709737814256, -31.517220462154569],
          [115.603731708251757, -31.517245564930818],
          [115.60375316337786, -31.517270993261661],
          [115.603774095997778, -31.517296740851862],
          [115.603794500715708, -31.517322801406124],
          [115.603802314025643, -31.517333045583541],
          [115.603957234838617, -31.517537715093454],
          [115.604007111239298, -31.517606933213358],
          [115.604053498270446, -31.517678536335325],
          [115.604096281718057, -31.517752349091609],
          [115.604135357261043, -31.517828189819056],
          [115.604153757390009, -31.517866303087374],
          [115.604161770349492, -31.517873193692878],
          [115.604187153714179, -31.51789580174983],
          [115.604212071230108, -31.517918788421298],
          [115.604236516601986, -31.517942144714141],
          [115.604260480836615, -31.517965865232441],
          [115.604283957638586, -31.517989941882263],
          [115.604306938914192, -31.51801436836837],
          [115.604329418368025, -31.518039136596826],
          [115.604351389704902, -31.518064237574436],
          [115.604372844831005, -31.518089667703975],
          [115.6043937783503, -31.518115415294119],
          [115.604414183068116, -31.518141474049742],
          [115.604434053588761, -31.518167835876852],
          [115.604453382717452, -31.51819449268163],
          [115.604472165957759, -31.518221436370141],
          [115.604490397014274, -31.518248658848506],
          [115.604508069591816, -31.518276152022736],
          [115.604508309710809, -31.518276532436005],
          [115.604636909166061, -31.518480915062128],
          [115.60465378044762, -31.518508288626549],
          [115.604670320778723, -31.518536297112405],
          [115.604686288241624, -31.518564551113116],
          [115.604701677440517, -31.518593040736221],
          [115.604716483878633, -31.518621758787106],
          [115.604730703059545, -31.518650695373253],
          [115.60474432958722, -31.518679842400786],
          [115.604757360763642, -31.518709190876393],
          [115.60476979209227, -31.518738730907671],
          [115.604781619076562, -31.518768455299949],
          [115.604792839018387, -31.518798354160651],
          [115.604803448320581, -31.518828417597376],
          [115.604805273045031, -31.518833935837449],
          [115.604858429273122, -31.518900732982388],
          [115.605013354582752, -31.519105401592981],
          [115.60505880452024, -31.519168227331761],
          [115.60510141439886, -31.519233012693348],
          [115.605141100581363, -31.519299629074567],
          [115.605346328570249, -31.519662715961545],
          [115.605394705801132, -31.519754554728877],
          [115.605437101640973, -31.519849301903719],
          [115.605473343420158, -31.519946570777563],
          [115.605503280951666, -31.520045960252844],
          [115.605526792827277, -31.520147062936587],
          [115.60562471730691, -31.520644298995137],
          [115.605638330344732, -31.52072429189252],
          [115.60564773905196, -31.520804888234977],
          [115.605652915549626, -31.520885865889966],
          [115.605653847247368, -31.520967003624264],
          [115.605646284848262, -31.521476037888817],
          [115.60567155220042, -31.521651402989789],
          [115.605744328038327, -31.521824304847769],
          [115.605779606643637, -31.521915680464247],
          [115.605809224915902, -31.522009043582443],
          [115.605833072238511, -31.522104045265451],
          [115.605882372173824, -31.522330114143415],
          [115.605884133046402, -31.522338295276086],
          [115.605890386931833, -31.522369256236118],
          [115.605896008593959, -31.522400308027727],
          [115.605900998932043, -31.522431441657659],
          [115.605905353449316, -31.52246264723334],
          [115.605909072146005, -31.522493914862252],
          [115.605909793402361, -31.522501237142365],
          [115.605935595851179, -31.522585312062461],
          [115.605947029831668, -31.522626723144697],
          [115.605972781918467, -31.522662427129262],
          [115.606307966439545, -31.523139694641145],
          [115.606354904755108, -31.52321008277903],
          [115.606398347405843, -31.523282680551233],
          [115.606886108207391, -31.524145562967306],
          [115.606962668392498, -31.524263793239413],
          [115.607032766049429, -31.524330352064055],
          [115.607099216955362, -31.524400552243662],
          [115.607161834051453, -31.524474192330047],
          [115.607220438372565, -31.524551065479272],
          [115.607274862644886, -31.524630951357267],
          [115.60732495308423, -31.524713624234323],
          [115.607401920662141, -31.524849781592081],
          [115.607409869769754, -31.524864004370272],
          [115.607425260767286, -31.524892493993377],
          [115.607440069004042, -31.524921212044262],
          [115.607454289084217, -31.52495014863041],
          [115.607467918309794, -31.524979294758623],
          [115.607480950385593, -31.52500864323423],
          [115.607493382613598, -31.525038184164828],
          [115.607502201365605, -31.52506034525868],
          [115.607537789337584, -31.525108674825447],
          [115.607666737729801, -31.525290504253348],
          [115.607719750066508, -31.525369697653389],
          [115.607768272088151, -31.525451719421255],
          [115.607812155406691, -31.52553631414952],
          [115.607830559133049, -31.525574431015116],
          [115.607838583783632, -31.525581332412514],
          [115.607863969846449, -31.52560393867077],
          [115.607888890959657, -31.525626924442975],
          [115.607913338130061, -31.525650279836498],
          [115.607937305062592, -31.525674000354797],
          [115.607960783663316, -31.52569807700462],
          [115.607983767636824, -31.52572250259135],
          [115.608006249788673, -31.525747269920544],
          [115.60802822292419, -31.525772371797473],
          [115.608049680748195, -31.525797800128316],
          [115.608070616965506, -31.525823547718517],
          [115.608091022582698, -31.52584960557482],
          [115.608110896700623, -31.52587596740193],
          [115.608130229426592, -31.525902623307388],
          [115.608131556825924, -31.525904494796578],
          [115.608260507016894, -31.526086322425783],
          [115.608321151899759, -31.526177618901954],
          [115.608375734452693, -31.526272664651685],
          [115.608424021751262, -31.526371057678148],
          [115.608465809649488, -31.526472381595113],
          [115.608472222715022, -31.526489587424464],
          [115.608475586179452, -31.526493037223872],
          [115.608498571052223, -31.526517462810602],
          [115.608521053204072, -31.526542230139739],
          [115.608543026339703, -31.526567332016725],
          [115.608564485062971, -31.526592760347569],
          [115.608585420380905, -31.526618507937769],
          [115.608605827796737, -31.526644565794015],
          [115.608625701015399, -31.526670927621183],
          [115.608645032842105, -31.52669758442596],
          [115.608663818780315, -31.526724527215094],
          [115.608682051635469, -31.52675174879414],
          [115.608699726910913, -31.52677924106905],
          [115.608716839210842, -31.52680699594606],
          [115.608733382239848, -31.526835004431859],
          [115.608741395199331, -31.526849023063903],
          [115.608818367273898, -31.526985180421718],
          [115.608826323576068, -31.526999413991746],
          [115.608841714573487, -31.527027903614794],
          [115.608856523709619, -31.527056620766416],
          [115.60887074468917, -31.527085557352564],
          [115.608884373914748, -31.5271147025814],
          [115.608888578245342, -31.527124169744582],
          [115.608894731406735, -31.527132995691147],
          [115.608912964262004, -31.527160217270193],
          [115.608930640436824, -31.527187710444423],
          [115.608947751837377, -31.527215464422113],
          [115.608964295765645, -31.527243472907912],
          [115.608972307825752, -31.527257488841997],
          [115.609049279900432, -31.527393645300435],
          [115.609057238001242, -31.527407881568422],
          [115.609072629898037, -31.527436372090847],
          [115.60908743903417, -31.527465089242412],
          [115.609101660013607, -31.52749402582856],
          [115.609115289239298, -31.527523171956773],
          [115.60912832221436, -31.527552520432437],
          [115.609140755341627, -31.527582059564338],
          [115.609152584124558, -31.527611784855935],
          [115.609163805865023, -31.527641682817375],
          [115.609174416965857, -31.527671746254043],
          [115.609184413829666, -31.527701965273423],
          [115.609193793758664, -31.527732331781635],
          [115.609202553155342, -31.527762835886108],
          [115.609203272613058, -31.527765542845486],
          [115.609451523269286, -31.528046217658755],
          [115.609496430016293, -31.528098959299484],
          [115.609539297100923, -31.528153370981215],
          [115.609797546419713, -31.528494475739421],
          [115.609843003551873, -31.528557300578939],
          [115.609885620624937, -31.52862208504115],
          [115.609925314002112, -31.528688701422368],
          [115.610079262647901, -31.528961011641343],
          [115.610128296383778, -31.529054400839868],
          [115.610171253400722, -31.529150736217446],
          [115.610207957431385, -31.52924962297169],
          [115.610283594912062, -31.529475976035428],
          [115.610290038554467, -31.529495682879428],
          [115.610299419382727, -31.529526049387641],
          [115.610308179678782, -31.529556552592794],
          [115.610316316744729, -31.529587185300329],
          [115.610323829681079, -31.529617936718353],
          [115.610326860396299, -31.529631524575166],
          [115.610330195981874, -31.529637698421027],
          [115.610345005118006, -31.529666415572592],
          [115.61035922699682, -31.52969535125942],
          [115.610372856222398, -31.529724498286896],
          [115.610385890096836, -31.52975384586324],
          [115.610398324123366, -31.529783385894518],
          [115.61041015380556, -31.529813110286739],
          [115.610421376445402, -31.529843008248179],
          [115.610431988445612, -31.529873071684847],
          [115.610435542566279, -31.529883589256201],
          [115.610511181845595, -31.530109942319939],
          [115.610527013510932, -31.530160040853161],
          [115.610541113981299, -31.530210653798576],
          [115.610573390649506, -31.53024850536417],
          [115.610641808372861, -31.530333523673107],
          [115.61070470605739, -31.530422704044497],
          [115.610761830993738, -31.530515686749482],
          [115.610812953854747, -31.530612100368103],
          [115.610857871393705, -31.530711557292477],
          [115.610860670983243, -31.530713000704395],
          [115.610891703889138, -31.530729649853413],
          [115.61092239055597, -31.530746762153285],
          [115.610952724688559, -31.530764332208093],
          [115.610982693696428, -31.5307823537226],
          [115.611012288586267, -31.530800823099469],
          [115.611017437205078, -31.530804105624952],
          [115.611304358709276, -31.530987645563357],
          [115.61138448740428, -31.531041558121387],
          [115.611461994575507, -31.531099174087558],
          [115.611930534166845, -31.531465111825412],
          [115.612013968769702, -31.531533998095483],
          [115.612093477831763, -31.5316073809758],
          [115.612327082129241, -31.531835447248056],
          [115.612348205405397, -31.531856393357828],
          [115.612371686704023, -31.53188046910833],
          [115.612394673375547, -31.531904894695117],
          [115.612417157326036, -31.531929661124934],
          [115.612439133159569, -31.531954763001863],
          [115.612460592782213, -31.531980190433387],
          [115.61248153079805, -31.532005937124268],
          [115.612501940012635, -31.532031994980514],
          [115.612521815029822, -31.532058355908362],
          [115.612541148655168, -31.53208501181382],
          [115.612552674366498, -31.53210153955439],
          [115.612557174574022, -31.532105841011685],
          [115.612581145103832, -31.532129559731345],
          [115.612604626402458, -31.532153634582528],
          [115.612627613073983, -31.532178061068635],
          [115.612650097923733, -31.532202828397772],
          [115.61267207285789, -31.532227929375381],
          [115.612693533379911, -31.532253356806905],
          [115.612714471395748, -31.532279102598466],
          [115.612734880610333, -31.532305161354088],
          [115.61275475562752, -31.532331522281879],
          [115.612774090152243, -31.532358178187337],
          [115.612792876989715, -31.532385120976528],
          [115.612811113442149, -31.532412342555517],
          [115.61282878961697, -31.532439834830484],
          [115.612845903715538, -31.532467588808117],
          [115.612862449442559, -31.532495596394597],
          [115.612878421402115, -31.532523848596668],
          [115.612893814198173, -31.532552339119093],
          [115.612908624233683, -31.532581055371338],
          [115.612922847011873, -31.532609991957543],
          [115.61293647803609, -31.532639138085699],
          [115.612949512809791, -31.532668485662043],
          [115.612961947735812, -31.532698025693264],
          [115.612973778317269, -31.532727750085542],
          [115.612985001856373, -31.532757648046982],
          [115.612995613856583, -31.53278771058433],
          [115.613004885866872, -31.532815734358621],
          [115.613023000910857, -31.532831896974415],
          [115.613047924721968, -31.5328548818473],
          [115.613072374590502, -31.532878237240823],
          [115.613096344220935, -31.532901955960483],
          [115.613119826418938, -31.532926032610249],
          [115.613142813090462, -31.532950457297716],
          [115.613165297940213, -31.532975224626853],
          [115.613187273773747, -31.533000325604519],
          [115.613208734295767, -31.533025753036043],
          [115.613229672311604, -31.533051499726866],
          [115.613250082425452, -31.533077557583169],
          [115.61326995744264, -31.533103919410337],
          [115.613289291067986, -31.533130574416418],
          [115.613308078804835, -31.533157517205609],
          [115.613326314358005, -31.533184738784598],
          [115.613343992331465, -31.533212230160245],
          [115.613361106430034, -31.533239984137936],
          [115.613377652156942, -31.533267992623735],
          [115.613393624116497, -31.533296244825806],
          [115.613396546913123, -31.533301654247907],
          [115.613406268584527, -31.53331127519516],
          [115.613429751681792, -31.533335350945663],
          [115.613452738353203, -31.533359775633073],
          [115.613475223203068, -31.533384542962267],
          [115.613497199036601, -31.533409643939876],
          [115.613518659558508, -31.5334350713714],
          [115.613539597574459, -31.533460818062281],
          [115.613560008587569, -31.533486875918527],
          [115.613579883604757, -31.533513236846375],
          [115.61359921812948, -31.533539892751833],
          [115.613618005866329, -31.533566836440286],
          [115.613620016750474, -31.533569784417978],
          [115.613697330567447, -31.533683387678138],
          [115.613713556135735, -31.533707661279493],
          [115.613731233209933, -31.53373515265514],
          [115.613748348207764, -31.533762906632774],
          [115.613764893934786, -31.533790914219253],
          [115.613778688635648, -31.53381531642367],
          [115.613822735630833, -31.533855311973014],
          [115.613865453428048, -31.533896724853946],
          [115.613877453981331, -31.533902200825878],
          [115.613909468047609, -31.533917430844724],
          [115.613941165552433, -31.533933138403597],
          [115.613972535703965, -31.533949319005842],
          [115.614003570408499, -31.53396596725554],
          [115.614034259773348, -31.533983078656092],
          [115.614064593905937, -31.534000647811581],
          [115.614094563813183, -31.534018669326088],
          [115.614124161401037, -31.534037137803637],
          [115.614153375877663, -31.53405604784831],
          [115.614182200048504, -31.534075392265493],
          [115.614210623121835, -31.534095166558643],
          [115.614238638802249, -31.534115366231106],
          [115.614266237197171, -31.534135981390364],
          [115.614293410212781, -31.534157008439138],
          [115.614320148855882, -31.534178441082133],
          [115.614346445931801, -31.534200270326153],
          [115.614372293346719, -31.534222492573917],
          [115.61437524132441, -31.534225077225472],
          [115.614479218241399, -31.534316415969784],
          [115.61450165992369, -31.534336437576485],
          [115.614526583734914, -31.53435942244937],
          [115.614551035401973, -31.534382777842893],
          [115.61457500503252, -31.534406496562497],
          [115.61459848723041, -31.534430572312999],
          [115.614621474801311, -31.534454997000466],
          [115.614643961449701, -31.534479764329603],
          [115.614665937283235, -31.534504865307269],
          [115.614687397805255, -31.534530292738793],
          [115.614708336720469, -31.534556039429617],
          [115.614728746834317, -31.5345820963866],
          [115.614748622750767, -31.534608457314391],
          [115.614767958174752, -31.534635113219849],
          [115.614786745911601, -31.53466205510972],
          [115.614804982364149, -31.534689276688709],
          [115.614822660337609, -31.534716768963676],
          [115.61483977533544, -31.53474452294131],
          [115.614849169653553, -31.534760424753756],
          [115.614859278932613, -31.534770427912861],
          [115.614882762029879, -31.534794503663363],
          [115.61490574960078, -31.53481892835083],
          [115.614928235349794, -31.534843694780648],
          [115.614950212082704, -31.534868795758257],
          [115.614971672604725, -31.534894223189781],
          [115.614972911870495, -31.534895720560996],
          [115.615179871054238, -31.53514604775188],
          [115.615227265326098, -31.535205880546926],
          [115.61527204167146, -31.535267696347091],
          [115.615314119151321, -31.53533138093843],
          [115.61541529557951, -31.535492117667047],
          [115.615419229214126, -31.5354945719169],
          [115.615448444590129, -31.535513481062253],
          [115.615477268760969, -31.535532826378812],
          [115.61550569363294, -31.535552600671963],
          [115.61553370931324, -31.535572799445106],
          [115.615561308607539, -31.535593414604364],
          [115.615588481623149, -31.535614441653138],
          [115.615615221165626, -31.535635873396814],
          [115.615641519140809, -31.535657704439473],
          [115.61566736655584, -31.535679924888598],
          [115.615692757115085, -31.535702531146853],
          [115.615717681825572, -31.535725515120362],
          [115.615742132593368, -31.535748869614622],
          [115.615766104022555, -31.535772589233545],
          [115.615789587119821, -31.535796664084728],
          [115.615812574690608, -31.535821088772195],
          [115.615835061339112, -31.535845855202012],
          [115.615857038071908, -31.535870956179622],
          [115.615878498593929, -31.535896383611146],
          [115.615899439307782, -31.535922130302026],
          [115.615919850320893, -31.53594818725901],
          [115.615939726237457, -31.5359745481868],
          [115.615959061661442, -31.536001203192939],
          [115.615977850297668, -31.536028145982129],
          [115.615979854886405, -31.536031084966567],
          [115.616057174998673, -31.536144688226727],
          [115.616073406862256, -31.536168970821279],
          [115.616091085735093, -31.536196462196926],
          [115.616108200732924, -31.536224216174617],
          [115.616124748258585, -31.536252223761096],
          [115.616140721117404, -31.536280475963167],
          [115.616156115712215, -31.536308964686953],
          [115.616170928445626, -31.536337681838518],
          [115.61618515212308, -31.536366618424665],
          [115.616198784046674, -31.536395763653502],
          [115.61620052963076, -31.536399694590216],
          [115.616209604689516, -31.536407496208938],
          [115.616234995248874, -31.536430101567873],
          [115.616259919959361, -31.536453086440758],
          [115.616284371626534, -31.536476440934962],
          [115.616308343055607, -31.536500159654622],
          [115.616331826152873, -31.536524235405068],
          [115.616350399851171, -31.536543900880304],
          [115.616583694781752, -31.536794511357584],
          [115.616588109553618, -31.536799269670496],
          [115.616610596202122, -31.53682403610037],
          [115.616632572934918, -31.536849137077979],
          [115.616654035255578, -31.536874565408823],
          [115.616674975070055, -31.536900310301007],
          [115.616695386083279, -31.53692636815731],
          [115.616715262899106, -31.536952728185838],
          [115.616734599222468, -31.536979384091239],
          [115.61675338785858, -31.53700632598111],
          [115.61677162521039, -31.5370335475601],
          [115.616789304083227, -31.537061038935747],
          [115.616806419980321, -31.537088792913437],
          [115.616822966606719, -31.537116799600597],
          [115.616836755911663, -31.537141189214481],
          [115.616856228931852, -31.537158526344854],
          [115.616881153642339, -31.537181510318419],
          [115.616905606208775, -31.537204864812622],
          [115.616929577637961, -31.537228584431602],
          [115.616953060735227, -31.537252659282728],
          [115.616976050104654, -31.537277083970196],
          [115.616998535853782, -31.537301850400013],
          [115.617020512586691, -31.53732694957904],
          [115.617041975806615, -31.537352377909883],
          [115.617062915621091, -31.537378124600707],
          [115.617083328432955, -31.53740418155769],
          [115.617103204349519, -31.537430541586161],
          [115.617118707762188, -31.537451830337659],
          [115.617428331752194, -31.537883688381442],
          [115.617468788653696, -31.537942605666672],
          [115.617506794902738, -31.538003132738368],
          [115.617969410659839, -31.53877494260945],
          [115.618008395371248, -31.538843512318181],
          [115.618044105651052, -31.53891384200017],
          [115.618076462358886, -31.53898577697197],
          [115.618305448637557, -31.539529527765467],
          [115.618311650362443, -31.539544458310047],
          [115.618323482742539, -31.539574181803005],
          [115.618334708080397, -31.539604079764445],
          [115.618345322778509, -31.539634142301793],
          [115.618355323239598, -31.539664361321172],
          [115.618364706765874, -31.539694726930065],
          [115.618373469759831, -31.539725231034538],
          [115.618381610423057, -31.539755862842753],
          [115.618389125158046, -31.539786614260777],
          [115.618396013065649, -31.539817473597509],
          [115.618402271447735, -31.539848434557541],
          [115.618405999137622, -31.539869012844633],
          [115.618426502780949, -31.539893302633743],
          [115.618447442595425, -31.539919048425304],
          [115.618467855407289, -31.539945105382287],
          [115.618487733122493, -31.539971466310078],
          [115.618507070345117, -31.539998121316216],
          [115.618525860779869, -31.540025063206031],
          [115.61853480543698, -31.540038415440449],
          [115.618548638808647, -31.540048387123306],
          [115.618576239901586, -31.540069002282564],
          [115.618603414715835, -31.540090028432019],
          [115.618630156056952, -31.540111459276375],
          [115.618656455830887, -31.540133289419714],
          [115.618682305044445, -31.540155509868839],
          [115.618707697402328, -31.540178115227775],
          [115.618732623012193, -31.54020109920134],
          [115.618757075578628, -31.540224453695544],
          [115.618781048806454, -31.540248172415204],
          [115.61880453370236, -31.54027224726633],
          [115.618827523071786, -31.540296671953797],
          [115.618850010619553, -31.540321436584975],
          [115.618871989150989, -31.540346537562641],
          [115.618893452371026, -31.540371964994165],
          [115.618914393984141, -31.540397710785669],
          [115.618934805896629, -31.540423768641972],
          [115.6189425850323, -31.540433963356691],
          [115.618994248385889, -31.540502181430497],
          [115.619053210637276, -31.540584982011239],
          [115.619060169591194, -31.540592376237157],
          [115.619065173419131, -31.540597859403647],
          [115.619147634056162, -31.540658815451934],
          [115.619226619712776, -31.540724212352472],
          [115.619301892068734, -31.54079385135509],
          [115.619373223595403, -31.540867522018459],
          [115.619440397556332, -31.540945002210037],
          [115.619503211603956, -31.54102605720675],
          [115.619561475082037, -31.541110442392949],
          [115.61961501262283, -31.541197902361262],
          [115.619623003998527, -31.541212033408556],
          [115.619649764225301, -31.541228121380641],
          [115.619679363611795, -31.54124658895887],
          [115.619708581685813, -31.541265497204904],
          [115.61973740855467, -31.541284841622087],
          [115.619765835225166, -31.541304615915237],
          [115.619793853603483, -31.541324812889741],
          [115.619821454696421, -31.541345428048999],
          [115.619848630410047, -31.541366454198453],
          [115.619875372650426, -31.541387885042809],
          [115.619901672424248, -31.541409714286829],
          [115.619927523436559, -31.541431934735954],
          [115.61993043634061, -31.54143448791126],
          [115.619942961198717, -31.541445489317823],
          [115.620067605435679, -31.541508285378995],
          [115.620160698757331, -31.541557908170887],
          [115.620251154367338, -31.541612192148932],
          [115.620338738442115, -31.541670997018855],
          [115.62042322525167, -31.54173416989596],
          [115.620504398059552, -31.541801548902299],
          [115.620660386367831, -31.54193855162282],
          [115.620729869787738, -31.542002560869435],
          [115.620796036507954, -31.542069994734447],
          [115.620858715657278, -31.542140680547902],
          [115.62091774895498, -31.542214439344832],
          [115.621072742613023, -31.542419089069654],
          [115.621118215033675, -31.542481911211212],
          [115.621160847395231, -31.542546694774103],
          [115.621200555161522, -31.542613310256002],
          [115.621247255156732, -31.54269588330834],
          [115.621476963591022, -31.542868851716094],
          [115.621558041970161, -31.542933207201713],
          [115.621635602201309, -31.543001761621952],
          [115.621709426648749, -31.543074323421251],
          [115.621994749158375, -31.543370590680183],
          [115.621997966932668, -31.543373939755497],
          [115.622020958100848, -31.543398364442908],
          [115.622043447447254, -31.543423129074085],
          [115.622065426878066, -31.543448229152432],
          [115.622086890997252, -31.543473656583956],
          [115.622107834409121, -31.54349940057682],
          [115.622128247220871, -31.543525458433123],
          [115.622148126734714, -31.543551817562275],
          [115.622167464856716, -31.543578472568413],
          [115.622186257090107, -31.543605413558964],
          [115.622195193653283, -31.54361875230353],
          [115.622209042313557, -31.543628734778224],
          [115.622236644305758, -31.543649349038162],
          [115.622263820918647, -31.543670374288297],
          [115.622290564058289, -31.543691805132653],
          [115.622316864731602, -31.543713634376672],
          [115.622342716643175, -31.543735853926478],
          [115.622368109900435, -31.543758459285414],
          [115.622393037308939, -31.543781442359659],
          [115.622417492573277, -31.543804796853863],
          [115.622441466700366, -31.543828514674146],
          [115.622464951596271, -31.543852590424649],
          [115.622487943663714, -31.543877013313477],
          [115.62251043301012, -31.543901778843974],
          [115.622532413340309, -31.543926878922264],
          [115.622537121291202, -31.543932375578606],
          [115.622614789441059, -31.544023425640546],
          [115.622631545609352, -31.544043356415727],
          [115.622652488121844, -31.544069100408592],
          [115.622672901832971, -31.544095157365575],
          [115.622692781346814, -31.544121517394046],
          [115.622712120368078, -31.544148172400185],
          [115.62273091170232, -31.544175113390736],
          [115.622749151752032, -31.544202334070405],
          [115.622766833322771, -31.544229825446052],
          [115.622783951917881, -31.544257579423686],
          [115.622800501242182, -31.544285585211526],
          [115.622816477698393, -31.544313837413597],
          [115.622817518213992, -31.544315761962821],
          [115.622834226718282, -31.544329151069405],
          [115.622860528290857, -31.544350980313425],
          [115.622886380202317, -31.54437320076255],
          [115.622911772560315, -31.544395805222166],
          [115.622936701767458, -31.544418788296412],
          [115.622961157031796, -31.544442142790615],
          [115.622985131158885, -31.544465860610956],
          [115.623008617853543, -31.544489934562762],
          [115.623015359171518, -31.544497005932044],
          [115.623145025222811, -31.544633721768776],
          [115.623161275072903, -31.544651075087017],
          [115.623183764419309, -31.544675840617515],
          [115.623205745648761, -31.544700939796485],
          [115.623227210667324, -31.544726366328689],
          [115.623248153179816, -31.54475211212025],
          [115.623268567790205, -31.544778169077176],
          [115.623288447304049, -31.544804528206384],
          [115.623307786325313, -31.544831183212466],
          [115.623326578558817, -31.544858124203017],
          [115.62334481860853, -31.544885344882744],
          [115.623362500179269, -31.544912836258334],
          [115.623379618774493, -31.544940589336704],
          [115.623396168998056, -31.544968596023864],
          [115.623412144554891, -31.544996847326615],
          [115.623427542746981, -31.545025336050401],
          [115.623429137244898, -31.54502842612095],
          [115.623473728329941, -31.545076003854433],
          [115.624157398345346, -31.545719341074687],
          [115.624225489614673, -31.545786622954267],
          [115.624289991689807, -31.545857353733822],
          [115.624350730102151, -31.545931340958589],
          [115.624407542074437, -31.546008384978961],
          [115.624897577261436, -31.546712805951188],
          [115.624947818786836, -31.546789036984421],
          [115.624993835297346, -31.546867889541431],
          [115.62503549189455, -31.546949130697783],
          [115.625072664471986, -31.547032518535843],
          [115.625105242413042, -31.547117806641438],
          [115.625334645977205, -31.547775356747252],
          [115.625512585837214, -31.548170636665532],
          [115.625601823765237, -31.548312356330143],
          [115.625620053023113, -31.548327483826256],
          [115.625645905833949, -31.548349703376061],
          [115.625671300889849, -31.548372308734997],
          [115.625696230096992, -31.548395290909923],
          [115.625720687160083, -31.548418645404126],
          [115.625744663085811, -31.54844236232509],
          [115.625768150679619, -31.548466436276954],
          [115.625791143646438, -31.548490859165781],
          [115.625813634791484, -31.548515624696279],
          [115.625835616920199, -31.548540723875249],
          [115.625857082838138, -31.548566150407453],
          [115.62587802714927, -31.548591895299694],
          [115.625898443558413, -31.548617951357301],
          [115.625918323971518, -31.548644311385829],
          [115.625937664791422, -31.548670964593271],
          [115.625956457924303, -31.548697905583822],
          [115.625974698873279, -31.548725127162868],
          [115.625992382242657, -31.548752617639138],
          [115.626009501737144, -31.548780370717509],
          [115.626026052860084, -31.548808377404669],
          [115.626042031114935, -31.54883662870742],
          [115.626057430206288, -31.548865117431205],
          [115.626072245637715, -31.548893832784131],
          [115.626086473811824, -31.548922767571639],
          [115.62610011023196, -31.548951912800476],
          [115.626113150401579, -31.548981258578181],
          [115.626125590723518, -31.549010798609402],
          [115.626137426700893, -31.54904052120304],
          [115.626148654736653, -31.54907041826516],
          [115.626159272132782, -31.549100480802508],
          [115.626169276191149, -31.549130699821887],
          [115.626178662415441, -31.549161065430781],
          [115.626187428107414, -31.549191568635933],
          [115.626195570569166, -31.549222200444149],
          [115.626199521290914, -31.549238023116231],
          [115.626249212431276, -31.549441536097959],
          [115.626269619847108, -31.549538117889767],
          [115.626283848021217, -31.549635800451767],
          [115.626291839396913, -31.549734190780214],
          [115.62629356069931, -31.549832889576123],
          [115.626292734222375, -31.549889318437238],
          [115.626331727027605, -31.549989346431175],
          [115.626615180746057, -31.550458558715491],
          [115.626714349887379, -31.550586081682297],
          [115.626734006369361, -31.55059989796689],
          [115.626821304459668, -31.550664069990773],
          [115.626904712982196, -31.550733221560904],
          [115.62698394954964, -31.550807117954093],
          [115.627058742566987, -31.550885507360249],
          [115.627128838425165, -31.550968123579992],
          [115.627193999703422, -31.551054686024884],
          [115.627254004268934, -31.551144899717315],
          [115.627308647076461, -31.551238457988404],
          [115.627539366348742, -31.551669444589152],
          [115.627576873474027, -31.551743827515565],
          [115.627610538695421, -31.551820026173232],
          [115.627640275678232, -31.551897841811922],
          [115.62766600708062, -31.551977072084185],
          [115.627830718812675, -31.552533946684264],
          [115.627990193792471, -31.552868350593883],
          [115.628259598301838, -31.553241105192797],
          [115.628319466170524, -31.553329325987534],
          [115.628373660216312, -31.553421141372553],
          [115.628421965501389, -31.553516187122284],
          [115.628464189570764, -31.553614086420907],
          [115.628641922586667, -31.554067056049746],
          [115.628676153481706, -31.554162735821535],
          [115.628704106209625, -31.554260433672027],
          [115.628725662959027, -31.554359739510346],
          [115.62874073379794, -31.55446023425236],
          [115.628749253975002, -31.554561495216774],
          [115.628751188416686, -31.554663095225635],
          [115.628749479704766, -31.554779875790587],
          [115.62879159315753, -31.554855692236345],
          [115.628862976844971, -31.554907941947931],
          [115.628933373076734, -31.554961872492356],
          [115.629001309662726, -31.555018869725018],
          [115.629469381606782, -31.55542984641022],
          [115.62954001256162, -31.555495022077537],
          [115.629607283649307, -31.555563661034114],
          [115.629771748967073, -31.55574025460902],
          [115.629900829559688, -31.55582846641056],
          [115.629967038548102, -31.55587564304642],
          [115.630031289712292, -31.555925451098631],
          [115.630093479630432, -31.555977811426828],
          [115.630457543181137, -31.556297456562334],
          [115.630516424493408, -31.556351316060329],
          [115.630572997246077, -31.556407595633971],
          [115.630627161614257, -31.55646619725718],
          [115.630808533287222, -31.556671118577242],
          [115.630825759801041, -31.556690862293408],
          [115.630847228416883, -31.556716287926292],
          [115.630868175426031, -31.556742032818534],
          [115.630888595432339, -31.55676808797682],
          [115.630908477644198, -31.556794447106029],
          [115.630927821162118, -31.556821100313471],
          [115.630934463554695, -31.556830622335326],
          [115.630947095432134, -31.556841476253055],
          [115.63097249318605, -31.556864079813408],
          [115.630997425990472, -31.556887061988277],
          [115.631021884852203, -31.556910414683841],
          [115.63104586437521, -31.556934131604862],
          [115.63106935556641, -31.556958204657349],
          [115.631092351231132, -31.556982628445496],
          [115.631102117868522, -31.556993271022577],
          [115.631205808801042, -31.557107145878035],
          [115.631218536006713, -31.557121267932132],
          [115.631240520833444, -31.557146366211782],
          [115.631261990348662, -31.557171791844667],
          [115.631282937357696, -31.557197536736908],
          [115.631303355565478, -31.557223591895195],
          [115.631323239575863, -31.557249950125026],
          [115.631342583093783, -31.557276604231845],
          [115.631361378924566, -31.557303545222396],
          [115.631379622571558, -31.557330765002746],
          [115.631397308638952, -31.557358254579754],
          [115.631414431730718, -31.557386006758747],
          [115.63143098555156, -31.557414013445907],
          [115.631444664239893, -31.557438196215742],
          [115.631597801697239, -31.557572645760956],
          [115.631656682110247, -31.557626502560993],
          [115.631713253064277, -31.557682779436675],
          [115.631767417432457, -31.557741376563229],
          [115.631873106658645, -31.557860784947252],
          [115.632001164722055, -31.557957175183446],
          [115.632085951005934, -31.558024612645738],
          [115.632166867506953, -31.558096647442255],
          [115.632243664213775, -31.558173059239266],
          [115.632253911988528, -31.558183860996337],
          [115.632261896169666, -31.55818797629405],
          [115.632292940766661, -31.558204621845789],
          [115.632323640024083, -31.558221729649063],
          [115.632353984049132, -31.558239295207272],
          [115.632383964748215, -31.558257314023763],
          [115.632413571329266, -31.558275778904033],
          [115.632442796597843, -31.558294685351427],
          [115.632471629761994, -31.558314027070651],
          [115.632500063627049, -31.558333798665842],
          [115.632528089200036, -31.558353994741026],
          [115.632555696588156, -31.558374607202325],
          [115.632582878597077, -31.558395631553083],
          [115.632609628032014, -31.55841705969948],
          [115.632635935000508, -31.55843888714486],
          [115.632661792307886, -31.558461105795345],
          [115.632687190961178, -31.558483709355642],
          [115.632712124664863, -31.558506692429887],
          [115.632736585325233, -31.558530043326812],
          [115.63276056484824, -31.558553760247776],
          [115.632784056039441, -31.558577833300319],
          [115.632807052603425, -31.558602255289827],
          [115.63282954734575, -31.558627019921005],
          [115.632851533071857, -31.558652118200655],
          [115.632856200553306, -31.558657566293618],
          [115.632933891186212, -31.558748610060263],
          [115.632950694119245, -31.558768587600184],
          [115.632971642027769, -31.558794331593106],
          [115.632992061134814, -31.558820386751393],
          [115.633011946044576, -31.558846745880601],
          [115.633031289562382, -31.558873399088043],
          [115.633050086292542, -31.558900340078594],
          [115.63306833083891, -31.558927558959624],
          [115.633086017805567, -31.558955049435951],
          [115.633103140897333, -31.558982801614945],
          [115.633119695617552, -31.559010807402785],
          [115.633135676570305, -31.559039057806217],
          [115.633138566092043, -31.559044403376447],
          [115.633148348917189, -31.559054079182374],
          [115.633171841007766, -31.559078151335598],
          [115.63319483757175, -31.559102574224369],
          [115.633217333213452, -31.559127337956227],
          [115.633239318939445, -31.559152437135197],
          [115.6332607875554, -31.559177861868761],
          [115.633272258408056, -31.559191837333401],
          [115.633401628582305, -31.559351091979295],
          [115.633411108336077, -31.559362861406896],
          [115.633431528342385, -31.559388916565183],
          [115.633451413252146, -31.559415274795072],
          [115.633470756770066, -31.559441928901833],
          [115.633477400961397, -31.559451450923689],
          [115.633490031040196, -31.559462303942155],
          [115.633515430592752, -31.559484908401771],
          [115.633540365195813, -31.559507888778001],
          [115.63356482585607, -31.559531240574245],
          [115.633588805379077, -31.559554956595946],
          [115.633612296570277, -31.559579031447072],
          [115.633635294933015, -31.55960345343658],
          [115.63365778967534, -31.559628217168438],
          [115.63367977630071, -31.559653315448088],
          [115.633701246715191, -31.559678741080972],
          [115.633722194623601, -31.559704485073894],
          [115.633742614630023, -31.559730540232181],
          [115.633750371282645, -31.559740702571332],
          [115.633853737560003, -31.559877127027733],
          [115.633865865817143, -31.559893322918469],
          [115.633885210234325, -31.559919976125968],
          [115.633904007863748, -31.559946917116463],
          [115.633922252410116, -31.55997413599755],
          [115.633939939376774, -31.5600016255745],
          [115.633957063367802, -31.560029377753551],
          [115.633973618088021, -31.560057384440711],
          [115.633987380413373, -31.560081712001363],
          [115.63400691638617, -31.560099097695172],
          [115.634031850089855, -31.560122078970721],
          [115.634056311649488, -31.560145431666285],
          [115.634080292071872, -31.560169147687986],
          [115.634103784162335, -31.560193220740473],
          [115.634126781625696, -31.560217642729981],
          [115.634149276368021, -31.560242405562519],
          [115.634171262993505, -31.560267504741489],
          [115.634192733407986, -31.560292930374374],
          [115.634213682215773, -31.560318674367295],
          [115.634234102222081, -31.560344730424902],
          [115.634253987131842, -31.56037108775547],
          [115.634273332448402, -31.560397740962912],
          [115.634292129178448, -31.560424681953464],
          [115.634310374624192, -31.560451900834494],
          [115.63432806159085, -31.560479390411501],
          [115.634332461074337, -31.560486411418708],
          [115.634615574848908, -31.56094049800555],
          [115.63466437835848, -31.561023922715833],
          [115.634708335421351, -31.56111000042614],
          [115.635049641627688, -31.561829033582967],
          [115.635167885389706, -31.561991663384504],
          [115.635285422284483, -31.562069122891671],
          [115.635369528680826, -31.562127315323323],
          [115.635450459571075, -31.562189849681772],
          [115.635527989225352, -31.562256553297232],
          [115.635601904504369, -31.562327240909383],
          [115.635672000362547, -31.562401718264653],
          [115.635738083445858, -31.562479779418254],
          [115.636100217051421, -31.562934707770523],
          [115.636158060546109, -31.563011409149169],
          [115.636211557617344, -31.563091201497684],
          [115.636260544588481, -31.563173841099854],
          [115.636304868574939, -31.563259070749496],
          [115.636554725420297, -31.563775951598871],
          [115.636743886121508, -31.56404965666627],
          [115.637035744903756, -31.564337944240663],
          [115.637096975245299, -31.564401284391693],
          [115.63715511551618, -31.56446747179632],
          [115.637210034415602, -31.564536357167128],
          [115.637468476189269, -31.564877411563259],
          [115.637528319776152, -31.564961207693557],
          [115.637583005751139, -31.565048458119804],
          [115.637632334464683, -31.565138844482021],
          [115.637676127851137, -31.56523203942703],
          [115.637685041031887, -31.565241850131258],
          [115.637707028556633, -31.565266948410908],
          [115.63772850166913, -31.565292372245153],
          [115.637749452275443, -31.565318116238018],
          [115.637769874080504, -31.565344171396362],
          [115.637789760788905, -31.565370528726874],
          [115.637809107004728, -31.565397181934372],
          [115.63782790643279, -31.565424122025547],
          [115.637846152777797, -31.565451340906634],
          [115.637863842442471, -31.565478829584265],
          [115.637880967332876, -31.565506581763316],
          [115.637897523851734, -31.565534587551156],
          [115.637905499039562, -31.565548526143516],
          [115.637956859321662, -31.565639284825068],
          [115.63796486778449, -31.565653596636139],
          [115.637980272271761, -31.565682083561285],
          [115.637995093998484, -31.56571079891421],
          [115.638009326669135, -31.565739732802399],
          [115.638022967585925, -31.565768877131916],
          [115.63803601405084, -31.565798222909621],
          [115.638036639978964, -31.565799708589623],
          [115.638045554958467, -31.565809522891129],
          [115.638067543382476, -31.56583462027146],
          [115.63808901559571, -31.565860045005024],
          [115.638109966202023, -31.565885788997946],
          [115.638130388906347, -31.565911843256913],
          [115.638150275614748, -31.565938200587425],
          [115.638169621830684, -31.565964854694244],
          [115.638188421258747, -31.565991794785475],
          [115.63820666940228, -31.566019013666505],
          [115.638224357268314, -31.566046502344136],
          [115.638241483058096, -31.566074255422507],
          [115.638258039576954, -31.566102259411707],
          [115.638266014764781, -31.566116198004067],
          [115.638394419966517, -31.566343098754942],
          [115.63844340783703, -31.566436054480278],
          [115.638486259633282, -31.566531994156151],
          [115.638522794591381, -31.56663051218834],
          [115.638552859826632, -31.56673119309005],
          [115.638576326736143, -31.566833613280608],
          [115.638584887382763, -31.566844960026856],
          [115.638604233598585, -31.566871612334978],
          [115.63862303392591, -31.56689855242621],
          [115.638641281170294, -31.56692577130724],
          [115.638658970834854, -31.566953260884247],
          [115.638676096624636, -31.566981012163922],
          [115.638692653143494, -31.567009017951762],
          [115.638708636794263, -31.567037268355193],
          [115.638724042180911, -31.567065755280339],
          [115.638738863008143, -31.567094469733945],
          [115.638753096578171, -31.567123403622134],
          [115.638766739293601, -31.567152547951707],
          [115.638779784859253, -31.567181893729355],
          [115.638792229677733, -31.567211431961994],
          [115.63880407105114, -31.567241154555575],
          [115.638815303583442, -31.567271050718375],
          [115.638825927274752, -31.567301112356404],
          [115.63883255617759, -31.567320899240087],
          [115.638958669906742, -31.567705646298521],
          [115.638981850831783, -31.567782887270369],
          [115.639001052256845, -31.567861212824653],
          [115.639016223819681, -31.567940417016587],
          [115.639068864736373, -31.568259763577203],
          [115.639118506413979, -31.568339748380652],
          [115.639163571441713, -31.568422397875338],
          [115.639203918625981, -31.568507451257801],
          [115.639239417565136, -31.568594637832234],
          [115.639264771252215, -31.568662568122988],
          [115.639269057421075, -31.568674182867198],
          [115.639279679313859, -31.568704245404547],
          [115.639289687868882, -31.568734462625287],
          [115.639299078589715, -31.56876482733486],
          [115.639307849677607, -31.568795331439333],
          [115.639315998434654, -31.568825961448908],
          [115.639323520364201, -31.568856711068292],
          [115.639330414566984, -31.568887571304344],
          [115.639336681043005, -31.568918531365114],
          [115.639342314396345, -31.568949583156666],
          [115.639347314626889, -31.568980715887278],
          [115.639351679936112, -31.569011920563639],
          [115.639355409424638, -31.569043187293232],
          [115.639356097405994, -31.569050145347887],
          [115.639531815041323, -31.569567488448797],
          [115.639558804595254, -31.56965513008015],
          [115.63980911020235, -31.570560029721548],
          [115.63982514691304, -31.570623018237654],
          [115.639838569294625, -31.570686615594809],
          [115.640009832587793, -31.571590570048727],
          [115.640020808813347, -31.571656103646205],
          [115.640028975556788, -31.571722047334561],
          [115.640085145413195, -31.572271908121991],
          [115.640086510584069, -31.572273719356645],
          [115.640105858598531, -31.572300372564087],
          [115.640124659825233, -31.572327312655318],
          [115.640142908868256, -31.572354532435668],
          [115.640160599432193, -31.572382020214036],
          [115.640177726121237, -31.57240977059439],
          [115.640194284438735, -31.57243777638223],
          [115.640210268988767, -31.572466026785662],
          [115.640225675274792, -31.572494513710808],
          [115.640240497900663, -31.572523229063734],
          [115.640254732370067, -31.572552162951922],
          [115.640260699371879, -31.572564728279531],
          [115.640388463356999, -31.572836726433707],
          [115.640429952680279, -31.572932747048583],
          [115.640465081997945, -31.573031273174649],
          [115.64049369842553, -31.57313188392925],
          [115.640515682352884, -31.573234149436416],
          [115.640561924593158, -31.573491372628723],
          [115.640573965616113, -31.573509331190621],
          [115.64059165618005, -31.573536819868309],
          [115.640608783768471, -31.573564571147983],
          [115.640625342085968, -31.573592576036503],
          [115.64064132843464, -31.573620826439935],
          [115.640656733821288, -31.573649313365081],
          [115.640671556447273, -31.573678027818687],
          [115.640683755750842, -31.573702736691928],
          [115.640760481411121, -31.573861425664234],
          [115.640762516576956, -31.573865650679181],
          [115.640776159292386, -31.573894795008755],
          [115.640789205757301, -31.573924140786403],
          [115.640801652374421, -31.573953679019041],
          [115.640813494647091, -31.573983400713303],
          [115.640824729877409, -31.574013296876103],
          [115.640835353568718, -31.574043359413452],
          [115.640845363023118, -31.574073576634191],
          [115.640854754643328, -31.574103941343765],
          [115.640863526630483, -31.574134443649598],
          [115.64087167538753, -31.574165074558493],
          [115.64087919911583, -31.574195825077197],
          [115.640884345935888, -31.574218861211421],
          [115.640895834775051, -31.574231972427526],
          [115.640917309686188, -31.574257397161091],
          [115.64093826209114, -31.574283140254693],
          [115.640958686594217, -31.57430919541298],
          [115.640978575101258, -31.574335551844172],
          [115.640997924015096, -31.574362205051671],
          [115.641016725241684, -31.574389144243582],
          [115.641034974284707, -31.574416363124612],
          [115.64105266574802, -31.5744438518023],
          [115.641069793336328, -31.574471603081975],
          [115.641086351653826, -31.574499608869814],
          [115.641094314251291, -31.574513524079805],
          [115.641248423875709, -31.574785801023836],
          [115.641288501263375, -31.574860891716753],
          [115.641324637821867, -31.574937956421536],
          [115.641356736424314, -31.575016788294079],
          [115.641384710735906, -31.575097175993847],
          [115.641393093316651, -31.57512352882776],
          [115.64171651020888, -31.57540737644922],
          [115.641779173170335, -31.575464825141523],
          [115.641839203816289, -31.57552501856469],
          [115.641896483435971, -31.575587837108969],
          [115.64223333889754, -31.575974821680632],
          [115.642290102306447, -31.576043249296447],
          [115.642343352064131, -31.576114444126233],
          [115.642392955070932, -31.576188227204852],
          [115.642438785421632, -31.576264410574026],
          [115.642448066425231, -31.576280807912894],
          [115.642464603158942, -31.576294052228661],
          [115.64249091642273, -31.576315877875402],
          [115.64251677912614, -31.576338094727248],
          [115.642542184973877, -31.576360697388225],
          [115.642567124073594, -31.576383677764454],
          [115.642591591029145, -31.576407028661379],
          [115.642615576847447, -31.57643074378376],
          [115.642639074333829, -31.576454815037664],
          [115.642662077193222, -31.576479236127796],
          [115.642671820448186, -31.576489849926588],
          [115.642775544655706, -31.576603715788792],
          [115.642788302438248, -31.576617865721857],
          [115.642810293560274, -31.576642963102245],
          [115.642831769370673, -31.57666838693649],
          [115.642852722675116, -31.576694130030035],
          [115.642873148077342, -31.576720184289002],
          [115.642893036584383, -31.576746541619571],
          [115.64291238729686, -31.576773193927693],
          [115.642931189422939, -31.576800134018924],
          [115.642949439365225, -31.576827352000635],
          [115.642967131727801, -31.576854840678322],
          [115.642984259316222, -31.576882591957997],
          [115.643000819432359, -31.576910596846517],
          [115.643016804881654, -31.576938847249949],
          [115.643019673718982, -31.576944150552038],
          [115.643029497013686, -31.576953863230187],
          [115.643052995399444, -31.576977935383354],
          [115.643075998258723, -31.577002355574223],
          [115.643098499296343, -31.577027119306081],
          [115.643120490418369, -31.577052215787091],
          [115.643141966228768, -31.577077641419976],
          [115.643162920432474, -31.577103382714881],
          [115.643183345834814, -31.577129436973905],
          [115.643203236140494, -31.577155794304417],
          [115.643222585054332, -31.577182446612596],
          [115.643241388079673, -31.577209386703771],
          [115.643259638021959, -31.577236604685538],
          [115.643277328585896, -31.577264093363169],
          [115.643294457972956, -31.5772918446429],
          [115.643311018089094, -31.577319850430683],
          [115.643318975290526, -31.577333753949517],
          [115.64344741016987, -31.577560651103113],
          [115.643488347309471, -31.577637502668551],
          [115.643525187137698, -31.577716401090981],
          [115.643557828031362, -31.57779712693582],
          [115.643664582054839, -31.57808307357493],
          [115.643682576589754, -31.57811486460929],
          [115.643753602346919, -31.578192832233356],
          [115.643814681602294, -31.578263212277363],
          [115.643871954926794, -31.578336722861422],
          [115.643925262241169, -31.578413158940066],
          [115.643974453358396, -31.578492306474743],
          [115.644019391581764, -31.578573944232119],
          [115.644147502705096, -31.578823389188017],
          [115.644188725829054, -31.578909451609832],
          [115.644224768858066, -31.578997808202246],
          [115.644255505886917, -31.579088147799723],
          [115.644280828097749, -31.579180152042341],
          [115.644300647356999, -31.579273497174086],
          [115.644316395385431, -31.57936106596037],
          [115.644384667418535, -31.579517051570633],
          [115.644582691837854, -31.579866871658737],
          [115.644599237564876, -31.579880123169119],
          [115.64462555262719, -31.579901947916539],
          [115.644651417129239, -31.579924164768329],
          [115.644676823876353, -31.579946767429306],
          [115.644701764774709, -31.579969746906272],
          [115.644726232629637, -31.579993097803197],
          [115.644750219347202, -31.580016812026201],
          [115.644773718632223, -31.580040883280105],
          [115.644796722390879, -31.580065304370237],
          [115.644819224327762, -31.580090067202775],
          [115.644841216349164, -31.580115164583162],
          [115.644862693958203, -31.580140588417351],
          [115.644883648161908, -31.580166330611632],
          [115.644904073564248, -31.5801923848706],
          [115.644923965668568, -31.580218742201168],
          [115.644943316381045, -31.58024539540861],
          [115.644962120305649, -31.580272333701203],
          [115.644964049351415, -31.58027515937107],
          [115.645041441409489, -31.580388746443475],
          [115.645057761406633, -31.580413137855999],
          [115.645075454668586, -31.580440627432949],
          [115.645092584055533, -31.580468376914041],
          [115.645109145071046, -31.580496381802561],
          [115.645125131419718, -31.580524632205993],
          [115.645140540403645, -31.580553118231762],
          [115.64515536482827, -31.580581832685368],
          [115.645169601995576, -31.580610765674237],
          [115.645183247409022, -31.580639910003811],
          [115.645196295672577, -31.580669254882139],
          [115.645208744088336, -31.580698793114777],
          [115.645220589059022, -31.580728514809095],
          [115.645231825188603, -31.580758410072519],
          [115.645242450678666, -31.580788471710548],
          [115.645252461931591, -31.580818688931288],
          [115.645261855350441, -31.580849053640861],
          [115.645270629136235, -31.580879555946694],
          [115.645278779692035, -31.58091018685559],
          [115.645286304319598, -31.580940935575654],
          [115.645291110296512, -31.580962441063775],
          [115.645502856571625, -31.581273217984574],
          [115.645557037127674, -31.581357890953882],
          [115.645606161695014, -31.58144559373909],
          [115.645759968247944, -31.581740415787522],
          [115.645770589241351, -31.581761123576939],
          [115.645784826408658, -31.581790056565808],
          [115.645798471822104, -31.581819200895382],
          [115.645811520984921, -31.58184854577371],
          [115.645823969400681, -31.581878084006348],
          [115.645835814371367, -31.58190780570061],
          [115.645847051400324, -31.58193770096409],
          [115.645857676890387, -31.581967762602119],
          [115.645867688143312, -31.581997979822859],
          [115.645877081562162, -31.582028345431752],
          [115.645885855347956, -31.582058846838265],
          [115.645894005903756, -31.582089477747161],
          [115.645901531430582, -31.582120227366545],
          [115.645908429230644, -31.58215108670322],
          [115.645909158580821, -31.58215469118602],
          [115.646003366162518, -31.582328822417196],
          [115.64654181904973, -31.583192033985142],
          [115.646593369088805, -31.583280450832092],
          [115.64663946923622, -31.583371827347889],
          [115.646946118268829, -31.584029119348315],
          [115.646986611143234, -31.584123241494353],
          [115.647020958050803, -31.584219776521422],
          [115.647049014200661, -31.5843183233319],
          [115.647070664479656, -31.584418473633605],
          [115.647085818955475, -31.584519810141103],
          [115.647101050772903, -31.584652047354041],
          [115.647197596591923, -31.584846365667204],
          [115.647635438724592, -31.585462892298608],
          [115.647684929316142, -31.585536445150751],
          [115.647730590594392, -31.585612434266409],
          [115.647961812587596, -31.586020839789853],
          [115.648010961436739, -31.586114084197561],
          [115.648053935540702, -31.586210329642938],
          [115.648090555035196, -31.586309167833804],
          [115.648120662538645, -31.586410179686027],
          [115.648144131246681, -31.586512938021656],
          [115.648157443011655, -31.586542478952197],
          [115.648167199756472, -31.586564563603702],
          [115.648179649970984, -31.586594100936964],
          [115.648191495840933, -31.586623821731962],
          [115.648202733769153, -31.586653717894706],
          [115.648213360158479, -31.586683778633414],
          [115.648223372310895, -31.586713996753531],
          [115.648232768427533, -31.586744360563728],
          [115.648241542213441, -31.586774862869561],
          [115.648249693668504, -31.586805493778456],
          [115.648257220094706, -31.586836243397897],
          [115.648264117894769, -31.586867102734573],
          [115.648270387068806, -31.586898062795342],
          [115.648276023120047, -31.586929113687574],
          [115.648279773292984, -31.586952449296064],
          [115.648476401964444, -31.587299746785845],
          [115.648495819226696, -31.587317018265765],
          [115.648520762822955, -31.587339997742674],
          [115.648545233375899, -31.587363347740279],
          [115.64856922279148, -31.587387061963284],
          [115.64859272387514, -31.587411133217188],
          [115.648615730331699, -31.587435553408],
          [115.648638234067334, -31.587460315341218],
          [115.648660229685902, -31.587485411822229],
          [115.648681709093694, -31.587510835656474],
          [115.648702665995302, -31.587536577850756],
          [115.648723094095544, -31.587562631210403],
          [115.648742987998503, -31.587588987641595],
          [115.648762341408997, -31.587615639949775],
          [115.648781146232977, -31.587642578242367],
          [115.648799398873166, -31.587669796224077],
          [115.648805118561427, -31.587678558318771],
          [115.648908213243544, -31.587837521584333],
          [115.648957310831292, -31.587917917377922],
          [115.649001836265825, -31.588000931997385],
          [115.649041649252808, -31.588086307337164],
          [115.649050610097675, -31.588096166604771],
          [115.649072605716242, -31.588121263085782],
          [115.649094085124034, -31.588146686920027],
          [115.649115042025642, -31.588172429114252],
          [115.649135471025261, -31.588198481574636],
          [115.64915536492822, -31.588224838905148],
          [115.649174717439337, -31.588251491213327],
          [115.64919352316258, -31.588278430405182],
          [115.649211776702145, -31.588305646588253],
          [115.649217498189046, -31.588314411380964],
          [115.649320593770426, -31.588473376445108],
          [115.649369692257551, -31.588553770440114],
          [115.649414217692083, -31.588636785059521],
          [115.649454030679067, -31.588722160399357],
          [115.649462990624556, -31.588732019666907],
          [115.649484986243237, -31.588757116147974],
          [115.649506465650916, -31.588782539082843],
          [115.649527422552524, -31.588808281277124],
          [115.649529204109513, -31.588810513394435],
          [115.649710353649994, -31.589037960033806],
          [115.649768898615889, -31.589115702827371],
          [115.649823077373185, -31.589196549181338],
          [115.650080730441459, -31.589605344111305],
          [115.650132090723446, -31.589692373304331],
          [115.650178109931858, -31.58978234148185],
          [115.650218618994131, -31.589874921290516],
          [115.650345784930096, -31.590192009653492],
          [115.650352910258675, -31.590210086925936],
          [115.650364149086272, -31.59023998218936],
          [115.650374776374861, -31.590270043827445],
          [115.650384790325916, -31.590300261048185],
          [115.650385423448597, -31.5903023070058],
          [115.650394630707751, -31.590317874270454],
          [115.650402576217971, -31.590331754406918],
          [115.6504539625804, -31.590422508591871],
          [115.650462007016017, -31.590436878858839],
          [115.65047741869796, -31.590465364884665],
          [115.650492245820601, -31.590494079338271],
          [115.65050648568581, -31.590523012327139],
          [115.650520133797158, -31.590552155757337],
          [115.650533184758729, -31.590581500635722],
          [115.650545634973128, -31.590611037968984],
          [115.650557481742453, -31.590640758763982],
          [115.65056872057005, -31.590670654926726],
          [115.650579348758015, -31.590700715665434],
          [115.650589361809693, -31.590730932886174],
          [115.650598757926446, -31.590761297595748],
          [115.650607534410256, -31.590791799002261],
          [115.650615685865318, -31.590822429911157],
          [115.650623213190784, -31.590853180429917],
          [115.650630112789486, -31.590884038867273],
          [115.650636381963523, -31.590914998928042],
          [115.650641465831086, -31.590943000219227],
          [115.650649450012224, -31.590951177754619],
          [115.650672457368046, -31.59097559794543],
          [115.650694962902321, -31.591000359878649],
          [115.650716959420151, -31.59102545635966],
          [115.65073843972732, -31.591050879294585],
          [115.650759398427567, -31.591076620589547],
          [115.650779827427186, -31.591102673949194],
          [115.650799722229408, -31.591129030380387],
          [115.650819075639902, -31.591155682688566],
          [115.650837882262522, -31.591182620981101],
          [115.650856136701464, -31.591209838063548],
          [115.650873832661318, -31.591237326741179],
          [115.650890965645658, -31.591265077121591],
          [115.650907529359074, -31.591293081110734],
          [115.650923519305024, -31.591321330614846],
          [115.650938930087591, -31.591349815741353],
          [115.650953758109495, -31.591378530194959],
          [115.650967997974817, -31.591407463183828],
          [115.650981646086166, -31.591436606614081],
          [115.650984931309608, -31.59144384885451],
          [115.651035994815402, -31.591557154439101],
          [115.651045760553416, -31.591579256177681],
          [115.651058212566568, -31.591608794410263],
          [115.65107005933578, -31.591638515205261],
          [115.65108129816349, -31.591668409569422],
          [115.651091926351341, -31.591698471207451],
          [115.651101940302397, -31.591728688428191],
          [115.651102573425078, -31.591730731687846],
          [115.651111781583495, -31.591746303449099],
          [115.651127772428822, -31.591774552053892],
          [115.651143184110765, -31.591803038079718],
          [115.651158012132669, -31.591831751634004],
          [115.651172251997878, -31.591860684622873],
          [115.651185479226569, -31.591888928731009],
          [115.65125524413429, -31.591960362780469],
          [115.651318284811055, -31.592028020576663],
          [115.651377746186085, -31.592098843986435],
          [115.651433469079393, -31.592172645051505],
          [115.651485305102824, -31.592249225921023],
          [115.651533115760799, -31.592328383348161],
          [115.651635892982085, -31.592509894416025],
          [115.651643933820537, -31.592524256589115],
          [115.651659346401743, -31.592552744413581],
          [115.651674174423647, -31.592581457068547],
          [115.651688414288969, -31.592610390057416],
          [115.651702062400318, -31.592639532588294],
          [115.651715114261151, -31.592668878365998],
          [115.651727565374927, -31.59269841569926],
          [115.651739413043515, -31.592728137393578],
          [115.651750651871112, -31.592758032657059],
          [115.651761280059077, -31.592788093395768],
          [115.651771294010018, -31.592818310616508],
          [115.651774293249105, -31.59282800261019],
          [115.651776430937616, -31.592830833675976],
          [115.651795785247373, -31.592857485984155],
          [115.651814592769256, -31.59288442427669],
          [115.651832847208198, -31.592911641359137],
          [115.651850544067429, -31.592939130036768],
          [115.651867677051769, -31.59296688041718],
          [115.651884240765185, -31.592994884406323],
          [115.651900231610512, -31.593023133011116],
          [115.651913420168285, -31.59304742909552],
          [115.652118656250991, -31.59343299903361],
          [115.652155489784036, -31.593506420584788],
          [115.652188583936095, -31.593581602109225],
          [115.652217854170658, -31.593658353849889],
          [115.652243225844245, -31.593736479754682],
          [115.652410194874619, -31.594300235967069],
          [115.652616146817763, -31.594741571066606],
          [115.652963961417754, -31.595277788239287],
          [115.653008932016633, -31.595351051509795],
          [115.653050155140591, -31.59542648844166],
          [115.65330646731968, -31.595925361266382],
          [115.653342620965191, -31.596000197451133],
          [115.653374901230791, -31.596076783716569],
          [115.653403223579971, -31.596154921312518],
          [115.653427514268401, -31.59623440429425],
          [115.653434115292271, -31.596258248019694],
          [115.653445632010403, -31.596272933948683],
          [115.653465528611264, -31.596299290379875],
          [115.653484883820397, -31.596325941788734],
          [115.653503691342394, -31.596352880081326],
          [115.653521947579861, -31.596380097163717],
          [115.653539645338469, -31.596407584942028],
          [115.653556779222072, -31.59643533532244],
          [115.653573343834864, -31.59646333841232],
          [115.653589335579454, -31.596491587916432],
          [115.65360474816066, -31.596520073042882],
          [115.653619577081827, -31.596548786597168],
          [115.653633818745789, -31.596577719586037],
          [115.653647467756514, -31.596606863016291],
          [115.653660521415986, -31.596636207894619],
          [115.653672973429025, -31.596665745227938],
          [115.653684821097727, -31.596695466022879],
          [115.653691738682824, -31.596713652113294],
          [115.65371711215505, -31.59678157790745],
          [115.653735150756688, -31.596832466045441],
          [115.653751416794535, -31.596883948635252],
          [115.653751721664662, -31.596884785004761],
          [115.65376200990886, -31.596907914668463],
          [115.653774461921898, -31.596937452001782],
          [115.6537863095906, -31.596967172796724],
          [115.653797550216836, -31.596997068060205],
          [115.653808179304065, -31.597027128798914],
          [115.653818194154383, -31.597057346019653],
          [115.653819129449289, -31.597060269715655],
          [115.653869549939827, -31.597218673602868],
          [115.653878012560313, -31.5972461128178],
          [115.653886789943499, -31.597276615123633],
          [115.653894944096464, -31.597307245133209],
          [115.653902472321306, -31.597337994752593],
          [115.653909372819385, -31.597368854089325],
          [115.653915643791947, -31.597399814150037],
          [115.653921281641942, -31.597430865042327],
          [115.653926287268405, -31.597461997772939],
          [115.65393065707417, -31.5974932024493],
          [115.653934391059352, -31.597524469178893],
          [115.653936424426547, -31.59754504027137],
          [115.6539814498841, -31.59762421208768],
          [115.654022049777836, -31.597705742825724],
          [115.654058100001407, -31.59778938517195],
          [115.65408949083735, -31.597874884618193],
          [115.654165285699492, -31.598101214299561],
          [115.654171791395129, -31.598121070431034],
          [115.654181188411144, -31.598151435140551],
          [115.65418996579433, -31.598181937446384],
          [115.654198119947296, -31.59821256655664],
          [115.654205648172137, -31.598243317075401],
          [115.654212548670216, -31.598274176412076],
          [115.654218819642892, -31.598305135573526],
          [115.65422445839215, -31.598336185566438],
          [115.654229463119236, -31.59836731919637],
          [115.654233833824378, -31.598398523872731],
          [115.65423756780956, -31.598429790602324],
          [115.654240663276028, -31.598461110391895],
          [115.654243121123159, -31.598492474248246],
          [115.654244939552427, -31.598523871379541],
          [115.654245516017795, -31.598539232699409],
          [115.654251872426016, -31.598552802569714],
          [115.654264925186226, -31.598582148347418],
          [115.654277378098527, -31.59861168568068],
          [115.654289226666492, -31.598641405576359],
          [115.654300467292842, -31.598671301739159],
          [115.65431109638007, -31.598701361578549],
          [115.654321111230388, -31.598731579698608],
          [115.654330265429508, -31.598761125125804],
          [115.6544828110829, -31.599271],
          [115.65450625555934, -31.599349361783595],
          [115.654529324968394, -31.599435147214251],
          [115.654765889834039, -31.600425055272012],
          [115.654976521849107, -31.601106451801286],
          [115.65510054735239, -31.601392912852589],
          [115.655199615769675, -31.601512567650843],
          [115.655566879108278, -31.601776268659819],
          [115.655650252557166, -31.60183935340342],
          [115.655730129441963, -31.601906810650746],
          [115.65580628133489, -31.601978446148337],
          [115.655878489700626, -31.602054054850726],
          [115.656371311886573, -31.602600516200823],
          [115.656444354823179, -31.602686631682673],
          [115.656511803976628, -31.602777194312011],
          [115.656573390449694, -31.602871842561456],
          [115.656952147124002, -31.603498062085862],
          [115.656963773559369, -31.603514427948426],
          [115.656984590166758, -31.603532301074779],
          [115.657010005007805, -31.603554901037796],
          [115.657034953999982, -31.603577879615386],
          [115.657059429049468, -31.603601228713671],
          [115.657083423860968, -31.603624941138094],
          [115.657106931239923, -31.603649010593301],
          [115.657129943092514, -31.60367342988485],
          [115.657152452223954, -31.603698191818069],
          [115.657174452339177, -31.60372328739976],
          [115.657195937142887, -31.603748709435365],
          [115.657216899440414, -31.60377445073027],
          [115.657237332936575, -31.603800503190598],
          [115.657257231336189, -31.603826858722528],
          [115.657276588343962, -31.60385350923201],
          [115.657295398563861, -31.603880448423922],
          [115.657313656600081, -31.603907664606993],
          [115.657319357402457, -31.60391639432612],
          [115.657422482661559, -31.604075351296387],
          [115.657471596437063, -31.604155742593377],
          [115.65751613626071, -31.604238755414201],
          [115.657555963636923, -31.604324128955341],
          [115.657564953260021, -31.604334017900555],
          [115.657586953375244, -31.604359112582927],
          [115.657608438178954, -31.604384536417172],
          [115.657629399577218, -31.604410276812757],
          [115.657649833972755, -31.604436329273142],
          [115.657669732372369, -31.604462684805014],
          [115.657689090279405, -31.604489335314554],
          [115.657707901398567, -31.604516273607089],
          [115.657726159434787, -31.60454348979016],
          [115.657743858991921, -31.604570977568528],
          [115.65776099557354, -31.604598727049563],
          [115.65776371872073, -31.604603247941498],
          [115.657995349006228, -31.604989087676188],
          [115.658029666236189, -31.605048962739374],
          [115.658061510330526, -31.605110187684943],
          [115.658367667433936, -31.605729695568925],
          [115.658588510351478, -31.606053654752316],
          [115.658876159407328, -31.606337548239196],
          [115.658941104848168, -31.606404893970648],
          [115.659002590597083, -31.606475413409555],
          [115.659117739791895, -31.606614471980265],
          [115.659156298224616, -31.606647331409192],
          [115.659234372868127, -31.606715810286346],
          [115.659256994414818, -31.606735963194126],
          [115.659281943406995, -31.606758940872396],
          [115.65930642025512, -31.606782289970681],
          [115.659330416865259, -31.606806002395047],
          [115.65934591758014, -31.606821873630508],
          [115.659486639896613, -31.606924765965118],
          [115.659488490701392, -31.606926120344156],
          [115.659516116075906, -31.606946728308799],
          [115.659543316071222, -31.606967748163015],
          [115.659570082593291, -31.606989172712133],
          [115.659596406648916, -31.607010995660858],
          [115.659622281043539, -31.607033210714064],
          [115.65964769678385, -31.607055810677082],
          [115.659672647574666, -31.607078786556713],
          [115.659697124422792, -31.607102136554317],
          [115.659706438701278, -31.607111340216136],
          [115.659722622900745, -31.60712001057999],
          [115.659753341043938, -31.607137112987346],
          [115.659783703954872, -31.6071546740489],
          [115.659813702640349, -31.607172686570209],
          [115.659843328107172, -31.607191147853143],
          [115.659872571362143, -31.607210049803939],
          [115.659901423412066, -31.607229387026564],
          [115.659923994596738, -31.607245010948475],
          [115.660054445756145, -31.607336593409002],
          [115.660060326423036, -31.607340736585684],
          [115.660088369083041, -31.607360928164269],
          [115.660115995356932, -31.607381536128969],
          [115.660143195352248, -31.607402555983128],
          [115.660169961874317, -31.607423981431566],
          [115.660196286829205, -31.607445802581708],
          [115.660222160324452, -31.607468017634858],
          [115.660247576964139, -31.607490617597875],
          [115.660272527755069, -31.607513595276146],
          [115.660297004603194, -31.607536942575791],
          [115.660321001213333, -31.607560655899533],
          [115.660344510390928, -31.607584725354741],
          [115.66036108669482, -31.60760231429532],
          [115.660369516939681, -31.607606656222174],
          [115.660400580422561, -31.607623296377994],
          [115.660431298565641, -31.60764039878535],
          [115.660461660577198, -31.607657959846904],
          [115.660491661061315, -31.607675973267533],
          [115.660521287427514, -31.607694433651147],
          [115.660550529783222, -31.607713334702566],
          [115.660579381833031, -31.607732671925248],
          [115.660607834583971, -31.607752439023784],
          [115.660635878143353, -31.607772629703049],
          [115.660663504417244, -31.60779323766775],
          [115.660690704412559, -31.607814258421229],
          [115.660717471833891, -31.607835682071027],
          [115.660743795889516, -31.607857505019808],
          [115.660769670284139, -31.607879719173638],
          [115.660772454585185, -31.607882157235736],
          [115.660876558306541, -31.607973460906464],
          [115.660899189745919, -31.607993621908065],
          [115.660924141435999, -31.608016599586335],
          [115.660948618284124, -31.608039947785301],
          [115.660972615793639, -31.608063660209723],
          [115.660996124071971, -31.608087729664931],
          [115.661019137723088, -31.60811214805716],
          [115.661041648653168, -31.608136909091058],
          [115.66106365056703, -31.60816200377343],
          [115.66108513716938, -31.608187425809035],
          [115.661106101265659, -31.608213166204621],
          [115.661126536560459, -31.608239218664949],
          [115.661146436758713, -31.608265573297501],
          [115.661165795565125, -31.608292223807041],
          [115.66117237770311, -31.608301648702081],
          [115.661185116599881, -31.608312586256829],
          [115.661210535038208, -31.608335186219847],
          [115.661235485829025, -31.608358162998798],
          [115.661259963576526, -31.608381512097083],
          [115.661283960186665, -31.608405225420768],
          [115.66130746936426, -31.608429293976712],
          [115.66133048301549, -31.608453712368885],
          [115.661340162418583, -31.608464249725273],
          [115.661443945981432, -31.608578102097681],
          [115.661456778407683, -31.608592325775192],
          [115.661478780321545, -31.608617419558243],
          [115.661500266923895, -31.608642841593849],
          [115.66152123102006, -31.608668582888754],
          [115.661541666314861, -31.608694635349082],
          [115.661561567412491, -31.608720989981634],
          [115.66158092621879, -31.608747639591854],
          [115.661599738237442, -31.60877457788439],
          [115.661617998072188, -31.608801794067517],
          [115.661635699428075, -31.608829280946509],
          [115.661652837808333, -31.608857030427544],
          [115.661669406917667, -31.608885034416744],
          [115.661685402259536, -31.608913282122217],
          [115.661700818438135, -31.608941767248723],
          [115.66171565095658, -31.608970479903689],
          [115.661729896217821, -31.608999411993238],
          [115.661733711141892, -31.609007553555728],
          [115.661752862204935, -31.609029974553664],
          [115.662332462673021, -31.609623216837917],
          [115.66237523353027, -31.609668468025347],
          [115.662416468345441, -31.609715122155137],
          [115.662727500673668, -31.610079231571262],
          [115.662744382747178, -31.610099284654211],
          [115.662765346843344, -31.610125025049797],
          [115.662785783037521, -31.610151076610862],
          [115.662805684135037, -31.610177431243415],
          [115.662825043840712, -31.610204081752954],
          [115.662843856758627, -31.61023101914617],
          [115.662862116593487, -31.610258235329241],
          [115.6628798197479, -31.610285722208289],
          [115.662888637866814, -31.6103],
          [115.663662800098223, -31.611087830239114],
          [115.663721701195641, -31.611151670413221],
          [115.664162559654415, -31.611652453397937],
          [115.664221217035561, -31.611722446733495],
          [115.664276185397739, -31.611795373657515],
          [115.664327318151322, -31.611871039017217],
          [115.66437447859937, -31.611949242263677],
          [115.687197807133202, -31.651408540271859],
          [115.687237271183221, -31.651482743333872],
          [115.705656421806452, -31.688400573427657],
          [115.705703446456937, -31.688496281078471],
          [115.70574411649784, -31.688594857566557],
          [115.720999528605375, -31.730626890218787],
          [115.726443681630712, -31.745781252702614],
          [115.726454343093565, -31.745811308944724],
          [115.72646438942013, -31.745841521668865],
          [115.72646523208482, -31.745844152185839],
          [115.726566463371682, -31.746160903303007],
          [115.726594107631968, -31.74625769733484],
          [115.752411758595827, -31.839347365888159],
          [115.752419954117613, -31.839377992300456],
          [115.752427522812013, -31.839408737423241],
          [115.752434461081521, -31.839439593162638],
          [115.752440768926363, -31.839470549626128],
          [115.752446443648523, -31.839501597820458],
          [115.753700291934933, -31.846630762899338],
          [115.753711779874834, -31.84671533964115],
          [115.753782238159829, -31.847370057781916],
          [115.753789397662672, -31.847462757200447],
          [115.757686616943829, -31.903189995122148],
          [115.757691373458215, -31.903266968995354],
          [115.757692270082316, -31.903344084062212],
          [115.75767833688576, -31.904381375599939],
          [115.757676246861365, -31.904443512458101],
          [115.757477393267095, -31.908246945939766],
          [115.755000000249879, -31.908333330318897],
          [115.25500000034981, -31.908333331218216],
          [115.200658935711957, -31.908255243436916],
          [115.20066343702625, -31.908637855151621],
          [115.608357356358141, -31.909335363995645],
          [115.607050514991343, -32.094906838080284],
          [115.699680790975023, -32.094402727734796],
          [115.76672136719742, -32.213333010809777],
          [115.745634160088457, -32.345846426271521],
          [115.74522743719649, -32.348368074926668],
          [115.745213902399769, -32.348440907421889],
          [115.744759012718305, -32.3506012642369],
          [115.744734660875906, -32.350700699577601],
          [115.744231604405059, -32.352499755559222],
          [115.744200239649444, -32.352599229570728],
          [115.743591805117717, -32.354329688864027],
          [115.743572701718904, -32.354381202930142],
          [115.743551868923646, -32.354432040706058],
          [115.742838123780416, -32.356093688372994],
          [115.742800380133531, -32.356175351311379],
          [115.742144420928298, -32.357499311643892],
          [115.742110896001122, -32.35756346837934],
          [115.742074670409806, -32.357626139434728],
          [115.741476506135882, -32.35861240883554],
          [115.74142445967118, -32.358693117593248],
          [115.741071929026361, -32.359208269046349],
          [115.741064289285532, -32.359219342398717],
          [115.740738944246914, -32.359689661748462],
          [115.740719813868395, -32.359716627920022],
          [115.740718129438164, -32.359718952667492],
          [115.740555611152558, -32.359942837991525],
          [115.740537616617758, -32.359967193431203],
          [115.740131632069279, -32.360504357590003],
          [115.740119549677502, -32.36052024231526],
          [115.739930149756674, -32.360766409242331],
          [115.739414620588377, -32.36140700173172],
          [115.73939332913892, -32.361432773603553],
          [115.73937151338464, -32.361458228914103],
          [115.739349179621058, -32.361483356871361],
          [115.739348765932846, -32.361483813726977],
          [115.739024968627518, -32.36184138956844],
          [115.738053571315277, -32.362914100905016],
          [115.737972619740617, -32.363003494415693],
          [115.737730167913014, -32.3632712261861],
          [115.737707322435085, -32.363296019595566],
          [115.737688320659572, -32.36331598634365],
          [115.737580490147593, -32.363427660558045],
          [115.737252644094269, -32.363767171717541],
          [115.737228797670923, -32.363791276246332],
          [115.737204462915656, -32.363815026442296],
          [115.737179645224501, -32.363838412412747],
          [115.737165315426978, -32.363851548809862],
          [115.736600205734931, -32.364364555379893],
          [115.736532457107273, -32.364423321579011],
          [115.735403474290933, -32.365359137214341],
          [115.73533266976699, -32.365415217138491],
          [115.734715036070156, -32.365882589409921],
          [115.734709318180535, -32.36588689986047],
          [115.734681343868942, -32.365907550093311],
          [115.734652952271972, -32.365927783040718],
          [115.734624150584182, -32.365947593306714],
          [115.734594949597295, -32.365966974596176],
          [115.734565358304735, -32.365985920613696],
          [115.734535383900948, -32.366004426862787],
          [115.733641860683406, -32.366542351848011],
          [115.733554371936748, -32.366592136517852],
          [115.733464664562689, -32.36663780319202],
          [115.732822646647833, -32.36694706205725],
          [115.732729916652374, -32.366989179107293],
          [115.732635423086322, -32.367027176363081],
          [115.724594937206689, -32.370238604128247],
          [115.71333330009179, -32.370333330618678],
          [115.017478733656731, -32.370946949741892],
          [114.842671587453481, -32.227326604199362],
          [114.842671587453481, -32.09906672340022],
          [115.315366680132854, -32.096494233099918],
          [114.842829390351298, -32.098919574193751],
          [114.8434328685248, -32.010811760861898],
          [112.827221640264383, -31.998131187099258],
          [112.827682214696182, -32.011430273817496],
          [112.800751078215072, -31.997964705576941],
          [112.814216646455634, -35.458615743401197],
          [115.969295342778366, -35.458615743401197],
          [116.374686363684759, -34.934266068724071],
          [116.655104142677928, -34.965750854568959],
          [116.826344042686912, -34.9665222054699],
          [116.824797104543634, -34.990306379422925],
        ],
        [
          [115.057657799259474, -31.908049751668521],
          [115.057657799259474, -31.908393191956126],
          [115.165240425629534, -31.908577251197134],
          [115.165240425629534, -31.908204347252095],
          [115.057657799259474, -31.908049751668521],
        ],
      ],
    },
  },
  WESTERNAUSTRALIA: {
    type: 'Feature',
    properties: {},
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [97, -10],
          [129, -10],
          [129, -36],
          [97, -36],
          [97, -10],
        ],
      ],
    },
  },
  QUEENSLAND: {
    type: 'Feature',
    properties: {},
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [138, -9],
          [155, -9],
          [155, -29],
          [138, -29],
          [138, -9],
        ],
      ],
    },
  },
  UNITEDSTATES: {
    type: 'Feature',
    properties: {},
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-117, 28],
          [-78.72, 23.8],
          [-57, 45.14],
          [-75.2, 49.88],
          [-126.9, 49.48],
          [-126.9, 39.96],
          [-117, 28],
        ],
      ],
    },
  },
  ALASKA: {
    type: 'Feature',
    properties: {},
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-190.24, 51.08],
          [-134.42, 51.6],
          [-127.19, 56.67],
          [-140.13, 61.49],
          [-140.13, 71.13],
          [-167.71, 72.51],
          [-167.71, 66.6],
          [-190.24, 51.08],
        ],
      ],
    },
  },
  HAWAII: {
    type: 'Feature',
    properties: {},
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-167.53, 14.01],
          [-145.37, 14.01],
          [-145.37, 26.77],
          [-167.53, 26.77],
          [-167.53, 14.01],
        ],
      ],
    },
  },
};

export default COUNTRY_AND_STATE_BOUNDS;
